export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  ISO8601Date: { input: any; output: any };
  ISO8601DateTime: { input: string; output: string };
  JSON: { input: any; output: any };
  SanitizedString: { input: any; output: any };
  UUID: { input: string; output: string };
};

/** An account on Metafy */
export type Api_Account = WithTimestamps & {
  __typename?: 'API_Account';
  achievements: Array<Api_CoachAchievement>;
  activeSessions: Array<Api_ActiveSession>;
  afkEndDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Connected apple account of the user */
  apple: Maybe<Api_Apple>;
  availability: Maybe<Api_AccountAvailability>;
  avatar: Api_Image;
  billingInfo: Maybe<Api_BillingInfo>;
  bio: Maybe<Scalars['String']['output']>;
  blockLayout: Maybe<Api_BlockLayout>;
  bookingNotice: Maybe<Api_AccountBookingNotice>;
  chatRoomCount: Maybe<Scalars['Int']['output']>;
  communities: Api_AccountCommunityConnection;
  communityCount: Maybe<Scalars['Int']['output']>;
  connectedAccountsCount: Scalars['Int']['output'];
  country: Maybe<Scalars['String']['output']>;
  /** Coupons this account has created */
  coupons: Api_CouponConnection;
  cover: Maybe<Api_Image>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentLevel: Scalars['Int']['output'];
  currentLevelXp: Scalars['Int']['output'];
  currentLevelXpRequired: Scalars['Int']['output'];
  dailyLimitMinutes: Maybe<Api_AccountDailyLimits>;
  /** Connected discord account of the user */
  discord: Maybe<Api_Discord>;
  discordGuilds: Array<Api_DiscordGuild>;
  earningThreshold: Maybe<EarningThresholdEnum>;
  email: Maybe<Scalars['String']['output']>;
  /** Connected facebook account of the user */
  facebook: Maybe<Api_Facebook>;
  faqCover: Maybe<Api_Image>;
  faqs: Array<Api_AccountFaq>;
  featuredProductCoaching: Maybe<Api_ProductCoaching>;
  featuredProductCoachings: Api_ProductCoachingConnection;
  featuredProductEventRecording: Maybe<Api_ProductEvent>;
  featuredProductGuide: Maybe<Api_ProductGuide>;
  featuredProductGuides: Api_ProductGuideConnection;
  features: Maybe<Scalars['JSON']['output']>;
  feeCover: Maybe<Api_AccountFeeCover>;
  followerCount: Scalars['Int']['output'];
  followers: Api_FollowConnection;
  followingAccountsCount: Scalars['Int']['output'];
  followingGamesCount: Scalars['Int']['output'];
  follows: Api_FollowConnection;
  /** Games this account offers services for */
  gamesOffered: Api_GameConnection;
  /** Connected google accounts of the user */
  google: Array<Api_Google>;
  groupCount: Scalars['Int']['output'];
  groupTeamMemberships: Api_GroupTeamMemberConnection;
  groups: Api_GroupConnection;
  /** Whether the account has an authenticator attached */
  hasAuthenticator: Maybe<Scalars['Boolean']['output']>;
  hasBillingInfo: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account has a password set or not */
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  intercomToken: Maybe<Scalars['String']['output']>;
  /** Whether the account is a customer or not of the current user */
  isACustomer: Scalars['Boolean']['output'];
  isAfk: Scalars['Boolean']['output'];
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isDiscoverable: Maybe<Scalars['Boolean']['output']>;
  isFollowing: Scalars['Boolean']['output'];
  isMuted: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isTeamCommunity: Scalars['Boolean']['output'];
  languages: Array<Scalars['String']['output']>;
  legacySubscription: Maybe<Api_Subscription>;
  metafyPartner: Scalars['Boolean']['output'];
  metafyPartnerReferralIdentifier: Maybe<Scalars['String']['output']>;
  metafyPartnerReferrer: Maybe<Api_Account>;
  /** The latest Metafy Pro subscription for this account */
  metafyPartnerSubscription: Maybe<Api_PurchasedProductSubscription>;
  metafyPartnerType: Maybe<MetafyPartnerEnum>;
  mutedAccounts: Api_MutedAccountConnection;
  name: Maybe<Scalars['String']['output']>;
  nextAvailability: Maybe<Scalars['ISO8601DateTime']['output']>;
  notes: Maybe<Api_AccountNote>;
  notificationSettings: Api_NotificationSettings;
  /** Your platform notifications */
  notifications: Api_NotificationConnection;
  optimizedScheduling: Maybe<Scalars['Boolean']['output']>;
  overview: Api_AccountOverview;
  ownedGroup: Maybe<Api_Group>;
  /** @deprecated This field no longer has any use */
  ownedGroupCount: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use Account.ownedGroup instead */
  ownedGroups: Api_GroupConnection;
  ownedTierCount: Scalars['Int']['output'];
  pastDueStatus: Maybe<Api_PastDue>;
  patreon: Maybe<Api_Patreon>;
  paypal: Maybe<Api_Paypal>;
  pendingProductGuideAuthorRequests: Maybe<Api_ProductGuideAuthorConnection>;
  postCount: Scalars['Int']['output'];
  productCoachingCount: Scalars['Int']['output'];
  productCoachings: Api_ProductCoachingConnection;
  productEventCount: Scalars['Int']['output'];
  productEvents: Api_ProductEventConnection;
  productGuideCount: Scalars['Int']['output'];
  productGuides: Api_ProductGuideConnection;
  products: Api_ProductConnection;
  profileTestimonials: Api_TestimonialConnection;
  purchasedPostsCount: Maybe<Scalars['Int']['output']>;
  requestCountry: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  /** Coupons this account has created */
  sales: Api_SaleConnection;
  sessionCancelationPolicy: Maybe<Api_ProductPolicy>;
  sessionPriceRange: Array<Api_AccountSessionPriceRange>;
  sessionPriceValue: Maybe<Scalars['String']['output']>;
  settings: Maybe<Api_AccountSettings>;
  shortLinks: Array<Api_ShortLink>;
  slug: Maybe<Scalars['String']['output']>;
  socialAccounts: Maybe<Api_AccountSocialAccount>;
  summary: Maybe<Scalars['String']['output']>;
  testimonialRequests: Api_TestimonialRequestConnection;
  testimonials: Api_TestimonialConnection;
  timezone: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  totalBalance: Maybe<Scalars['Float']['output']>;
  totalBalanceLocked: Maybe<Scalars['Float']['output']>;
  totalBalanceWithdrawable: Maybe<Scalars['Float']['output']>;
  totalExperience: Scalars['Int']['output'];
  /** Connected twitch account of the user */
  twitch: Maybe<Api_Twitch>;
  unlistedGroupCount: Maybe<Scalars['Int']['output']>;
  unreadMessageCount: Maybe<Scalars['Int']['output']>;
  unreadNotificationCount: Maybe<Scalars['Int']['output']>;
  unseenNotificationCount: Maybe<Scalars['Int']['output']>;
  unverified: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  useCreditForMetafyPro: Maybe<Scalars['Boolean']['output']>;
  /** Transactions for the account's wallet */
  walletTransactions: Api_WalletTransactionConnection;
  xpRequiredToLevel: Scalars['Int']['output'];
};

/** An account on Metafy */
export type Api_AccountCommunitiesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<AccountCommunitySortOption>>>;
  type: InputMaybe<AccountCommunityEnum>;
};

/** An account on Metafy */
export type Api_AccountCouponsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<CouponSortOption>>>;
};

/** An account on Metafy */
export type Api_AccountFeaturedProductCoachingsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An account on Metafy */
export type Api_AccountFeaturedProductGuidesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An account on Metafy */
export type Api_AccountFollowersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<FollowSortOption>>>;
};

/** An account on Metafy */
export type Api_AccountFollowsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<FollowSortOption>>>;
  type: FollowEnum;
};

/** An account on Metafy */
export type Api_AccountGamesOfferedArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  productTypes?: InputMaybe<Array<ProductEnum>>;
};

/** An account on Metafy */
export type Api_AccountGroupTeamMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupTeamMemberSortOption>>>;
  states?: InputMaybe<Array<GroupTeamMemberStateEnum>>;
};

/** An account on Metafy */
export type Api_AccountGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  gameSlug: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  nonOwnedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupMemberSortOption>>>;
};

/** An account on Metafy */
export type Api_AccountMutedAccountsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<MutedAccountSortOption>>>;
};

/** An account on Metafy */
export type Api_AccountNotificationsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An account on Metafy */
export type Api_AccountOwnedGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupSortOption>>>;
};

/** An account on Metafy */
export type Api_AccountPendingProductGuideAuthorRequestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An account on Metafy */
export type Api_AccountProductCoachingsArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  gameSlug: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sessionCount?: InputMaybe<ProductCoachingSessionCountFilterEnum>;
  sort: InputMaybe<Array<InputMaybe<ProductCoachingSortOption>>>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An account on Metafy */
export type Api_AccountProductEventsArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  completed: InputMaybe<ProductEventCompletedEnum>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductEventSortOption>>>;
  states?: InputMaybe<Array<ProductEventStateEnum>>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An account on Metafy */
export type Api_AccountProductGuidesArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  gameSlug: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductGuideAuthorSortOption>>>;
  states?: InputMaybe<Array<ProductGuideStateEnum>>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An account on Metafy */
export type Api_AccountProductsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductSortOption>>>;
  type: InputMaybe<ProductEnum>;
};

/** An account on Metafy */
export type Api_AccountProfileTestimonialsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  type: TestimonialEnum;
};

/** An account on Metafy */
export type Api_AccountSalesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<SaleSortOption>>>;
};

/** An account on Metafy */
export type Api_AccountSessionPriceRangeArgs = {
  gameId: InputMaybe<Scalars['UUID']['input']>;
  gameSlug: InputMaybe<Scalars['String']['input']>;
};

/** An account on Metafy */
export type Api_AccountSessionPriceValueArgs = {
  gameId: InputMaybe<Scalars['UUID']['input']>;
  gameSlug: InputMaybe<Scalars['String']['input']>;
};

/** An account on Metafy */
export type Api_AccountTestimonialRequestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An account on Metafy */
export type Api_AccountTestimonialsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  newOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<Array<InputMaybe<TestimonialSortOption>>>;
  type: TestimonialEnum;
};

/** An account on Metafy */
export type Api_AccountWalletTransactionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<WalletTransactionSortOption>>>;
};

export type Api_AccountAttachment = WithTimestamps & {
  __typename?: 'API_AccountAttachment';
  attachment: Api_Image;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_AccountAvailability = {
  __typename?: 'API_AccountAvailability';
  friday: Maybe<Scalars['JSON']['output']>;
  monday: Maybe<Scalars['JSON']['output']>;
  saturday: Maybe<Scalars['JSON']['output']>;
  sunday: Maybe<Scalars['JSON']['output']>;
  thursday: Maybe<Scalars['JSON']['output']>;
  tuesday: Maybe<Scalars['JSON']['output']>;
  wednesday: Maybe<Scalars['JSON']['output']>;
};

export type Api_AccountBookingNotice = {
  __typename?: 'API_AccountBookingNotice';
  unit: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type Api_AccountCommunity = WithTimestamps & {
  __typename?: 'API_AccountCommunity';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
  record: AccountCommunityRecordUnion;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_AccountCommunity. */
export type Api_AccountCommunityConnection = {
  __typename?: 'API_AccountCommunityConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_AccountCommunityEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_AccountCommunity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_AccountCommunityEdge = {
  __typename?: 'API_AccountCommunityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_AccountCommunity>;
};

/** The connection type for API_Account. */
export type Api_AccountConnection = {
  __typename?: 'API_AccountConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_AccountEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An account customer on Metafy */
export type Api_AccountCustomer = WithTimestamps & {
  __typename?: 'API_AccountCustomer';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: Api_Account;
  firstPurchaseAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  firstTouchpoint: Maybe<TouchpointEnum>;
  id: Scalars['UUID']['output'];
  lastPurchaseAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  note: Maybe<Scalars['String']['output']>;
  purchaseCount: Scalars['Int']['output'];
  purchases: Api_PurchasedProductConnection;
  totalRevenue: Api_Money;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An account customer on Metafy */
export type Api_AccountCustomerPurchasesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductSortOption>>>;
};

/** The connection type for API_AccountCustomer. */
export type Api_AccountCustomerConnection = {
  __typename?: 'API_AccountCustomerConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_AccountCustomerEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_AccountCustomer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_AccountCustomerEdge = {
  __typename?: 'API_AccountCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_AccountCustomer>;
};

export type Api_AccountDailyLimits = {
  __typename?: 'API_AccountDailyLimits';
  friday: Maybe<Scalars['Int']['output']>;
  monday: Maybe<Scalars['Int']['output']>;
  saturday: Maybe<Scalars['Int']['output']>;
  sunday: Maybe<Scalars['Int']['output']>;
  thursday: Maybe<Scalars['Int']['output']>;
  tuesday: Maybe<Scalars['Int']['output']>;
  wednesday: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type Api_AccountEdge = {
  __typename?: 'API_AccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Account>;
};

export type Api_AccountFaq = {
  __typename?: 'API_AccountFaq';
  answer: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type Api_AccountFeeCover = {
  __typename?: 'API_AccountFeeCover';
  platformFee: Maybe<Scalars['Boolean']['output']>;
  processingFee: Maybe<Scalars['Boolean']['output']>;
};

export type Api_AccountMetric = {
  __typename?: 'API_AccountMetric';
  customers: Api_AccountMetricCustomer;
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['UUID']['output'];
  monthlyRevenue: Api_Money;
  percentageChange: Scalars['Float']['output'];
  previousMonthlyRevenue: Api_Money;
  referrals: Api_AccountMetricReferral;
  revenueDaily: Array<Api_AccountMetricMoneyDailyPoint>;
  sessions: Api_AccountMetricCount;
  startDate: Scalars['ISO8601Date']['output'];
  totalPaidOut: Api_Money;
  totalRevenue: Api_Money;
  valueChange: Api_Money;
};

export type Api_AccountMetricCount = {
  __typename?: 'API_AccountMetricCount';
  daily: Array<Api_AccountMetricCountDailyPoint>;
  monthToDate: Scalars['Int']['output'];
  percentageChange: Scalars['Float']['output'];
  previousMonth: Scalars['Int']['output'];
  previousMonthToDate: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  valueChange: Scalars['Int']['output'];
};

export type Api_AccountMetricCountDailyPoint = {
  __typename?: 'API_AccountMetricCountDailyPoint';
  count: Scalars['Int']['output'];
  date: Scalars['ISO8601Date']['output'];
};

export type Api_AccountMetricCustomer = {
  __typename?: 'API_AccountMetricCustomer';
  count: Api_AccountMetricCount;
  payments: Api_AccountMetricCount;
  revenue: Api_AccountMetricMoney;
};

export type Api_AccountMetricMetafyPartnerReferral = {
  __typename?: 'API_AccountMetricMetafyPartnerReferral';
  allTimeRevenue: Maybe<Api_Money>;
  id: Scalars['UUID']['output'];
  monthlyRevenue: Maybe<Api_Money>;
  signUpDate: Maybe<Scalars['ISO8601Date']['output']>;
  state: ReferralStateEnum;
};

/** The connection type for API_AccountMetricMetafyPartnerReferral. */
export type Api_AccountMetricMetafyPartnerReferralConnection = {
  __typename?: 'API_AccountMetricMetafyPartnerReferralConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_AccountMetricMetafyPartnerReferralEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_AccountMetricMetafyPartnerReferral>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_AccountMetricMetafyPartnerReferralEdge = {
  __typename?: 'API_AccountMetricMetafyPartnerReferralEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_AccountMetricMetafyPartnerReferral>;
};

export type Api_AccountMetricMoney = {
  __typename?: 'API_AccountMetricMoney';
  daily: Array<Api_AccountMetricMoneyDailyPoint>;
  monthToDate: Api_Money;
  percentageChange: Scalars['Float']['output'];
  previousMonth: Api_Money;
  previousMonthToDate: Api_Money;
  total: Api_Money;
  valueChange: Api_Money;
};

export type Api_AccountMetricMoneyDailyPoint = {
  __typename?: 'API_AccountMetricMoneyDailyPoint';
  date: Scalars['ISO8601Date']['output'];
  revenue: Api_Money;
};

export type Api_AccountMetricReferral = {
  __typename?: 'API_AccountMetricReferral';
  clicks: Api_AccountMetricCount;
  count: Api_AccountMetricReferralCount;
  monthlyRevenue: Api_Money;
  nextPayout: Api_Money;
  percentageChange: Scalars['Float']['output'];
  previousMonthlyRevenue: Api_Money;
  referrals: Api_AccountMetricMetafyPartnerReferralConnection;
  totalRevenue: Api_Money;
  valueChange: Api_Money;
};

export type Api_AccountMetricReferralReferralsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ReferralTrackedPurchaseSortOption>>>;
};

export type Api_AccountMetricReferralCount = {
  __typename?: 'API_AccountMetricReferralCount';
  active: Api_AccountMetricCount;
  canceled: Api_AccountMetricCount;
  trial: Api_AccountMetricCount;
};

export type Api_AccountNote = WithTimestamps & {
  __typename?: 'API_AccountNote';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  note: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_AccountOverview = {
  __typename?: 'API_AccountOverview';
  /** The carousel of the account overview */
  carousel: Array<Api_AccountOverviewCarousel>;
  /** The sections of the account overview */
  sections: Api_AccountOverviewSections;
};

export type Api_AccountOverviewBillboard = {
  __typename?: 'API_AccountOverviewBillboard';
  buttonText: Maybe<Scalars['String']['output']>;
  buttonUrl: Maybe<Scalars['String']['output']>;
  ctaText: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type Api_AccountOverviewCarousel = {
  __typename?: 'API_AccountOverviewCarousel';
  id: Scalars['UUID']['output'];
  linkUrl: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  record: Maybe<AccountOverviewCarouselRecordUnion>;
  recordType: Maybe<Scalars['String']['output']>;
};

export type Api_AccountOverviewSection = {
  __typename?: 'API_AccountOverviewSection';
  enabled: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
};

export type Api_AccountOverviewSections = {
  __typename?: 'API_AccountOverviewSections';
  aboutMe: Api_AccountOverviewSection;
  billboard: Maybe<Api_AccountOverviewBillboard>;
  community: Api_AccountOverviewSection;
  discordServerAccess: Api_AccountOverviewSection;
  faq: Api_AccountOverviewSection;
  productCoaching: Api_AccountOverviewSection;
  productEvent: Api_AccountOverviewSection;
  productGuide: Api_AccountOverviewSection;
  /** @deprecated Use product_guide, product_event, and product_coaching instead */
  products: Api_AccountOverviewSection;
  supporterTiers: Api_AccountOverviewSection;
  testimonials: Api_AccountOverviewSection;
};

export type Api_AccountSessionPriceRange = {
  __typename?: 'API_AccountSessionPriceRange';
  game: Maybe<Api_Game>;
  max: Scalars['Float']['output'];
  middle: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type Api_AccountSettings = {
  __typename?: 'API_AccountSettings';
  /** Whether the user has dismissed the contest banner */
  contestBannerDismissed: Scalars['Boolean']['output'];
  /** Whether the user has dimissed the icebreaker question prompt */
  feedIcebreakerDismissed: Scalars['Boolean']['output'];
  /** Whether the user has dismissed the guide launch banner */
  guideLaunchBannerDismissed: Scalars['Boolean']['output'];
  /** Whether the user has dismissed the navigation tooltip */
  navigationTooltipDismissed: Scalars['Boolean']['output'];
};

export type Api_AccountSocialAccount = {
  __typename?: 'API_AccountSocialAccount';
  discord: Maybe<Scalars['String']['output']>;
  discordServer: Maybe<Scalars['String']['output']>;
  externalSite: Maybe<Scalars['String']['output']>;
  facebook: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  tiktok: Maybe<Scalars['String']['output']>;
  twitch: Maybe<Scalars['String']['output']>;
  twitter: Maybe<Scalars['String']['output']>;
  youtube: Maybe<Scalars['String']['output']>;
};

export type Api_ActiveSession = {
  __typename?: 'API_ActiveSession';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  metadata: Api_ActiveSessionMetadata;
};

export type Api_ActiveSessionMetadata = {
  __typename?: 'API_ActiveSessionMetadata';
  browser: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  device: Maybe<Scalars['String']['output']>;
  os: Maybe<Scalars['String']['output']>;
};

export type Api_Announcement = WithTimestamps & {
  __typename?: 'API_Announcement';
  coverImage: Maybe<Api_Image>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  dismissible: Scalars['Boolean']['output'];
  href: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDismissed: Scalars['Boolean']['output'];
  post: Maybe<Api_Post>;
  title: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Announcement. */
export type Api_AnnouncementConnection = {
  __typename?: 'API_AnnouncementConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_AnnouncementEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Announcement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_AnnouncementEdge = {
  __typename?: 'API_AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Announcement>;
};

export type Api_ApiKey = WithTimestamps & {
  __typename?: 'API_ApiKey';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  disabledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['UUID']['output'];
  key: Maybe<Scalars['String']['output']>;
  scopes: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Apple = WithTimestamps & {
  __typename?: 'API_Apple';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Authentication tokens for an account on Metafy */
export type Api_AuthenticationToken = {
  __typename?: 'API_AuthenticationToken';
  /** The access token for authenticated requests */
  accessToken: Scalars['String']['output'];
  /** The long-living refresh token used to refresh the short-lived access token */
  refreshToken: Scalars['String']['output'];
};

export type Api_Availability = {
  __typename?: 'API_Availability';
  /** The users afk mode */
  afkMode: Scalars['Boolean']['output'];
  /** The users availabile times */
  availability: Array<Scalars['ISO8601DateTime']['output']>;
  /** The users next availabile time */
  nextAvailability: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Api_BillingInfo = {
  __typename?: 'API_BillingInfo';
  /** The country of billing info. */
  country: Maybe<Scalars['String']['output']>;
  /** The first name of billing info. */
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The last name of billing info. */
  lastName: Maybe<Scalars['String']['output']>;
  paymentMethod: Maybe<Api_PaymentMethod>;
  /** The postal code of billing info. */
  postalCode: Maybe<Scalars['String']['output']>;
  /** The type of billing info. */
  type: Scalars['String']['output'];
};

export type Api_BlockLayout = {
  __typename?: 'API_BlockLayout';
  blocks: Array<Api_BlockLayoutBlock>;
  /** The ID of the layout */
  id: Scalars['UUID']['output'];
  identifier: Maybe<Scalars['String']['output']>;
};

export type Api_BlockLayoutBlock = {
  __typename?: 'API_BlockLayoutBlock';
  /** The layout of the block */
  blockLayout: Api_BlockLayout;
  /** The type of block */
  blockType: BlockLayoutBlockEnum;
  /** The desktop layout of the block */
  desktop: Api_BlockLayoutBlockGrid;
  /**
   * The height of the block
   * @deprecated Use the desktop.h field instead
   */
  h: Scalars['Int']['output'];
  /** The ID of the block */
  id: Scalars['UUID']['output'];
  /** The mobile layout of the block */
  mobile: Api_BlockLayoutBlockGrid;
  /** The properties of the block */
  properties: Api_BlockLayoutBlockProperties;
  records: Array<BlockLayoutBlockRecordUnion>;
  /**
   * The width of the block
   * @deprecated Use the desktop.w field instead
   */
  w: Scalars['Int']['output'];
  /**
   * The x position of the block
   * @deprecated Use the desktop.x field instead
   */
  x: Scalars['Int']['output'];
  /**
   * The y position of the block
   * @deprecated Use the desktop.y field instead
   */
  y: Scalars['Int']['output'];
};

export type Api_BlockLayoutBlockCopyText = {
  __typename?: 'API_BlockLayoutBlockCopyText';
  /** The format of the text */
  format: BlockLayoutBlockCopyTextFormatEnum;
  /** The text */
  text: Scalars['String']['output'];
};

export type Api_BlockLayoutBlockGif = {
  __typename?: 'API_BlockLayoutBlockGif';
  /** The image */
  image: Api_BlockLayoutBlockGifImage;
  /** The provider of the gif */
  provider: BlockLayoutBlockImageProviderEnum;
};

export type Api_BlockLayoutBlockGifImage = {
  __typename?: 'API_BlockLayoutBlockGifImage';
  /** The dimensions of the image */
  dims: Array<Scalars['Int']['output']>;
  /** The duration of the image */
  duration: Scalars['Float']['output'];
  /** The ID of the image */
  id: Scalars['ID']['output'];
  /** The preview of the image */
  preview: Scalars['String']['output'];
  /** The size of the image */
  size: Scalars['Int']['output'];
  /** The URL of the image */
  url: Scalars['String']['output'];
};

export type Api_BlockLayoutBlockGrid = {
  __typename?: 'API_BlockLayoutBlockGrid';
  /** The height of the block */
  h: Maybe<Scalars['Int']['output']>;
  /** Whether the block is shown */
  show: Maybe<Scalars['Boolean']['output']>;
  /** The width of the block */
  w: Maybe<Scalars['Int']['output']>;
  /** The x position of the block */
  x: Maybe<Scalars['Int']['output']>;
  /** The y position of the block */
  y: Maybe<Scalars['Int']['output']>;
};

export type Api_BlockLayoutBlockGroupSupporter = {
  __typename?: 'API_BlockLayoutBlockGroupSupporter';
  /** The description of the supporter block */
  description: Maybe<Scalars['String']['output']>;
  /** The title of the supporter block */
  title: Maybe<Scalars['String']['output']>;
};

export type Api_BlockLayoutBlockImage = {
  __typename?: 'API_BlockLayoutBlockImage';
  /** The alt text of the image */
  altText: Maybe<Scalars['String']['output']>;
  /** The URL of the link */
  url: Scalars['String']['output'];
};

export type Api_BlockLayoutBlockLink = {
  __typename?: 'API_BlockLayoutBlockLink';
  /** The open graph data of the link */
  openGraph: Maybe<Api_OpenGraph>;
  /** The type of the link */
  source: BlockLayoutBlockLinkSourceEnum;
  /** The title of the link */
  title: Scalars['String']['output'];
  /** The URL of the link */
  url: Scalars['String']['output'];
  /** The username of the link if this is a social block */
  username: Maybe<Scalars['String']['output']>;
};

export type Api_BlockLayoutBlockPost = {
  __typename?: 'API_BlockLayoutBlockPost';
  /** The color of the block background */
  color: Maybe<Scalars['String']['output']>;
};

export type Api_BlockLayoutBlockProperties = {
  __typename?: 'API_BlockLayoutBlockProperties';
  /** The copy text */
  copyText: Maybe<Api_BlockLayoutBlockCopyText>;
  /** The image */
  gif: Maybe<Api_BlockLayoutBlockGif>;
  /** The group supporter */
  groupSupporter: Maybe<Api_BlockLayoutBlockGroupSupporter>;
  /** The image */
  image: Maybe<Api_BlockLayoutBlockImage>;
  /** The link */
  link: Maybe<Api_BlockLayoutBlockLink>;
  /** The post */
  post: Maybe<Api_BlockLayoutBlockPost>;
  /** The quote */
  quote: Maybe<Api_BlockLayoutBlockQuote>;
  /** The video */
  video: Maybe<Api_BlockLayoutBlockVideo>;
};

export type Api_BlockLayoutBlockQuote = {
  __typename?: 'API_BlockLayoutBlockQuote';
  /** The background of the quote */
  background: Maybe<Api_BlockLayoutBlockQuoteBackground>;
  /** The quote */
  quote: Scalars['String']['output'];
};

export type Api_BlockLayoutBlockQuoteBackground = {
  __typename?: 'API_BlockLayoutBlockQuoteBackground';
  /** The alignment of the background */
  align: Scalars['String']['output'];
  /** The color of the background */
  color: Maybe<Scalars['String']['output']>;
  /** The justification of the background */
  justify: Scalars['String']['output'];
  /** The size of the background */
  size: Maybe<Scalars['String']['output']>;
};

export type Api_BlockLayoutBlockVideo = {
  __typename?: 'API_BlockLayoutBlockVideo';
  /** The description of the video */
  description: Maybe<Scalars['String']['output']>;
  /** The duration of the video in seconds */
  durationSecond: Maybe<Scalars['Int']['output']>;
  /** The ID of the video */
  id: Scalars['String']['output'];
  /** The source of the video */
  source: BlockLayoutBlockVideoSourceEnum;
  /** The thumbnail of the video */
  thumbnail: Maybe<Scalars['String']['output']>;
  /** The URL of the video */
  url: Maybe<Scalars['String']['output']>;
};

/** A change log entry */
export type Api_ChangeLog = WithTimestamps & {
  __typename?: 'API_ChangeLog';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  seen: Scalars['Boolean']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_ChangeLog. */
export type Api_ChangeLogConnection = {
  __typename?: 'API_ChangeLogConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ChangeLogEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ChangeLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ChangeLogEdge = {
  __typename?: 'API_ChangeLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ChangeLog>;
};

/** A member of a chat room */
export type Api_ChatMember = WithTimestamps & {
  __typename?: 'API_ChatMember';
  account: Api_Account;
  chatRoomId: Scalars['UUID']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  unreadCount: Maybe<Scalars['Int']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A message within a chat room */
export type Api_ChatMessage = WithTimestamps & {
  __typename?: 'API_ChatMessage';
  answered: Scalars['Boolean']['output'];
  author: Api_ChatMember;
  chatRoom: Api_ChatRoom;
  chatRoomId: Scalars['UUID']['output'];
  content: Scalars['String']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** @deprecated Use reaction_count instead */
  likeCount: Scalars['Int']['output'];
  /** @deprecated Use user_reactions instead */
  likeId: Maybe<Scalars['UUID']['output']>;
  messageType: ChatMessageEnum;
  /** The parent message if this is a reply */
  parent: Maybe<Api_ChatMessage>;
  reactionCounts: Array<Api_ChatMessageReactionCount>;
  tipValue: Maybe<Api_Money>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The reactions of the authenticated user */
  userReactions: Maybe<Array<Api_ChatMessageReaction>>;
};

/** The connection type for API_ChatMessage. */
export type Api_ChatMessageConnection = {
  __typename?: 'API_ChatMessageConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ChatMessageEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ChatMessage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ChatMessageEdge = {
  __typename?: 'API_ChatMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ChatMessage>;
};

/** A reaction to a chat message */
export type Api_ChatMessageReaction = WithTimestamps & {
  __typename?: 'API_ChatMessageReaction';
  chatMember: Api_ChatMember;
  chatMessage: Api_ChatMessage;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  emote: Api_Emote;
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_ChatMessageReactionCount = {
  __typename?: 'API_ChatMessageReactionCount';
  count: Scalars['Int']['output'];
  emote: Api_Emote;
};

export type Api_ChatRoom = WithTimestamps & {
  __typename?: 'API_ChatRoom';
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Maybe<Api_ProductEvent>;
  id: Scalars['UUID']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<Api_ChatMember>;
  messages: Api_ChatMessageConnection;
  roomType: ChatRoomEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_ChatRoomMessagesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ChatMessageSortOption>>>;
  type: InputMaybe<Array<ChatMessageEnum>>;
};

/** The connection type for API_ChatRoom. */
export type Api_ChatRoomConnection = {
  __typename?: 'API_ChatRoomConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ChatRoomEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ChatRoom>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ChatRoomEdge = {
  __typename?: 'API_ChatRoomEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ChatRoom>;
};

export type Api_CoachAchievement = WithTimestamps & {
  __typename?: 'API_CoachAchievement';
  account: Api_Account;
  achievement: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  game: Maybe<Api_Game>;
  id: Scalars['UUID']['output'];
  placement: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  tournamentTitle: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  year: Maybe<Scalars['Int']['output']>;
};

export type Api_ContestLeaderboard = {
  __typename?: 'API_ContestLeaderboard';
  group: Maybe<Api_Group>;
  guides: Maybe<Array<Api_ProductGuide>>;
  position: Scalars['Int']['output'];
  prize: Scalars['Int']['output'];
  purchaseCount: Scalars['Int']['output'];
  subscriptionCount: Scalars['Int']['output'];
};

/** The connection type for API_ContestLeaderboard. */
export type Api_ContestLeaderboardConnection = {
  __typename?: 'API_ContestLeaderboardConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ContestLeaderboardEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ContestLeaderboard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ContestLeaderboardEdge = {
  __typename?: 'API_ContestLeaderboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ContestLeaderboard>;
};

export type Api_Coupon = WithCouponBase &
  WithTimestamps & {
    __typename?: 'API_Coupon';
    /** List of accounts this coupon can be redeemed against */
    accounts: Array<Api_CouponAccount>;
    /** The code of the coupon */
    code: Scalars['String']['output'];
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    /** The type of discount */
    discountType: CouponDiscountEnum;
    /** The value of the discount */
    discountValue: Scalars['Float']['output'];
    /** The duration of the coupon for group_supporter subscriptions */
    duration: Maybe<CouponDurationEnum>;
    /** Whether the coupon is enabled */
    enabled: Scalars['Boolean']['output'];
    /** The expiry date of the coupon */
    expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** List of games this coupon can be redeemed against */
    games: Array<Api_CouponGame>;
    /** Whether the coupon is global */
    global: Scalars['Boolean']['output'];
    /** The ID of the coupon */
    id: Scalars['UUID']['output'];
    /** The limits of the coupon */
    limits: Api_CouponLimitConnection;
    /** The maximum value of the discount */
    maxDiscountValue: Maybe<Scalars['Float']['output']>;
    /** The maximum number of redemptions */
    maxRedemptions: Maybe<Scalars['Int']['output']>;
    /**
     * The maximum number of redemptions per account
     * @deprecated Use limits.max_redemptions_per_account instead
     */
    maxRedemptionsPerAccount: Maybe<Scalars['Int']['output']>;
    /** The name of the coupon */
    name: Maybe<Scalars['SanitizedString']['output']>;
    /** List of products this coupon can be redeemed against */
    products: Array<Api_CouponProduct>;
    /** The number of times the coupon has been redeemed */
    redeemedCount: Scalars['Int']['output'];
    /** Whether the coupon or sale is stackable with other coupons or sales */
    stackable: Scalars['Boolean']['output'];
    /** List of product types this coupon can be redeemed against */
    supportedProductTypes: Array<ProductEnum>;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
    /** The date the coupon becomes valid */
    validFrom: Maybe<Scalars['ISO8601DateTime']['output']>;
  };

export type Api_CouponLimitsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_CouponAccount = WithTimestamps & {
  __typename?: 'API_CouponAccount';
  account: Api_Account;
  coupon: Api_Coupon;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Coupon. */
export type Api_CouponConnection = {
  __typename?: 'API_CouponConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_CouponEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Coupon>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_CouponEdge = {
  __typename?: 'API_CouponEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Coupon>;
};

export type Api_CouponGame = WithTimestamps & {
  __typename?: 'API_CouponGame';
  coupon: Api_Coupon;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  game: Api_Game;
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_CouponLimit = WithTimestamps & {
  __typename?: 'API_CouponLimit';
  coupon: Api_Coupon;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  maxRedemptions: Maybe<Scalars['Int']['output']>;
  maxRedemptionsPerAccount: Maybe<Scalars['Int']['output']>;
  productType: ProductEnum;
  redeemedCount: Scalars['Int']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_CouponLimit. */
export type Api_CouponLimitConnection = {
  __typename?: 'API_CouponLimitConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_CouponLimitEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_CouponLimit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_CouponLimitEdge = {
  __typename?: 'API_CouponLimitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_CouponLimit>;
};

export type Api_CouponProduct = WithTimestamps & {
  __typename?: 'API_CouponProduct';
  coupon: Api_Coupon;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  product: Api_Product;
  record: CouponProductRecordUnion;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Discord = WithTimestamps & {
  __typename?: 'API_Discord';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  discriminator: Scalars['String']['output'];
  hasLatestPermissions: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  username: Scalars['String']['output'];
};

export type Api_DiscordGuild = WithTimestamps & {
  __typename?: 'API_DiscordGuild';
  approximateMemberCount: Scalars['Int']['output'];
  approximatePresenceCount: Scalars['Int']['output'];
  assignableRoles: Array<Scalars['UUID']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  gate: DiscordGuildGateEnum;
  iconUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  members: Array<Api_DiscordGuildMember>;
  name: Scalars['String']['output'];
  roles: Array<Api_DiscordGuildRole>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_DiscordGuildMember = {
  __typename?: 'API_DiscordGuildMember';
  avatarUrl: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Api_DiscordGuildRole = WithTimestamps & {
  __typename?: 'API_DiscordGuildRole';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  discordGuild: Api_DiscordGuild;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Emote = WithTimestamps & {
  __typename?: 'API_Emote';
  animated: Scalars['Boolean']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Facebook = WithTimestamps & {
  __typename?: 'API_Facebook';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Follow = WithTimestamps & {
  __typename?: 'API_Follow';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  game: Maybe<Api_Game>;
  id: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
  targetAccount: Maybe<Api_Account>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Follow. */
export type Api_FollowConnection = {
  __typename?: 'API_FollowConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_FollowEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Follow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_FollowEdge = {
  __typename?: 'API_FollowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Follow>;
};

/** An game on Metafy */
export type Api_Game = WithTimestamps & {
  __typename?: 'API_Game';
  accounts: Api_AccountConnection;
  artwork: Maybe<Api_Image>;
  /** Returns a list of accounts that are currently offer coaching */
  coachingPageAccounts: Api_AccountConnection;
  /** Returns the first artwork from the community. See community_artworks for the list. */
  communityArtwork: Maybe<Api_GameCommunityArtwork>;
  /** Artworks of the game from members of the community. */
  communityArtworks: Api_GameCommunityArtworkConnection;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  cutout: Maybe<Api_Image>;
  filter: Api_GameFilter;
  followerCount: Scalars['Int']['output'];
  groupCount: Scalars['Int']['output'];
  groups: Api_GroupConnection;
  homePageBackgroundImage: Maybe<Api_Image>;
  homePageCutoutImage: Maybe<Api_Image>;
  homePageCutoutTwoImage: Maybe<Api_Image>;
  homePageLogo: Maybe<Api_Image>;
  id: Scalars['UUID']['output'];
  isFollowing: Scalars['Boolean']['output'];
  localizedShortTitles: Api_GameTitle;
  localizedTitles: Api_GameTitle;
  logoMain: Maybe<Api_Image>;
  logotype: Maybe<Api_Image>;
  /** Return a list of accounts that the account has purchased coaching from */
  myCoaches: Api_AccountConnection;
  /** Return a list of guides that the account has purchased */
  myGuides: Api_PurchasedProductGuideConnection;
  postCount: Scalars['Int']['output'];
  poster: Maybe<Api_Image>;
  productCoachings: Api_ProductCoachingConnection;
  productEvents: Api_ProductEventConnection;
  productGuides: Api_ProductGuideConnection;
  seoData: Api_GameSeoData;
  /** @deprecated Use Game.localized_short_titles instead */
  shortTitle: Scalars['JSON']['output'];
  slug: Scalars['String']['output'];
  /** @deprecated Use Game.localized_titles instead */
  title: Scalars['JSON']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An game on Metafy */
export type Api_GameAccountsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<AccountSortOption>>>;
};

/** An game on Metafy */
export type Api_GameCoachingPageAccountsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  languages: InputMaybe<Array<Scalars['String']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
  priceRange: InputMaybe<PriceRangeInput>;
  priceValue: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductCoachingSortOption>>>;
};

/** An game on Metafy */
export type Api_GameCommunityArtworksArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GameCommunityArtworkSortOption>>>;
};

/** An game on Metafy */
export type Api_GameGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupSortOption>>>;
};

/** An game on Metafy */
export type Api_GameMyCoachesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An game on Metafy */
export type Api_GameMyGuidesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  includeOwnGuides?: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** An game on Metafy */
export type Api_GameProductCoachingsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductCoachingSortOption>>>;
};

/** An game on Metafy */
export type Api_GameProductEventsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  languages: InputMaybe<Array<Scalars['String']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductEventSortOption>>>;
  states?: InputMaybe<Array<ProductEventStateEnum>>;
};

/** An game on Metafy */
export type Api_GameProductGuidesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  chapterCount: InputMaybe<Scalars['Int']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  languages: InputMaybe<Array<Scalars['String']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
  priceValue: InputMaybe<PriceValueEnum>;
  sort: InputMaybe<Array<InputMaybe<ProductGuideSortOption>>>;
};

/** An artwork for a game on Metafy */
export type Api_GameCommunityArtwork = WithTimestamps & {
  __typename?: 'API_GameCommunityArtwork';
  artwork: Maybe<Api_Image>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The game this artwork is for */
  game: Api_Game;
  /** The ID of the artwork */
  id: Scalars['UUID']['output'];
  /** The name the artwork author goes by */
  name: Scalars['String']['output'];
  /** Social accounts for the artwork author */
  socialAccounts: Maybe<Api_GameCommunityArtworkSocialAccounts>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_GameCommunityArtwork. */
export type Api_GameCommunityArtworkConnection = {
  __typename?: 'API_GameCommunityArtworkConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GameCommunityArtworkEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GameCommunityArtwork>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GameCommunityArtworkEdge = {
  __typename?: 'API_GameCommunityArtworkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GameCommunityArtwork>;
};

export type Api_GameCommunityArtworkSocialAccounts = {
  __typename?: 'API_GameCommunityArtworkSocialAccounts';
  /** Artstation account */
  artstation: Maybe<Scalars['String']['output']>;
  /** Devianart account */
  devianart: Maybe<Scalars['String']['output']>;
  /** Instagram account */
  instagram: Maybe<Scalars['String']['output']>;
  /** Twitter account */
  twitter: Maybe<Scalars['String']['output']>;
  /** Website */
  website: Maybe<Scalars['String']['output']>;
};

/** The connection type for API_Game. */
export type Api_GameConnection = {
  __typename?: 'API_GameConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GameEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Game>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GameEdge = {
  __typename?: 'API_GameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Game>;
};

export type Api_GameFilter = {
  __typename?: 'API_GameFilter';
  guide: Api_GameFilterGuide;
  session: Api_GameFilterSession;
};

export type Api_GameFilterCount = {
  __typename?: 'API_GameFilterCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Api_GameFilterGuide = {
  __typename?: 'API_GameFilterGuide';
  chapterCount: Array<Api_GameFilterCount>;
  languages: Array<Api_GameFilterCount>;
  priceRange: Array<Api_GameFilterPriceRange>;
};

export type Api_GameFilterGuideLanguagesArgs = {
  queryType?: InputMaybe<CoachingPageAccountsQueryEnum>;
};

export type Api_GameFilterGuidePriceRangeArgs = {
  queryType?: InputMaybe<CoachingPageAccountsQueryEnum>;
};

export type Api_GameFilterPriceRange = {
  __typename?: 'API_GameFilterPriceRange';
  hasFree: Scalars['Boolean']['output'];
  max: Scalars['Float']['output'];
  middle: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type Api_GameFilterSession = {
  __typename?: 'API_GameFilterSession';
  languages: Array<Api_GameFilterCount>;
  priceRanges: Array<Api_GameFilterPriceRange>;
  timezones: Array<Api_GameFilterCount>;
};

export type Api_GameFilterSessionLanguagesArgs = {
  queryType?: InputMaybe<CoachingPageAccountsQueryEnum>;
};

export type Api_GameFilterSessionPriceRangesArgs = {
  queryType?: InputMaybe<CoachingPageAccountsQueryEnum>;
};

export type Api_GameSeoData = {
  __typename?: 'API_GameSeoData';
  description: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type Api_GameTitle = {
  __typename?: 'API_GameTitle';
  en: Maybe<Scalars['String']['output']>;
};

export type Api_GiftCard = WithTimestamps & {
  __typename?: 'API_GiftCard';
  anonymousGift: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  gifter: Maybe<Api_Account>;
  gifterName: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  message: Maybe<Scalars['String']['output']>;
  purchasedProduct: Maybe<Api_PurchasedProduct>;
  recipient: Maybe<Api_Account>;
  recipientEmail: Maybe<Scalars['String']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  state: GiftCardStateEnum;
  style: Maybe<Scalars['Int']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Api_Money;
};

/** The connection type for API_GiftCard. */
export type Api_GiftCardConnection = {
  __typename?: 'API_GiftCardConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GiftCardEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GiftCard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GiftCardEdge = {
  __typename?: 'API_GiftCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GiftCard>;
};

export type Api_Google = WithTimestamps & {
  __typename?: 'API_Google';
  calendarAdd: Scalars['Boolean']['output'];
  calendarConflicts: Scalars['Boolean']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isCalendarLinked: Scalars['Boolean']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Community within Metafy */
export type Api_Group = WithTimestamps & {
  __typename?: 'API_Group';
  account: Api_Account;
  archived: Scalars['Boolean']['output'];
  banCount: Maybe<Scalars['Int']['output']>;
  /** Collection of banned accounts from the group */
  bans: Api_GroupBanConnection;
  blockLayoutAbout: Maybe<Api_BlockLayout>;
  channelCount: Scalars['Int']['output'];
  channels: Array<Api_GroupChannel>;
  cover: Maybe<Api_Image>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  game: Maybe<Api_Game>;
  /** Returns a group tier by ID or slug */
  groupTier: Maybe<Api_GroupTier>;
  groupTiers: Array<Api_GroupTier>;
  id: Scalars['UUID']['output'];
  /**
   * The GroupInvite record if you have been invited to the group
   * @deprecated Invites are deprecated
   */
  invite: Maybe<Api_GroupInvite>;
  /** @deprecated Inivites are deprecated */
  invites: Api_GroupInviteConnection;
  /** If you're banned from the group */
  isBanned: Scalars['Boolean']['output'];
  leaderboard: Api_GroupMemberConnection;
  logo: Maybe<Api_Image>;
  memberCount: Scalars['Int']['output'];
  members: Api_GroupMemberConnection;
  /** Your GroupMember record if you are a member of the group */
  membership: Maybe<Api_GroupMember>;
  /** Returns a list of metrics for the current group */
  metrics: Maybe<Api_GroupMetric>;
  postCount: Scalars['Int']['output'];
  postPermission: GroupPostPermissionEnum;
  /** @deprecated Prices are now on the GroupTier records */
  price: Api_Money;
  product: Maybe<Api_Product>;
  /**
   * The GroupRequest record if you have requested to join the group
   * @deprecated Requests are deprecated
   */
  request: Maybe<Api_GroupRequest>;
  /** @deprecated Requests are deprecated */
  requests: Api_GroupRequestConnection;
  scheduledPostCount: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  subscriptionPercentageSplit: Maybe<Scalars['Float']['output']>;
  supporterCount: Scalars['Int']['output'];
  /** Team members of the group */
  teamMembers: Api_GroupTeamMemberConnection;
  tierCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  visibility: GroupVisibilityEnum;
};

/** Community within Metafy */
export type Api_GroupBansArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupBanSortOption>>>;
};

/** Community within Metafy */
export type Api_GroupGroupTierArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

/** Community within Metafy */
export type Api_GroupGroupTiersArgs = {
  includeUnlisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Community within Metafy */
export type Api_GroupInvitesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupInviteSortOption>>>;
};

/** Community within Metafy */
export type Api_GroupLeaderboardArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** Community within Metafy */
export type Api_GroupMembersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  groupTierId: InputMaybe<Scalars['UUID']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  nameFilter: InputMaybe<Scalars['SanitizedString']['input']>;
  onlySupporters: InputMaybe<Scalars['Boolean']['input']>;
  roles: InputMaybe<Array<GroupRoleEnum>>;
  sort: InputMaybe<Array<InputMaybe<GroupMemberSortOption>>>;
};

/** Community within Metafy */
export type Api_GroupMetricsArgs = {
  days: InputMaybe<Scalars['Int']['input']>;
  month: InputMaybe<Scalars['Int']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

/** Community within Metafy */
export type Api_GroupRequestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupRequestSortOption>>>;
};

/** Community within Metafy */
export type Api_GroupTeamMembersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  productsOffered?: InputMaybe<Array<ProductEnum>>;
  sort: InputMaybe<Array<InputMaybe<GroupTeamMemberSortOption>>>;
  states?: InputMaybe<Array<GroupTeamMemberStateEnum>>;
};

export type Api_GroupBan = WithTimestamps & {
  __typename?: 'API_GroupBan';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  group: Api_Group;
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_GroupBan. */
export type Api_GroupBanConnection = {
  __typename?: 'API_GroupBanConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupBanEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GroupBan>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GroupBanEdge = {
  __typename?: 'API_GroupBanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GroupBan>;
};

/** A channel within a group */
export type Api_GroupChannel = WithTimestamps & {
  __typename?: 'API_GroupChannel';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  group: Api_Group;
  guide: Maybe<Api_ProductGuide>;
  id: Scalars['UUID']['output'];
  /** Is this channel a guide channel */
  isGuideChannel: Scalars['Boolean']['output'];
  /** Is this channel viewable by the authenticated user */
  isViewable: Scalars['Boolean']['output'];
  /** @deprecated No longer used */
  paywalled: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  postCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Group. */
export type Api_GroupConnection = {
  __typename?: 'API_GroupConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Group>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

export type Api_GroupDiscount = {
  __typename?: 'API_GroupDiscount';
  discountPercent: Scalars['Int']['output'];
  group: Api_Group;
  groupTier: Api_GroupTier;
  groupTierBenefit: Api_GroupTierBenefit;
};

/** An edge in a connection. */
export type Api_GroupEdge = {
  __typename?: 'API_GroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Group>;
};

/** An invitation to join a group */
export type Api_GroupInvite = WithTimestamps & {
  __typename?: 'API_GroupInvite';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  group: Api_Group;
  id: Scalars['UUID']['output'];
  role: GroupRoleEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_GroupInvite. */
export type Api_GroupInviteConnection = {
  __typename?: 'API_GroupInviteConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupInviteEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GroupInvite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GroupInviteEdge = {
  __typename?: 'API_GroupInviteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GroupInvite>;
};

/** A member of a group */
export type Api_GroupMember = WithTimestamps & {
  __typename?: 'API_GroupMember';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Experience gained over the last 30 days */
  currentExperience: Scalars['Int']['output'];
  currentLevel: Scalars['Int']['output'];
  currentLevelXp: Scalars['Int']['output'];
  currentLevelXpRequired: Scalars['Int']['output'];
  group: Api_Group;
  groupTier: Maybe<Api_GroupTier>;
  id: Scalars['UUID']['output'];
  isSupporter: Scalars['Boolean']['output'];
  /** The name of the tier the member was previously subscribed to */
  lastTier: Maybe<Scalars['String']['output']>;
  lifetimeRevenue: Maybe<Api_Money>;
  newPostsCount: Maybe<Scalars['Int']['output']>;
  /** The tier the member is downgrading to next billing cycle */
  pendingTier: Maybe<Api_GroupTier>;
  role: GroupRoleEnum;
  subscription: Maybe<Api_PurchasedProductSubscription>;
  subscriptionEndDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  subscriptionEndedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  subscriptionRenewalCount: Maybe<Scalars['Int']['output']>;
  totalExperience: Scalars['Int']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  xpRequiredToLevel: Scalars['Int']['output'];
};

/** The connection type for API_GroupMember. */
export type Api_GroupMemberConnection = {
  __typename?: 'API_GroupMemberConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupMemberEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GroupMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GroupMemberEdge = {
  __typename?: 'API_GroupMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GroupMember>;
};

export type Api_GroupMetric = {
  __typename?: 'API_GroupMetric';
  conversion: Api_GroupMetricsCount;
  dailyActiveMembers: Api_GroupMetricsCount;
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['UUID']['output'];
  members: Api_GroupMetricsMembers;
  monthlyActiveMembers: Api_GroupMetricsCount;
  posts: Api_GroupMetricsPosts;
  response: Scalars['JSON']['output'];
  revenue: Api_GroupMetricsRevenue;
  startDate: Scalars['ISO8601Date']['output'];
  views: Api_GroupMetricsCount;
};

export type Api_GroupMetricsCount = {
  __typename?: 'API_GroupMetricsCount';
  daily: Array<Api_AccountMetricCountDailyPoint>;
  percentageChange: Scalars['Float']['output'];
  previousMonth: Scalars['Int']['output'];
  previousMonthToDate: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  valueChange: Scalars['Int']['output'];
};

export type Api_GroupMetricsCountSimple = {
  __typename?: 'API_GroupMetricsCountSimple';
  daily: Array<Api_AccountMetricCountDailyPoint>;
  total: Scalars['Int']['output'];
};

export type Api_GroupMetricsMembers = {
  __typename?: 'API_GroupMetricsMembers';
  count: Api_GroupMetricsCountSimple;
  new: Api_AccountMetricCount;
};

export type Api_GroupMetricsPosts = {
  __typename?: 'API_GroupMetricsPosts';
  all: Api_GroupMetricsCountSimple;
  new: Api_AccountMetricCount;
};

export type Api_GroupMetricsRevenue = {
  __typename?: 'API_GroupMetricsRevenue';
  periodRevenue: Api_Money;
  periodRevenueDaily: Array<Api_AccountMetricMoneyDailyPoint>;
  revenuePercentageChange: Scalars['Float']['output'];
  revenueValueChange: Scalars['Int']['output'];
  supporterCount: Scalars['Int']['output'];
  supporterCountDaily: Array<Api_AccountMetricCountDailyPoint>;
  supporterTotalCount: Scalars['Int']['output'];
  totalRevenue: Api_Money;
  totalSupporterRevenue: Api_Money;
};

/** A request to join a group */
export type Api_GroupRequest = WithTimestamps & {
  __typename?: 'API_GroupRequest';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  group: Api_Group;
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_GroupRequest. */
export type Api_GroupRequestConnection = {
  __typename?: 'API_GroupRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupRequestEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GroupRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GroupRequestEdge = {
  __typename?: 'API_GroupRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GroupRequest>;
};

/** A team member of a community */
export type Api_GroupTeamMember = WithTimestamps & {
  __typename?: 'API_GroupTeamMember';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  group: Api_Group;
  id: Scalars['UUID']['output'];
  /** The percentage split of revenue you take from non-recurring revenue */
  percentageSplit: Maybe<Scalars['Float']['output']>;
  position: Maybe<Scalars['Int']['output']>;
  state: GroupTeamMemberStateEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_GroupTeamMember. */
export type Api_GroupTeamMemberConnection = {
  __typename?: 'API_GroupTeamMemberConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupTeamMemberEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GroupTeamMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GroupTeamMemberEdge = {
  __typename?: 'API_GroupTeamMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GroupTeamMember>;
};

export type Api_GroupTier = {
  __typename?: 'API_GroupTier';
  benefits: Array<Api_GroupTierBenefit>;
  billingFrequency: Maybe<BillingFrequencyEnum>;
  billingInterval: Maybe<Scalars['Int']['output']>;
  channels: Array<Api_GroupChannel>;
  cover: Maybe<Api_Image>;
  coverVideo: Maybe<Api_MuxAsset>;
  description: Scalars['String']['output'];
  discordGuilds: Array<Scalars['UUID']['output']>;
  discordRoles: Array<Api_DiscordGuildRole>;
  group: Api_Group;
  hasSetupFee: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  orderItemForAccount: Maybe<Api_OrderItem>;
  price: Api_Money;
  priceLastChangedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  pricingOption: Api_ProductPricingOption;
  recommended: Scalars['Boolean']['output'];
  role: Maybe<Scalars['String']['output']>;
  seatLimit: Maybe<Scalars['Int']['output']>;
  seatsLeft: Maybe<Scalars['Int']['output']>;
  setupPrice: Api_Money;
  slug: Scalars['String']['output'];
  supporterCount: Maybe<Scalars['Int']['output']>;
  unlisted: Scalars['Boolean']['output'];
  yearlyDiscountEnabled: Scalars['Boolean']['output'];
  yearlyDiscountPercentage: Scalars['Int']['output'];
  yearlyPrice: Maybe<Api_Money>;
  yearlyProductPricingOption: Maybe<Api_ProductPricingOption>;
};

export type Api_GroupTierOrderItemForAccountArgs = {
  forYearlyDiscountRate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Api_GroupTierBenefit = {
  __typename?: 'API_GroupTierBenefit';
  allRecords: Scalars['Boolean']['output'];
  benefitType: GroupTierBenefitEnum;
  context: Maybe<Scalars['String']['output']>;
  discountPercent: Scalars['Int']['output'];
  groupTier: Api_GroupTier;
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
  records: Array<GroupTierBenefitUnion>;
  title: Scalars['String']['output'];
};

/** The connection type for API_GroupTierBenefit. */
export type Api_GroupTierBenefitConnection = {
  __typename?: 'API_GroupTierBenefitConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_GroupTierBenefitEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_GroupTierBenefit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_GroupTierBenefitEdge = {
  __typename?: 'API_GroupTierBenefitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_GroupTierBenefit>;
};

export type Api_Image = {
  __typename?: 'API_Image';
  /** Blurhash-encoded version of the image */
  blurhash: Maybe<Scalars['String']['output']>;
  /** The original image */
  original: Maybe<Api_ImageView>;
  /** The various generated variants of this image */
  variants: Array<Api_ImageView>;
};

export type Api_ImageView = {
  __typename?: 'API_ImageView';
  /** The height of the image */
  height: Maybe<Scalars['Int']['output']>;
  /** The name of this view of the image */
  name: Scalars['String']['output'];
  /** The URL of this view of the image */
  url: Scalars['String']['output'];
  /** The width of the image */
  width: Maybe<Scalars['Int']['output']>;
};

export type Api_Money = {
  __typename?: 'API_Money';
  /** ISO currency code */
  currency: Scalars['String']['output'];
  /** The value in cents */
  subunits: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type Api_Mutation = {
  __typename?: 'API_Mutation';
  /** Create a new achievement */
  accountAchievementCreate: Maybe<AccountAchievementCreatePayload>;
  /** Remove a achievement */
  accountAchievementDelete: Maybe<AccountAchievementDeletePayload>;
  /** Update an existing achievement */
  accountAchievementUpdate: Maybe<AccountAchievementUpdatePayload>;
  /** Create an attachment for an account */
  accountAttachmentCreate: Maybe<AccountAttachmentCreatePayload>;
  /** Preview a block layout block */
  accountBlockLayoutBlockPreview: Maybe<AccountBlockLayoutBlockPreviewPayload>;
  /** Update a user's block layout settings */
  accountBlockLayoutUpdate: Maybe<AccountBlockLayoutUpdatePayload>;
  /** Update cancelation policy for an account */
  accountCancelationPolicyUpdate: Maybe<AccountCancelationPolicyUpdatePayload>;
  /** Update the position of a community within an account */
  accountCommunitiesEdit: Maybe<AccountCommunitiesEditPayload>;
  /** Confirm an email address change with a valid key */
  accountConfirmEmail: Maybe<AccountConfirmEmailPayload>;
  /** Create a Metafy account */
  accountCreate: Maybe<AccountCreatePayload>;
  /** Update a customer's account information */
  accountCustomerUpdate: Maybe<AccountCustomerUpdatePayload>;
  /** Edit your account on Metafy */
  accountEdit: Maybe<AccountEditPayload>;
  /** Create a FAQ entry */
  accountFaqCreate: Maybe<AccountFaqCreatePayload>;
  /** Remove a FAQ entry */
  accountFaqDelete: Maybe<AccountFaqDeletePayload>;
  /** Update a FAQ */
  accountFaqUpdate: Maybe<AccountFaqUpdatePayload>;
  /** Follow an account on Metafy */
  accountFollowCreate: Maybe<AccountFollowCreatePayload>;
  /** Unfollow an account on Metafy */
  accountFollowDelete: Maybe<AccountFollowDeletePayload>;
  /** Login to an existing Metafy account */
  accountLogin: Maybe<AccountLoginPayload>;
  /** Logout of your session with Metafy */
  accountLogout: Maybe<AccountLogoutPayload>;
  /** Mute an account on Metafy. Muted accounts won't be able to reply to or see your posts */
  accountMute: Maybe<AccountMutePayload>;
  /** Remove a notification */
  accountNotificationDelete: Maybe<AccountNotificationDeletePayload>;
  /** Mark all notifications as read */
  accountNotificationMarkAllRead: Maybe<AccountNotificationMarkAllReadPayload>;
  /** Mark all notifications as seen */
  accountNotificationMarkAllSeen: Maybe<AccountNotificationMarkAllSeenPayload>;
  /** Mark a single notification as read */
  accountNotificationMarkRead: Maybe<AccountNotificationMarkReadPayload>;
  /** Update your notification settings */
  accountNotificationSettingsEdit: Maybe<AccountNotificationSettingsEditPayload>;
  /** Register a device for Web Push notifications */
  accountNotificationWebPushRegister: Maybe<AccountNotificationWebPushRegisterPayload>;
  /** Connect your Metafy account with another provider */
  accountOAuthConnect: Maybe<AccountOAuthConnectPayload>;
  /** Disconnect an external account from your Metafy account */
  accountOAuthDisconnect: Maybe<AccountOAuthDisconnectPayload>;
  /** Adds an authenticator to your Metafy account */
  accountOtpCreate: Maybe<AccountOtpCreatePayload>;
  /** Removes an authenticator from your Metafy account */
  accountOtpDelete: Maybe<AccountOtpDeletePayload>;
  /** Returns an OTP secret to add an authenticator to your account */
  accountOtpSetup: Maybe<AccountOtpSetupPayload>;
  /** Verify an OTP code against your account */
  accountOtpVerify: Maybe<AccountOtpVerifyPayload>;
  /** Add a MuxAsset or AccountAttachment to the account overview carousel */
  accountOverviewCarouselCreate: Maybe<AccountOverviewCarouselCreatePayload>;
  /** Remove an item in the account overview carousel */
  accountOverviewCarouselDelete: Maybe<AccountOverviewCarouselDeletePayload>;
  /** Update the position of an item in the account overview carousel */
  accountOverviewCarouselUpdate: Maybe<AccountOverviewCarouselUpdatePayload>;
  /** Updates an account overview */
  accountOverviewUpdate: Maybe<AccountOverviewUpdatePayload>;
  /** Edit your password on Metafy */
  accountPasswordEdit: Maybe<AccountPasswordEditPayload>;
  /** Regenerate up to 5 new recovery codes for your account */
  accountRecoveryCodes: Maybe<AccountRecoveryCodesPayload>;
  /** Refresh a short-lived access token */
  accountRefreshToken: Maybe<AccountRefreshTokenPayload>;
  /** Reset your password with a valid token */
  accountResetPassword: Maybe<AccountResetPasswordPayload>;
  /** Request an email to reset your account password */
  accountResetPasswordRequest: Maybe<AccountResetPasswordRequestPayload>;
  /** Removes an active session from your account */
  accountSessionRemove: Maybe<AccountSessionRemovePayload>;
  /** Verify your email with a valid token */
  accountVerifyEmail: Maybe<AccountVerifyEmailPayload>;
  /** Request another verification email */
  accountVerifyEmailResend: Maybe<AccountVerifyEmailResendPayload>;
  /** Create an API key associated with your account */
  apiKeyCreate: Maybe<ApiKeyCreatePayload>;
  /** Delete an API key associated with your account */
  apiKeyDelete: Maybe<ApiKeyDeletePayload>;
  /** Update an API key associated with your account */
  apiKeyUpdate: Maybe<ApiKeyUpdatePayload>;
  /** Add billing info to your account */
  billingCreate: Maybe<BillingCreatePayload>;
  /** Remove billing info from your account */
  billingDelete: Maybe<BillingDeletePayload>;
  /** Preview a block layout block */
  blockLayoutBlockPreview: Maybe<BlockLayoutBlockPreviewPayload>;
  /** Update a block layout */
  blockLayoutUpdate: Maybe<BlockLayoutUpdatePayload>;
  /** Mark a change log as seen */
  changeLogSeen: Maybe<ChangeLogSeenPayload>;
  /** Mark all messages as read for a Chat Room */
  chatMarkRead: Maybe<ChatMarkReadPayload>;
  /** Delete one of your own chat messages */
  chatMessageDelete: Maybe<ChatMessageDeletePayload>;
  /** Like a chat message */
  chatMessageLike: Maybe<ChatMessageLikePayload>;
  /** Mark a question message as answered */
  chatMessageMarkAnswered: Maybe<ChatMessageMarkAnsweredPayload>;
  /** Send a direct message to another user or chat room */
  chatMessageSend: Maybe<ChatMessageSendPayload>;
  /** Unlike a chat message */
  chatMessageUnlike: Maybe<ChatMessageUnlikePayload>;
  /** React to a message with an emote */
  chatReactionCreate: Maybe<ChatReactionCreatePayload>;
  /** Remove a reaction of yours */
  chatReactionDelete: Maybe<ChatReactionDeletePayload>;
  /** Answer an intake question for a coaching product */
  coachingIntakeQuestionAnswer: Maybe<CoachingIntakeQuestionAnswerPayload>;
  /** Accept a coaching session for a coaching product */
  coachingSessionAccept: Maybe<CoachingSessionAcceptPayload>;
  /** Accept a rescheduled coaching session for a coaching product */
  coachingSessionAcceptReschedule: Maybe<CoachingSessionAcceptReschedulePayload>;
  /** Cancel a coaching session for a coaching product */
  coachingSessionCancel: Maybe<CoachingSessionCancelPayload>;
  /** Request to reschedule a coaching session for a coaching product */
  coachingSessionRequestReschedule: Maybe<CoachingSessionRequestReschedulePayload>;
  /** Schedule a coaching session for a coaching product */
  coachingSessionSchedule: Maybe<CoachingSessionSchedulePayload>;
  couponCreate: Maybe<CouponCreatePayload>;
  couponDelete: Maybe<CouponDeletePayload>;
  couponUpdate: Maybe<CouponUpdatePayload>;
  /** Refresh the roles for a Discord server */
  discordRefreshRoles: Maybe<DiscordRefreshRolesPayload>;
  /** Request an invite to the Discord server */
  discordRequestInvite: Maybe<DiscordRequestInvitePayload>;
  /** Sync roles for a Group member or Metafy partner */
  discordSyncRoles: Maybe<DiscordSyncRolesPayload>;
  /** Update a Discord guild */
  discordUpdate: Maybe<DiscordUpdatePayload>;
  /** Create an announcement */
  feedAnnouncementCreate: Maybe<FeedAnnouncementCreatePayload>;
  /** Remove an announcement */
  feedAnnouncementDelete: Maybe<FeedAnnouncementDeletePayload>;
  /** Dismiss an announcement from showing */
  feedAnnouncementDismiss: Maybe<FeedAnnouncementDismissPayload>;
  /** Hide announcements from showing until the next new announcement */
  feedAnnouncementsHide: Maybe<FeedAnnouncementsHidePayload>;
  /** Vote on a poll within a post */
  feedPollVote: Maybe<FeedPollVotePayload>;
  /** Create a post on the feed */
  feedPostCreate: Maybe<FeedPostCreatePayload>;
  /** Delete a post */
  feedPostDelete: Maybe<FeedPostDeletePayload>;
  /** Edit a post */
  feedPostEdit: Maybe<FeedPostEditPayload>;
  /** Pin a post to a group feed */
  feedPostPin: Maybe<FeedPostPinPayload>;
  /** Unpin a pinned post */
  feedPostUnpin: Maybe<FeedPostUnpinPayload>;
  /** Add a reaction to a post */
  feedReactionCreate: Maybe<FeedReactionCreatePayload>;
  /** Remove a reaction of yours */
  feedReactionDelete: Maybe<FeedReactionDeletePayload>;
  /** Vote on a top-level feed post */
  feedVoteCreate: Maybe<FeedVoteCreatePayload>;
  /** Remove a vote from a top-level post */
  feedVoteDelete: Maybe<FeedVoteDeletePayload>;
  /** Follow a game community on Metafy */
  gameFollowCreate: Maybe<GameFollowCreatePayload>;
  /** Unfollow a game community on Metafy */
  gameFollowDelete: Maybe<GameFollowDeletePayload>;
  /** Redeem a gift card */
  giftCardRedeem: Maybe<GiftCardRedeemPayload>;
  /** Send a purchased gift card to a recipient */
  giftCardSend: Maybe<GiftCardSendPayload>;
  /** Edit a Google account associated with the current user */
  googleEdit: Maybe<GoogleEditPayload>;
  /** Ban a user from a group you moderate */
  groupBanCreate: Maybe<GroupBanCreatePayload>;
  /** Unban a user from a group you moderate */
  groupBanDelete: Maybe<GroupBanDeletePayload>;
  /** Create a channel for a group */
  groupChannelCreate: Maybe<GroupChannelCreatePayload>;
  /** Remove a channel from a group */
  groupChannelDelete: Maybe<GroupChannelDeletePayload>;
  /** Edit a channel for a group that you administrate */
  groupChannelEdit: Maybe<GroupChannelEditPayload>;
  /** Edit a group on Metafy */
  groupEdit: Maybe<GroupEditPayload>;
  /** Joins a public group */
  groupJoin: Maybe<GroupJoinPayload>;
  /** Leave a group you are a member of */
  groupLeave: Maybe<GroupLeavePayload>;
  /** Remove a member from a group */
  groupMemberDelete: Maybe<GroupMemberDeletePayload>;
  /** Update the role of a group member */
  groupMemberEdit: Maybe<GroupMemberEditPayload>;
  /** Extend a subscription for a group member for their current tier */
  groupMemberExtendSubscription: Maybe<GroupMemberExtendSubscriptionPayload>;
  /** Accept an invite to join a group as a team member */
  groupTeamMemberAccept: Maybe<GroupTeamMemberAcceptPayload>;
  /** Add a team member to a group */
  groupTeamMemberAdd: Maybe<GroupTeamMemberAddPayload>;
  /** Reject an invite to join a group as a team member */
  groupTeamMemberReject: Maybe<GroupTeamMemberRejectPayload>;
  /** Remove a team member from a group */
  groupTeamMemberRemove: Maybe<GroupTeamMemberRemovePayload>;
  /** Update a team member's attributes in a group */
  groupTeamMemberUpdate: Maybe<GroupTeamMemberUpdatePayload>;
  /** Create a new benefit for an existing tier */
  groupTierBenefitCreate: Maybe<GroupTierBenefitCreatePayload>;
  /** Remove a benefit associated with a group tier */
  groupTierBenefitDelete: Maybe<GroupTierBenefitDeletePayload>;
  /** Edit a benefit associated with a group tier */
  groupTierBenefitEdit: Maybe<GroupTierBenefitEditPayload>;
  /** Enable access to a group channel for a tier */
  groupTierChannelCreate: Maybe<GroupTierChannelCreatePayload>;
  /** Remove access to a group channel for a tier */
  groupTierChannelDelete: Maybe<GroupTierChannelDeletePayload>;
  /** Create a tier for your Group */
  groupTierCreate: Maybe<GroupTierCreatePayload>;
  /** Remove a tier from your Group */
  groupTierDelete: Maybe<GroupTierDeletePayload>;
  /** Edit a tier from your Group */
  groupTierEdit: Maybe<GroupTierEditPayload>;
  /** Mark a chapter as complete or incomplete */
  guideChapterComplete: Maybe<GuideChapterCompletePayload>;
  /** Cancel a legacy subscription on Metafy */
  legacySubscriptionCancel: Maybe<LegacySubscriptionCancelPayload>;
  /** Create a new Mux asset */
  muxAssetCreate: Maybe<MuxAssetCreatePayload>;
  /** Update a new Mux asset */
  muxAssetUpdate: Maybe<MuxAssetUpdatePayload>;
  /** Track a view of a Mux asset */
  muxAssetViewTrack: Maybe<MuxAssetViewTrackPayload>;
  /** Create an OAuth application associated with your account */
  oauthApplicationCreate: Maybe<OAuthApplicationCreatePayload>;
  /** Delete an OAuth application associated with your account */
  oauthApplicationDelete: Maybe<OAuthApplicationDeletePayload>;
  /** Update an OAuth application associated with your account */
  oauthApplicationUpdate: Maybe<OAuthApplicationUpdatePayload>;
  /** Edit the discounts on a Patreon tier for a Patreon supporter */
  patreonTierEdit: Maybe<PatreonTierEditPayload>;
  /** Connect a Paypal email address to the current account */
  paypalCreate: Maybe<PaypalCreatePayload>;
  /** Remove a Paypal email address from the current account */
  paypalDelete: Maybe<PaypalDeletePayload>;
  /** Add an addon to a product on Metafy */
  productAddonCreate: Maybe<ProductAddonCreatePayload>;
  /** Remove an addon from a product on Metafy */
  productAddonDelete: Maybe<ProductAddonDeletePayload>;
  /** Update an addon from a product on Metafy */
  productAddonUpdate: Maybe<ProductAddonUpdatePayload>;
  /** Create a new coaching product on Metafy */
  productCoachingCreate: Maybe<ProductCoachingCreatePayload>;
  /** Remove a coaching product from Metafy */
  productCoachingDelete: Maybe<ProductCoachingDeletePayload>;
  /** Add an intake question to a coaching product on Metafy */
  productCoachingIntakeQuestionCreate: Maybe<ProductCoachingIntakeQuestionCreatePayload>;
  /** Delete an intake question from a coaching product on Metafy */
  productCoachingIntakeQuestionDelete: Maybe<ProductCoachingIntakeQuestionDeletePayload>;
  /** Update an intake question on a coaching product on Metafy */
  productCoachingIntakeQuestionUpdate: Maybe<ProductCoachingIntakeQuestionUpdatePayload>;
  /** Add a session to a coaching product on Metafy */
  productCoachingSessionCreate: Maybe<ProductCoachingSessionCreatePayload>;
  /** Remove a session from a coaching product on Metafy */
  productCoachingSessionDelete: Maybe<ProductCoachingSessionDeletePayload>;
  /** Update an existing coaching product session on Metafy */
  productCoachingSessionUpdate: Maybe<ProductCoachingSessionUpdatePayload>;
  /** Update an existing coaching product on Metafy */
  productCoachingUpdate: Maybe<ProductCoachingUpdatePayload>;
  /** Cancels an upcoming event */
  productEventCancel: Maybe<ProductEventCancelPayload>;
  /** Create a new event */
  productEventCreate: Maybe<ProductEventCreatePayload>;
  /** Ends a live event */
  productEventEndLive: Maybe<ProductEventEndLivePayload>;
  /** Extends an ongoing event by 30 minutes */
  productEventExtend: Maybe<ProductEventExtendPayload>;
  /** Starts a live event */
  productEventGoLive: Maybe<ProductEventGoLivePayload>;
  /** Update an upcoming event */
  productEventUpdate: Maybe<ProductEventUpdatePayload>;
  /** Updates your role in the call */
  productEventUpdateRole: Maybe<ProductEventUpdateRolePayload>;
  /** Flag a product as featured */
  productFeature: Maybe<ProductFeaturePayload>;
  /** Archive a guide for a product */
  productGuideArchive: Maybe<ProductGuideArchivePayload>;
  /** Accept or decline a request to become an author of a guide */
  productGuideAuthorRequestUpdate: Maybe<ProductGuideAuthorRequestUpdatePayload>;
  /** Update a chapter within a guide */
  productGuideChangelogUpdate: Maybe<ProductGuideChangelogUpdatePayload>;
  /** Create a new chapter within a guide */
  productGuideChapterCreate: Maybe<ProductGuideChapterCreatePayload>;
  /** Remove a chapter from a guide */
  productGuideChapterRemove: Maybe<ProductGuideChapterRemovePayload>;
  /** Update a chapter within a guide */
  productGuideChapterUpdate: Maybe<ProductGuideChapterUpdatePayload>;
  /** Create a new guide */
  productGuideCreate: Maybe<ProductGuideCreatePayload>;
  /** Create a new draft of an existing guide */
  productGuideCreateDraft: Maybe<ProductGuideCreateDraftPayload>;
  /** Delete a draft guide for a product */
  productGuideDeleteDraft: Maybe<ProductGuideDeleteDraftPayload>;
  /** Duplicate an existing guide */
  productGuideDuplicate: Maybe<ProductGuideDuplicatePayload>;
  /** Publish a new guide or latest draft guide for a product */
  productGuidePublish: Maybe<ProductGuidePublishPayload>;
  /** Unarchive a guide for a product */
  productGuideUnarchive: Maybe<ProductGuideUnarchivePayload>;
  /** Unpublish a guide for a product */
  productGuideUnpublish: Maybe<ProductGuideUnpublishPayload>;
  /** Update a guide */
  productGuideUpdate: Maybe<ProductGuideUpdatePayload>;
  /** Add a pricing option to a product */
  productPricingOptionCreate: Maybe<ProductPricingOptionCreatePayload>;
  /** Remove a pricing option from a product */
  productPricingOptionDelete: Maybe<ProductPricingOptionDeletePayload>;
  /** Update a pricing option on a product */
  productPricingOptionUpdate: Maybe<ProductPricingOptionUpdatePayload>;
  /** Add a unified tag to a product on Metafy */
  productUnifiedTagAdd: Maybe<ProductUnifiedTagAddPayload>;
  /** Remove a unified tag from a product on Metafy */
  productUnifiedTagRemove: Maybe<ProductUnifiedTagRemovePayload>;
  /** Edit a products visibility settings */
  productVisibilityEdit: Maybe<ProductVisibilityEditPayload>;
  /** Remove a product from being visible in a group */
  productVisibilityRemove: Maybe<ProductVisibilityRemovePayload>;
  /** Create a new purchase on Metafy */
  purchaseCreate: Maybe<PurchaseCreatePayload>;
  /** Preview a new purchase on Metafy */
  purchasePreview: Maybe<PurchasePreviewPayload>;
  /** Preview a new reschedule purchase */
  purchaseProductCoachingSessionReschedulePreview: Maybe<PurchaseProductCoachingSessionReschedulePreviewPayload>;
  /** Refund a product purchase on Metafy */
  purchaseProductRefund: Maybe<PurchaseProductRefundPayload>;
  /** Track a referral click */
  referralClickTrack: Maybe<ReferralClickTrackPayload>;
  /** Report a record on Metafy to Metafy staff */
  report: Maybe<ReportPayload>;
  saleCreate: Maybe<SaleCreatePayload>;
  saleDelete: Maybe<SaleDeletePayload>;
  saleUpdate: Maybe<SaleUpdatePayload>;
  /** Create a mfy.gg short link */
  shortLinkCreate: Maybe<ShortLinkCreatePayload>;
  /** Remove a mfy.gg short link that you've created */
  shortLinkDelete: Maybe<ShortLinkDeletePayload>;
  /** Cancel a subscription on Metafy */
  subscriptionCancel: Maybe<SubscriptionCancelPayload>;
  /** Provide feedback for a canceled subscription on Metafy */
  subscriptionCancelationFeedback: Maybe<SubscriptionCancelationFeedbackPayload>;
  /** Cancel a pending downgrade of a community subscription */
  subscriptionDowngradeCancel: Maybe<SubscriptionDowngradeCancelPayload>;
  /** Downgrade a community subscription to a lower tier */
  subscriptionDowngradeTier: Maybe<SubscriptionDowngradeTierPayload>;
  /** Reactive a canceled subscription on Metafy */
  subscriptionReactivate: Maybe<SubscriptionReactivatePayload>;
  /** Create a new testimonial */
  testimonialCreate: Maybe<TestimonialCreatePayload>;
  /** Edit a testimonial that you've received */
  testimonialEdit: Maybe<TestimonialEditPayload>;
  /** Remove a request to leave a testimonial */
  testimonialRequestDelete: Maybe<TestimonialRequestDeletePayload>;
  /** Edit the discounts for a Twitch subscriber */
  twitchEdit: Maybe<TwitchEditPayload>;
  walletPayoutRequestCreate: Maybe<WalletPayoutRequestCreatePayload>;
};

export type Api_MutationAccountAchievementCreateArgs = {
  input: AccountAchievementCreateInput;
};

export type Api_MutationAccountAchievementDeleteArgs = {
  input: AccountAchievementDeleteInput;
};

export type Api_MutationAccountAchievementUpdateArgs = {
  input: AccountAchievementUpdateInput;
};

export type Api_MutationAccountAttachmentCreateArgs = {
  input: AccountAttachmentCreateInput;
};

export type Api_MutationAccountBlockLayoutBlockPreviewArgs = {
  input: AccountBlockLayoutBlockPreviewInput;
};

export type Api_MutationAccountBlockLayoutUpdateArgs = {
  input: AccountBlockLayoutUpdateInput;
};

export type Api_MutationAccountCancelationPolicyUpdateArgs = {
  input: AccountCancelationPolicyUpdateInput;
};

export type Api_MutationAccountCommunitiesEditArgs = {
  input: AccountCommunitiesEditInput;
};

export type Api_MutationAccountConfirmEmailArgs = {
  input: AccountConfirmEmailInput;
};

export type Api_MutationAccountCreateArgs = {
  input: AccountCreateInput;
};

export type Api_MutationAccountCustomerUpdateArgs = {
  input: AccountCustomerUpdateInput;
};

export type Api_MutationAccountEditArgs = {
  input: AccountEditInput;
};

export type Api_MutationAccountFaqCreateArgs = {
  input: AccountFaqCreateInput;
};

export type Api_MutationAccountFaqDeleteArgs = {
  input: AccountFaqDeleteInput;
};

export type Api_MutationAccountFaqUpdateArgs = {
  input: AccountFaqUpdateInput;
};

export type Api_MutationAccountFollowCreateArgs = {
  input: AccountFollowCreateInput;
};

export type Api_MutationAccountFollowDeleteArgs = {
  input: AccountFollowDeleteInput;
};

export type Api_MutationAccountLoginArgs = {
  input: AccountLoginInput;
};

export type Api_MutationAccountMuteArgs = {
  input: AccountMuteInput;
};

export type Api_MutationAccountNotificationDeleteArgs = {
  input: AccountNotificationDeleteInput;
};

export type Api_MutationAccountNotificationMarkReadArgs = {
  input: AccountNotificationMarkReadInput;
};

export type Api_MutationAccountNotificationSettingsEditArgs = {
  input: AccountNotificationSettingsEditInput;
};

export type Api_MutationAccountNotificationWebPushRegisterArgs = {
  input: AccountNotificationWebPushRegisterInput;
};

export type Api_MutationAccountOAuthConnectArgs = {
  input: AccountOAuthConnectInput;
};

export type Api_MutationAccountOAuthDisconnectArgs = {
  input: AccountOAuthDisconnectInput;
};

export type Api_MutationAccountOtpCreateArgs = {
  input: AccountOtpCreateInput;
};

export type Api_MutationAccountOtpDeleteArgs = {
  input: AccountOtpDeleteInput;
};

export type Api_MutationAccountOtpVerifyArgs = {
  input: AccountOtpVerifyInput;
};

export type Api_MutationAccountOverviewCarouselCreateArgs = {
  input: AccountOverviewCarouselCreateInput;
};

export type Api_MutationAccountOverviewCarouselDeleteArgs = {
  input: AccountOverviewCarouselDeleteInput;
};

export type Api_MutationAccountOverviewCarouselUpdateArgs = {
  input: AccountOverviewCarouselUpdateInput;
};

export type Api_MutationAccountOverviewUpdateArgs = {
  input: AccountOverviewUpdateInput;
};

export type Api_MutationAccountPasswordEditArgs = {
  input: AccountPasswordEditInput;
};

export type Api_MutationAccountRecoveryCodesArgs = {
  input: AccountRecoveryCodesInput;
};

export type Api_MutationAccountRefreshTokenArgs = {
  input: AccountRefreshTokenInput;
};

export type Api_MutationAccountResetPasswordArgs = {
  input: AccountResetPasswordInput;
};

export type Api_MutationAccountResetPasswordRequestArgs = {
  input: AccountResetPasswordRequestInput;
};

export type Api_MutationAccountSessionRemoveArgs = {
  input: AccountSessionRemoveInput;
};

export type Api_MutationAccountVerifyEmailArgs = {
  input: AccountVerifyEmailInput;
};

export type Api_MutationApiKeyCreateArgs = {
  input: ApiKeyCreateInput;
};

export type Api_MutationApiKeyDeleteArgs = {
  input: ApiKeyDeleteInput;
};

export type Api_MutationApiKeyUpdateArgs = {
  input: ApiKeyUpdateInput;
};

export type Api_MutationBillingCreateArgs = {
  input: BillingCreateInput;
};

export type Api_MutationBlockLayoutBlockPreviewArgs = {
  input: BlockLayoutBlockPreviewInput;
};

export type Api_MutationBlockLayoutUpdateArgs = {
  input: BlockLayoutUpdateInput;
};

export type Api_MutationChangeLogSeenArgs = {
  input: ChangeLogSeenInput;
};

export type Api_MutationChatMarkReadArgs = {
  input: ChatMarkReadInput;
};

export type Api_MutationChatMessageDeleteArgs = {
  input: ChatMessageDeleteInput;
};

export type Api_MutationChatMessageLikeArgs = {
  input: ChatMessageLikeInput;
};

export type Api_MutationChatMessageMarkAnsweredArgs = {
  input: ChatMessageMarkAnsweredInput;
};

export type Api_MutationChatMessageSendArgs = {
  input: ChatMessageSendInput;
};

export type Api_MutationChatMessageUnlikeArgs = {
  input: ChatMessageUnlikeInput;
};

export type Api_MutationChatReactionCreateArgs = {
  input: ChatReactionCreateInput;
};

export type Api_MutationChatReactionDeleteArgs = {
  input: ChatReactionDeleteInput;
};

export type Api_MutationCoachingIntakeQuestionAnswerArgs = {
  input: CoachingIntakeQuestionAnswerInput;
};

export type Api_MutationCoachingSessionAcceptArgs = {
  input: CoachingSessionAcceptInput;
};

export type Api_MutationCoachingSessionAcceptRescheduleArgs = {
  input: CoachingSessionAcceptRescheduleInput;
};

export type Api_MutationCoachingSessionCancelArgs = {
  input: CoachingSessionCancelInput;
};

export type Api_MutationCoachingSessionRequestRescheduleArgs = {
  input: CoachingSessionRequestRescheduleInput;
};

export type Api_MutationCoachingSessionScheduleArgs = {
  input: CoachingSessionScheduleInput;
};

export type Api_MutationCouponCreateArgs = {
  input: CouponCreateInput;
};

export type Api_MutationCouponDeleteArgs = {
  input: CouponDeleteInput;
};

export type Api_MutationCouponUpdateArgs = {
  input: CouponUpdateInput;
};

export type Api_MutationDiscordRefreshRolesArgs = {
  input: DiscordRefreshRolesInput;
};

export type Api_MutationDiscordRequestInviteArgs = {
  input: DiscordRequestInviteInput;
};

export type Api_MutationDiscordSyncRolesArgs = {
  input: DiscordSyncRolesInput;
};

export type Api_MutationDiscordUpdateArgs = {
  input: DiscordUpdateInput;
};

export type Api_MutationFeedAnnouncementCreateArgs = {
  input: FeedAnnouncementCreateInput;
};

export type Api_MutationFeedAnnouncementDeleteArgs = {
  input: FeedAnnouncementDeleteInput;
};

export type Api_MutationFeedAnnouncementDismissArgs = {
  input: FeedAnnouncementDismissInput;
};

export type Api_MutationFeedPollVoteArgs = {
  input: FeedPollVoteInput;
};

export type Api_MutationFeedPostCreateArgs = {
  input: FeedPostCreateInput;
};

export type Api_MutationFeedPostDeleteArgs = {
  input: FeedPostDeleteInput;
};

export type Api_MutationFeedPostEditArgs = {
  input: FeedPostEditInput;
};

export type Api_MutationFeedPostPinArgs = {
  input: FeedPostPinInput;
};

export type Api_MutationFeedPostUnpinArgs = {
  input: FeedPostUnpinInput;
};

export type Api_MutationFeedReactionCreateArgs = {
  input: FeedReactionCreateInput;
};

export type Api_MutationFeedReactionDeleteArgs = {
  input: FeedReactionDeleteInput;
};

export type Api_MutationFeedVoteCreateArgs = {
  input: FeedVoteCreateInput;
};

export type Api_MutationFeedVoteDeleteArgs = {
  input: FeedVoteDeleteInput;
};

export type Api_MutationGameFollowCreateArgs = {
  input: GameFollowCreateInput;
};

export type Api_MutationGameFollowDeleteArgs = {
  input: GameFollowDeleteInput;
};

export type Api_MutationGiftCardRedeemArgs = {
  input: GiftCardRedeemInput;
};

export type Api_MutationGiftCardSendArgs = {
  input: GiftCardSendInput;
};

export type Api_MutationGoogleEditArgs = {
  input: GoogleEditInput;
};

export type Api_MutationGroupBanCreateArgs = {
  input: GroupBanCreateInput;
};

export type Api_MutationGroupBanDeleteArgs = {
  input: GroupBanDeleteInput;
};

export type Api_MutationGroupChannelCreateArgs = {
  input: GroupChannelCreateInput;
};

export type Api_MutationGroupChannelDeleteArgs = {
  input: GroupChannelDeleteInput;
};

export type Api_MutationGroupChannelEditArgs = {
  input: GroupChannelEditInput;
};

export type Api_MutationGroupEditArgs = {
  input: GroupEditInput;
};

export type Api_MutationGroupJoinArgs = {
  input: GroupJoinInput;
};

export type Api_MutationGroupLeaveArgs = {
  input: GroupLeaveInput;
};

export type Api_MutationGroupMemberDeleteArgs = {
  input: GroupMemberDeleteInput;
};

export type Api_MutationGroupMemberEditArgs = {
  input: GroupMemberEditInput;
};

export type Api_MutationGroupMemberExtendSubscriptionArgs = {
  input: GroupMemberExtendSubscriptionInput;
};

export type Api_MutationGroupTeamMemberAcceptArgs = {
  input: GroupTeamMemberAcceptInput;
};

export type Api_MutationGroupTeamMemberAddArgs = {
  input: GroupTeamMemberAddInput;
};

export type Api_MutationGroupTeamMemberRejectArgs = {
  input: GroupTeamMemberRejectInput;
};

export type Api_MutationGroupTeamMemberRemoveArgs = {
  input: GroupTeamMemberRemoveInput;
};

export type Api_MutationGroupTeamMemberUpdateArgs = {
  input: GroupTeamMemberUpdateInput;
};

export type Api_MutationGroupTierBenefitCreateArgs = {
  input: GroupTierBenefitCreateInput;
};

export type Api_MutationGroupTierBenefitDeleteArgs = {
  input: GroupTierBenefitDeleteInput;
};

export type Api_MutationGroupTierBenefitEditArgs = {
  input: GroupTierBenefitEditInput;
};

export type Api_MutationGroupTierChannelCreateArgs = {
  input: GroupTierChannelCreateInput;
};

export type Api_MutationGroupTierChannelDeleteArgs = {
  input: GroupTierChannelDeleteInput;
};

export type Api_MutationGroupTierCreateArgs = {
  input: GroupTierCreateInput;
};

export type Api_MutationGroupTierDeleteArgs = {
  input: GroupTierDeleteInput;
};

export type Api_MutationGroupTierEditArgs = {
  input: GroupTierEditInput;
};

export type Api_MutationGuideChapterCompleteArgs = {
  input: GuideChapterCompleteInput;
};

export type Api_MutationLegacySubscriptionCancelArgs = {
  input: LegacySubscriptionCancelInput;
};

export type Api_MutationMuxAssetCreateArgs = {
  input: MuxAssetCreateInput;
};

export type Api_MutationMuxAssetUpdateArgs = {
  input: MuxAssetUpdateInput;
};

export type Api_MutationMuxAssetViewTrackArgs = {
  input: MuxAssetViewTrackInput;
};

export type Api_MutationOauthApplicationCreateArgs = {
  input: OAuthApplicationCreateInput;
};

export type Api_MutationOauthApplicationDeleteArgs = {
  input: OAuthApplicationDeleteInput;
};

export type Api_MutationOauthApplicationUpdateArgs = {
  input: OAuthApplicationUpdateInput;
};

export type Api_MutationPatreonTierEditArgs = {
  input: PatreonTierEditInput;
};

export type Api_MutationPaypalCreateArgs = {
  input: PaypalCreateInput;
};

export type Api_MutationProductAddonCreateArgs = {
  input: ProductAddonCreateInput;
};

export type Api_MutationProductAddonDeleteArgs = {
  input: ProductAddonDeleteInput;
};

export type Api_MutationProductAddonUpdateArgs = {
  input: ProductAddonUpdateInput;
};

export type Api_MutationProductCoachingCreateArgs = {
  input: ProductCoachingCreateInput;
};

export type Api_MutationProductCoachingDeleteArgs = {
  input: ProductCoachingDeleteInput;
};

export type Api_MutationProductCoachingIntakeQuestionCreateArgs = {
  input: ProductCoachingIntakeQuestionCreateInput;
};

export type Api_MutationProductCoachingIntakeQuestionDeleteArgs = {
  input: ProductCoachingIntakeQuestionDeleteInput;
};

export type Api_MutationProductCoachingIntakeQuestionUpdateArgs = {
  input: ProductCoachingIntakeQuestionUpdateInput;
};

export type Api_MutationProductCoachingSessionCreateArgs = {
  input: ProductCoachingSessionCreateInput;
};

export type Api_MutationProductCoachingSessionDeleteArgs = {
  input: ProductCoachingSessionDeleteInput;
};

export type Api_MutationProductCoachingSessionUpdateArgs = {
  input: ProductCoachingSessionUpdateInput;
};

export type Api_MutationProductCoachingUpdateArgs = {
  input: ProductCoachingUpdateInput;
};

export type Api_MutationProductEventCancelArgs = {
  input: ProductEventCancelInput;
};

export type Api_MutationProductEventCreateArgs = {
  input: ProductEventCreateInput;
};

export type Api_MutationProductEventEndLiveArgs = {
  input: ProductEventEndLiveInput;
};

export type Api_MutationProductEventExtendArgs = {
  input: ProductEventExtendInput;
};

export type Api_MutationProductEventGoLiveArgs = {
  input: ProductEventGoLiveInput;
};

export type Api_MutationProductEventUpdateArgs = {
  input: ProductEventUpdateInput;
};

export type Api_MutationProductEventUpdateRoleArgs = {
  input: ProductEventUpdateRoleInput;
};

export type Api_MutationProductFeatureArgs = {
  input: ProductFeatureInput;
};

export type Api_MutationProductGuideArchiveArgs = {
  input: ProductGuideArchiveInput;
};

export type Api_MutationProductGuideAuthorRequestUpdateArgs = {
  input: ProductGuideAuthorRequestUpdateInput;
};

export type Api_MutationProductGuideChangelogUpdateArgs = {
  input: ProductGuideChangelogUpdateInput;
};

export type Api_MutationProductGuideChapterCreateArgs = {
  input: ProductGuideChapterCreateInput;
};

export type Api_MutationProductGuideChapterRemoveArgs = {
  input: ProductGuideChapterRemoveInput;
};

export type Api_MutationProductGuideChapterUpdateArgs = {
  input: ProductGuideChapterUpdateInput;
};

export type Api_MutationProductGuideCreateArgs = {
  input: ProductGuideCreateInput;
};

export type Api_MutationProductGuideCreateDraftArgs = {
  input: ProductGuideCreateDraftInput;
};

export type Api_MutationProductGuideDeleteDraftArgs = {
  input: ProductGuideDeleteDraftInput;
};

export type Api_MutationProductGuideDuplicateArgs = {
  input: ProductGuideDuplicateInput;
};

export type Api_MutationProductGuidePublishArgs = {
  input: ProductGuidePublishInput;
};

export type Api_MutationProductGuideUnarchiveArgs = {
  input: ProductGuideUnarchiveInput;
};

export type Api_MutationProductGuideUnpublishArgs = {
  input: ProductGuideUnpublishInput;
};

export type Api_MutationProductGuideUpdateArgs = {
  input: ProductGuideUpdateInput;
};

export type Api_MutationProductPricingOptionCreateArgs = {
  input: ProductPricingOptionCreateInput;
};

export type Api_MutationProductPricingOptionDeleteArgs = {
  input: ProductPricingOptionDeleteInput;
};

export type Api_MutationProductPricingOptionUpdateArgs = {
  input: ProductPricingOptionUpdateInput;
};

export type Api_MutationProductUnifiedTagAddArgs = {
  input: ProductUnifiedTagAddInput;
};

export type Api_MutationProductUnifiedTagRemoveArgs = {
  input: ProductUnifiedTagRemoveInput;
};

export type Api_MutationProductVisibilityEditArgs = {
  input: ProductVisibilityEditInput;
};

export type Api_MutationProductVisibilityRemoveArgs = {
  input: ProductVisibilityRemoveInput;
};

export type Api_MutationPurchaseCreateArgs = {
  input: PurchaseCreateInput;
};

export type Api_MutationPurchasePreviewArgs = {
  input: PurchasePreviewInput;
};

export type Api_MutationPurchaseProductCoachingSessionReschedulePreviewArgs = {
  input: PurchaseProductCoachingSessionReschedulePreviewInput;
};

export type Api_MutationPurchaseProductRefundArgs = {
  input: PurchaseProductRefundInput;
};

export type Api_MutationReferralClickTrackArgs = {
  input: ReferralClickTrackInput;
};

export type Api_MutationReportArgs = {
  input: ReportInput;
};

export type Api_MutationSaleCreateArgs = {
  input: SaleCreateInput;
};

export type Api_MutationSaleDeleteArgs = {
  input: SaleDeleteInput;
};

export type Api_MutationSaleUpdateArgs = {
  input: SaleUpdateInput;
};

export type Api_MutationShortLinkCreateArgs = {
  input: ShortLinkCreateInput;
};

export type Api_MutationShortLinkDeleteArgs = {
  input: ShortLinkDeleteInput;
};

export type Api_MutationSubscriptionCancelArgs = {
  input: SubscriptionCancelInput;
};

export type Api_MutationSubscriptionCancelationFeedbackArgs = {
  input: SubscriptionCancelationFeedbackInput;
};

export type Api_MutationSubscriptionDowngradeCancelArgs = {
  input: SubscriptionDowngradeCancelInput;
};

export type Api_MutationSubscriptionDowngradeTierArgs = {
  input: SubscriptionDowngradeTierInput;
};

export type Api_MutationSubscriptionReactivateArgs = {
  input: SubscriptionReactivateInput;
};

export type Api_MutationTestimonialCreateArgs = {
  input: TestimonialCreateInput;
};

export type Api_MutationTestimonialEditArgs = {
  input: TestimonialEditInput;
};

export type Api_MutationTestimonialRequestDeleteArgs = {
  input: TestimonialRequestDeleteInput;
};

export type Api_MutationTwitchEditArgs = {
  input: TwitchEditInput;
};

export type Api_MutationWalletPayoutRequestCreateArgs = {
  input: WalletPayoutRequestCreateInput;
};

export type Api_MutedAccount = WithTimestamps & {
  __typename?: 'API_MutedAccount';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  target: Api_Account;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_MutedAccount. */
export type Api_MutedAccountConnection = {
  __typename?: 'API_MutedAccountConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_MutedAccountEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_MutedAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_MutedAccountEdge = {
  __typename?: 'API_MutedAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_MutedAccount>;
};

export type Api_MuxAsset = WithTimestamps & {
  __typename?: 'API_MuxAsset';
  account: Api_Account;
  assetId: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The current timestamp of the requesting user's view of the asset */
  currentTimestamp: Maybe<Scalars['Float']['output']>;
  /** A custom user uploaded thumbnail of the asset */
  customThumbnail: Maybe<Api_Image>;
  durationSeconds: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  originalFilename: Maybe<Scalars['String']['output']>;
  playbackIds: Maybe<Array<Api_MuxPlaybackId>>;
  recordType: MuxRecordEnum;
  sentiment: Maybe<SentimentEnum>;
  signingKey: Maybe<Scalars['String']['output']>;
  status: MuxAssetStatusEnum;
  storyboardSigningKey: Maybe<Scalars['String']['output']>;
  summary: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploadUrl: Maybe<Scalars['String']['output']>;
};

export type Api_MuxAssetThumbnailUrlArgs = {
  endTime: InputMaybe<Scalars['Int']['input']>;
  fps: InputMaybe<Scalars['Int']['input']>;
  height: InputMaybe<Scalars['Int']['input']>;
  startTime: InputMaybe<Scalars['Int']['input']>;
  width: InputMaybe<Scalars['Int']['input']>;
};

export type Api_MuxPlaybackId = {
  __typename?: 'API_MuxPlaybackId';
  id: Scalars['ID']['output'];
  policy: MuxPlaybackPolicyEnum;
};

export type Api_Notification = WithTimestamps & {
  __typename?: 'API_Notification';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Api_NotificationEvent;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  readAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  seenAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  type: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Notification. */
export type Api_NotificationConnection = {
  __typename?: 'API_NotificationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_NotificationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_NotificationEdge = {
  __typename?: 'API_NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Notification>;
};

export type Api_NotificationEvent = WithTimestamps & {
  __typename?: 'API_NotificationEvent';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  notificationsCount: Scalars['Int']['output'];
  params: Scalars['JSON']['output'];
  record: Maybe<NotificationRecordUnion>;
  recordId: Maybe<Scalars['UUID']['output']>;
  recordType: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_NotificationSettings = {
  __typename?: 'API_NotificationSettings';
  discord: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  webPush: Scalars['Boolean']['output'];
};

export type Api_OAuthApplication = {
  __typename?: 'API_OAuthApplication';
  clientId: Scalars['String']['output'];
  clientSecret: Maybe<Scalars['String']['output']>;
  icon: Maybe<Api_Image>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  scopes: Array<ScopeEnum>;
};

export type Api_OpenGraph = {
  __typename?: 'API_OpenGraph';
  /** The description of the page */
  description: Maybe<Scalars['String']['output']>;
  /** The favicon of the page */
  favicon: Maybe<Scalars['String']['output']>;
  /** The image of the page */
  image: Maybe<Scalars['String']['output']>;
  /** The short favicon of the page */
  shortFavicon: Maybe<Scalars['String']['output']>;
  /** The title of the page */
  title: Maybe<Scalars['String']['output']>;
  /** The URL of the page */
  url: Scalars['String']['output'];
};

export type Api_Order = WithTimestamps & {
  __typename?: 'API_Order';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The total amount of discounts applied to the order. */
  discounts: Scalars['Float']['output'];
  /** The total amount of fees applied to the order. */
  fees: Scalars['Float']['output'];
  /** The unique ID of the order. */
  id: Scalars['UUID']['output'];
  /** The items in the order. */
  items: Array<Api_OrderItem>;
  /** The payments made for the order. */
  payments: Array<Api_OrderPayment>;
  /** The payouts made for the order. */
  payouts: Array<Api_OrderPayout>;
  /** The current state of the order. */
  state: OrderStateEnum;
  /** The subtotal of the order. */
  subTotal: Scalars['Float']['output'];
  /** The total amount of taxes applied to the order. */
  taxes: Scalars['Float']['output'];
  /** The total amount of the order. */
  total: Scalars['Float']['output'];
  /** The total amount due for the order after credits are consumed. */
  totalDue: Scalars['Float']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Order. */
export type Api_OrderConnection = {
  __typename?: 'API_OrderConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_OrderEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_OrderEdge = {
  __typename?: 'API_OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Order>;
};

export type Api_OrderItem = WithTimestamps & {
  __typename?: 'API_OrderItem';
  addons: Array<Api_OrderItemAddon>;
  addonsTotal: Scalars['Float']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  discounts: Scalars['Float']['output'];
  feeTotal: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  itemDiscounts: Array<Api_OrderItemDiscount>;
  payouts: Array<Api_OrderPayout>;
  product: Api_PurchasedProduct;
  quantity: Scalars['Int']['output'];
  refundable: Scalars['Boolean']['output'];
  refundableAmount: Api_Money;
  refunded: Api_Money;
  state: OrderItemStateEnum;
  subTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  unitAmount: Scalars['Float']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_OrderItemAddon = WithTimestamps & {
  __typename?: 'API_OrderItemAddon';
  addon: Api_PurchasedProductAddon;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  item: Api_OrderItem;
  itemAddonDiscounts: Array<Api_OrderItemAddonDiscount>;
  total: Scalars['Float']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_OrderItemAddonDiscount = WithTimestamps & {
  __typename?: 'API_OrderItemAddonDiscount';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountAmount: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  discountedTotal: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  originalTotal: Scalars['Float']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_OrderItem. */
export type Api_OrderItemConnection = {
  __typename?: 'API_OrderItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_OrderItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_OrderItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

export type Api_OrderItemDiscount = WithTimestamps & {
  __typename?: 'API_OrderItemDiscount';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountAmount: Scalars['Float']['output'];
  discountType: Scalars['String']['output'];
  discountedTotal: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  originalTotal: Scalars['Float']['output'];
  record: Maybe<OrderItemDiscountRecordUnion>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An edge in a connection. */
export type Api_OrderItemEdge = {
  __typename?: 'API_OrderItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_OrderItem>;
};

export type Api_OrderPayment = WithTimestamps & {
  __typename?: 'API_OrderPayment';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  fees: Scalars['Float']['output'];
  giftCard: Maybe<Api_GiftCard>;
  id: Scalars['UUID']['output'];
  order: Api_Order;
  paymentType: OrderPaymentEnum;
  state: OrderPaymentStateEnum;
  subTotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_OrderPayout = WithTimestamps & {
  __typename?: 'API_OrderPayout';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  order: Maybe<Api_Order>;
  orderItem: Maybe<Api_OrderItem>;
  state: OrderPayoutStateEnum;
  type: OrderPayoutEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  walletTransaction: Maybe<Api_WalletTransaction>;
};

export type Api_OtpSetupCode = {
  __typename?: 'API_OtpSetupCode';
  /** The key to insert into your Authenticator to generate OTP codes */
  key: Scalars['String']['output'];
  /** The internal key representation used when setting up your authenticator with Metafy */
  raw: Scalars['String']['output'];
};

export type Api_PastDue = {
  __typename?: 'API_PastDue';
  amount: Api_Money;
  pastDue: Scalars['Boolean']['output'];
};

export type Api_Patreon = {
  __typename?: 'API_Patreon';
  id: Scalars['UUID']['output'];
  tiers: Array<Api_PatreonTier>;
};

export type Api_PatreonTier = WithDiscounts & {
  __typename?: 'API_PatreonTier';
  amount: Api_Money;
  description: Scalars['String']['output'];
  eventDiscountType: CouponDiscountEnum;
  eventDiscountValue: Scalars['Int']['output'];
  groupTierDiscountType: CouponDiscountEnum;
  groupTierDiscountValue: Scalars['Int']['output'];
  guideDiscountType: CouponDiscountEnum;
  guideDiscountValue: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  sessionDiscountType: CouponDiscountEnum;
  sessionDiscountValue: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** A payment response from a payment gateway */
export type Api_PaymentGatewayResponse = {
  __typename?: 'API_PaymentGatewayResponse';
  code: Maybe<Scalars['String']['output']>;
  customerMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** The 3DSecure token for the payment if additional verification is required */
  secureToken: Maybe<Scalars['String']['output']>;
};

export type Api_PaymentMethod = {
  __typename?: 'API_PaymentMethod';
  /** The type of card (e.g. Visa, Mastercard, etc.) */
  cardType: Maybe<Scalars['String']['output']>;
  /** The expiration month of the card */
  expMonth: Maybe<Scalars['Int']['output']>;
  /** The expiration year of the card */
  expYear: Maybe<Scalars['Int']['output']>;
  /** The first 6 digits of the card */
  firstSix: Maybe<Scalars['String']['output']>;
  /** The last 4 digits of the card */
  lastFour: Maybe<Scalars['String']['output']>;
  /** The last 2 digits of the card */
  lastTwo: Maybe<Scalars['String']['output']>;
  /** The type of payment method (e.g. credit_card, paypal, apple_pay, etc.) */
  type: Maybe<Scalars['String']['output']>;
};

export type Api_Paypal = WithTimestamps & {
  __typename?: 'API_Paypal';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Poll = WithTimestamps & {
  __typename?: 'API_Poll';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  options: Array<Api_PollOption>;
  totalVotes: Scalars['Int']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userVotedFor: Maybe<Scalars['UUID']['output']>;
};

export type Api_PollOption = WithTimestamps & {
  __typename?: 'API_PollOption';
  content: Scalars['String']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  votes: Scalars['Int']['output'];
};

export type Api_Post = WithTimestamps & {
  __typename?: 'API_Post';
  account: Maybe<Api_Account>;
  announcement: Maybe<Api_Announcement>;
  archived: Scalars['Boolean']['output'];
  author: Api_Account;
  content: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  editedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  embedData: Maybe<Api_PostEmbed>;
  game: Maybe<Api_Game>;
  group: Maybe<Api_Group>;
  groupChannel: Maybe<Api_GroupChannel>;
  groupChannelId: Maybe<Scalars['UUID']['output']>;
  groupTierRole: Maybe<Scalars['String']['output']>;
  guideChapter: Maybe<Api_ProductGuideChapter>;
  hasUploads: Scalars['Boolean']['output'];
  /** @deprecated Use `title` instead */
  icebreakerQuestion: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isGated: Scalars['Boolean']['output'];
  isGuideChapter: Scalars['Boolean']['output'];
  isIcebreaker: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isTopLevel: Scalars['Boolean']['output'];
  languageCode: Maybe<Scalars['String']['output']>;
  legacyEditor: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  originalContent: Maybe<Scalars['String']['output']>;
  originalPost: Maybe<Api_Post>;
  parent: Maybe<Api_Post>;
  poll: Maybe<Api_Poll>;
  price: Api_Money;
  product: Maybe<Api_Product>;
  published: Scalars['Boolean']['output'];
  purchasable: Scalars['Boolean']['output'];
  purchasedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  reactionCounts: Array<Api_PostReactionCount>;
  reactions: Api_PostReactionConnection;
  reasonForGate: Maybe<PostGateReasonEnum>;
  replies: Api_PostConnection;
  repliesCount: Scalars['Int']['output'];
  scheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  shareCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  threeReactors: Array<Api_RecentPostReaction>;
  title: Maybe<Scalars['String']['output']>;
  totalReactionCount: Scalars['Int']['output'];
  totalRepliesCount: Scalars['Int']['output'];
  totalVoteCount: Scalars['Int']['output'];
  unifiedTags: Api_UnifiedTagConnection;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploads: Array<Api_PostUpload>;
  userReactions: Array<Api_PostReaction>;
  vote: Maybe<Api_PostVote>;
};

export type Api_PostReactionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PostReactionSortOption>>>;
  type: InputMaybe<ReactionEnum>;
};

export type Api_PostRepliesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PostSortOption>>>;
};

export type Api_PostUnifiedTagsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<UnifiedTagRecordSortOption>>>;
};

/** The connection type for API_Post. */
export type Api_PostConnection = {
  __typename?: 'API_PostConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PostEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PostEdge = {
  __typename?: 'API_PostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Post>;
};

export type Api_PostEmbed = {
  __typename?: 'API_PostEmbed';
  groupId: Maybe<Scalars['String']['output']>;
  kind: PostEmbedEnum;
  muxPlaybackId: Maybe<Scalars['String']['output']>;
  ogData: Maybe<Api_OpenGraph>;
  redditUrl: Maybe<Scalars['String']['output']>;
  spotifyId: Maybe<Scalars['String']['output']>;
  spotifyType: Maybe<Scalars['String']['output']>;
  twitchChannelId: Maybe<Scalars['String']['output']>;
  twitchClipId: Maybe<Scalars['String']['output']>;
  twitchVodId: Maybe<Scalars['String']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
  youtubeId: Maybe<Scalars['String']['output']>;
};

export type Api_PostReaction = WithTimestamps & {
  __typename?: 'API_PostReaction';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  post: Api_Post;
  reactionType: ReactionEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_PostReaction. */
export type Api_PostReactionConnection = {
  __typename?: 'API_PostReactionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PostReactionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PostReaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

export type Api_PostReactionCount = {
  __typename?: 'API_PostReactionCount';
  count: Scalars['Int']['output'];
  reaction: ReactionEnum;
};

/** An edge in a connection. */
export type Api_PostReactionEdge = {
  __typename?: 'API_PostReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PostReaction>;
};

export type Api_PostUpload = {
  __typename?: 'API_PostUpload';
  id: Scalars['UUID']['output'];
  isVideo: Scalars['Boolean']['output'];
  muxAsset: Maybe<Api_MuxAsset>;
  upload: Maybe<Api_Image>;
};

export type Api_PostVote = WithTimestamps & {
  __typename?: 'API_PostVote';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  post: Api_Post;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voteType: PostVoteEnum;
};

export type Api_Product = WithProduct &
  WithTimestamps & {
    __typename?: 'API_Product';
    /** The account that owns the product */
    account: Maybe<Api_Account>;
    accountsRecentlyPurchased: Api_AccountConnection;
    /** The addons for the product */
    addons: Array<Api_ProductAddon>;
    /** Whether the product has addons enabled */
    addonsEnabled: Scalars['Boolean']['output'];
    /** Whether the current account can purchase the product */
    canPurchase: Scalars['Boolean']['output'];
    /** The coaching product */
    coaching: Maybe<Api_ProductCoaching>;
    cover: Maybe<Api_Image>;
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    /** The currency of the product (USD, EUR, etc.) */
    currency: Maybe<Scalars['String']['output']>;
    /** The description of the product */
    description: Maybe<Scalars['String']['output']>;
    /** Whether the product is enabled for purchase */
    enabled: Scalars['Boolean']['output'];
    /** The event associated with the product */
    event: Maybe<Api_ProductEvent>;
    /**
     * Whether the product is featured
     * @deprecated use visabilties.featured instead
     */
    featured: Scalars['Boolean']['output'];
    /** Whether the product is global or offered by an account */
    global: Scalars['Boolean']['output'];
    /** If this product has a group discount (returns highest discount) */
    groupDiscountAvailable: Maybe<Api_GroupDiscount>;
    groupTierBenefits: Api_GroupTierBenefitConnection;
    /** The guide for the product */
    guide: Maybe<Api_ProductGuide>;
    /** Whether the current account has left a testimonial for the product */
    hasLeftTestimonial: Scalars['Boolean']['output'];
    /** The ID of the product */
    id: Scalars['UUID']['output'];
    /** The name of the product */
    name: Scalars['String']['output'];
    /** The price of the product for the current account */
    orderItemForAccount: Maybe<Api_OrderItem>;
    /**
     * The position of the product in the overview list
     * @deprecated use visabilties.overview_position instead
     */
    overviewPosition: Maybe<Scalars['Int']['output']>;
    /** The position of the product in the account's product list */
    position: Maybe<Scalars['Int']['output']>;
    /** The pricing options for the product */
    pricingOptions: Array<Api_ProductPricingOption>;
    /** The type of the product */
    productType: ProductEnum;
    /** The number of times the product has been purchased */
    purchaseCount: Maybe<Scalars['Int']['output']>;
    /** The purchases of the product as a buyer */
    purchasesAsBuyer: Api_PurchasedProductConnection;
    /** The stock keeping unit of the product */
    sku: Maybe<Scalars['String']['output']>;
    /** The slug of the product */
    slug: Maybe<Scalars['String']['output']>;
    /** Whether the current account is subscribed to the product */
    subscribed: Scalars['Boolean']['output'];
    /** Whether the product is only available to supporters */
    supporterOnly: Maybe<Scalars['Boolean']['output']>;
    /** The total revenue generated by the product */
    totalRevenue: Maybe<Scalars['Float']['output']>;
    unifiedTags: Api_UnifiedTagConnection;
    /** Whether the product is unlisted from disovery */
    unlisted: Scalars['Boolean']['output'];
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
    /** The visibility of the product within communties */
    visibilities: Api_ProductVisibilityConnection;
  };

export type Api_ProductAccountsRecentlyPurchasedArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductGroupTierBenefitsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductGuideArgs = {
  mode?: InputMaybe<ProductGuideModeEnum>;
};

export type Api_ProductPurchasesAsBuyerArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductSortOption>>>;
};

export type Api_ProductUnifiedTagsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductVisibilitiesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductAddon = WithProductAddon &
  WithTimestamps & {
    __typename?: 'API_ProductAddon';
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    description: Maybe<Scalars['String']['output']>;
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    price: Maybe<Scalars['Float']['output']>;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type Api_ProductCoaching = WithProductCoaching &
  WithTimestamps & {
    __typename?: 'API_ProductCoaching';
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    durationSeconds: Scalars['Int']['output'];
    game: Maybe<Api_Game>;
    id: Scalars['UUID']['output'];
    intakeQuestions: Array<Api_ProductCoachingIntakeQuestion>;
    intakeQuestionsEnabled: Scalars['Boolean']['output'];
    product: Api_Product;
    scheduler: SchedulerEnum;
    sessionConnection: Api_ProductCoachingSessionConnection;
    sessionCount: Scalars['Int']['output'];
    /** @deprecated Use session_connection instead. */
    sessions: Array<Api_ProductCoachingSession>;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type Api_ProductCoachingSessionConnectionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductCoachingSessionsArgs = {
  sort: InputMaybe<Array<InputMaybe<ProductCoachingSessionSortOption>>>;
};

/** The connection type for API_ProductCoaching. */
export type Api_ProductCoachingConnection = {
  __typename?: 'API_ProductCoachingConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductCoachingEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductCoaching>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductCoachingEdge = {
  __typename?: 'API_ProductCoachingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductCoaching>;
};

export type Api_ProductCoachingIntakeQuestion = WithCoachingQuestion &
  WithTimestamps & {
    __typename?: 'API_ProductCoachingIntakeQuestion';
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    id: Scalars['UUID']['output'];
    question: Scalars['String']['output'];
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type Api_ProductCoachingSession = WithProductCoachingSession &
  WithTimestamps & {
    __typename?: 'API_ProductCoachingSession';
    coaching: Api_ProductCoaching;
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    /** The description of the session */
    description: Maybe<Scalars['String']['output']>;
    /** The ID of the session */
    id: Scalars['UUID']['output'];
    /** The name of the session */
    name: Scalars['String']['output'];
    /** The position of the session */
    position: Scalars['Int']['output'];
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** The connection type for API_ProductCoachingSession. */
export type Api_ProductCoachingSessionConnection = {
  __typename?: 'API_ProductCoachingSessionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductCoachingSessionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductCoachingSession>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductCoachingSessionEdge = {
  __typename?: 'API_ProductCoachingSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductCoachingSession>;
};

/** The connection type for API_Product. */
export type Api_ProductConnection = {
  __typename?: 'API_ProductConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Product>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductEdge = {
  __typename?: 'API_ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Product>;
};

export type Api_ProductEvent = WithTimestamps & {
  __typename?: 'API_ProductEvent';
  account: Api_Account;
  cancelationReason: Maybe<Scalars['String']['output']>;
  canceledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  chatRoom: Api_ChatRoom;
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationSeconds: Scalars['Int']['output'];
  extendedCount: Scalars['Int']['output'];
  extendedDurationSeconds: Scalars['Int']['output'];
  extensionsLeft: Scalars['Int']['output'];
  game: Maybe<Api_Game>;
  group: Maybe<Api_Group>;
  id: Scalars['UUID']['output'];
  language: Scalars['String']['output'];
  learningOutcomes: Array<Scalars['String']['output']>;
  liveAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  offerReplayPurchase: Scalars['Boolean']['output'];
  product: Api_Product;
  purchasedProduct: Maybe<Api_PurchasedProduct>;
  purchasedProductEvent: Maybe<Api_PurchasedProductEvent>;
  replayPrice: Maybe<Api_ProductPricingOption>;
  rtmpStreamUrl: Maybe<Scalars['String']['output']>;
  scheduledAt: Scalars['ISO8601DateTime']['output'];
  seatLimit: Scalars['Int']['output'];
  seatsLeft: Scalars['Int']['output'];
  state: ProductEventStateEnum;
  supporterAccess: Scalars['Boolean']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_ProductEvent. */
export type Api_ProductEventConnection = {
  __typename?: 'API_ProductEventConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductEventEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductEventEdge = {
  __typename?: 'API_ProductEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductEvent>;
};

export type Api_ProductGuide = WithTimestamps & {
  __typename?: 'API_ProductGuide';
  account: Maybe<Api_Account>;
  accountsRecentlyPurchased: Api_AccountConnection;
  authorOrContributor: ProductGuideAuthorRoleEnum;
  authors: Api_ProductGuideAuthorConnection;
  blockLayoutLandingPage: Maybe<Api_BlockLayout>;
  canEdit: Scalars['Boolean']['output'];
  changelog: Maybe<Api_ProductGuideChangelogConnection>;
  chapterCount: Scalars['Int']['output'];
  chapters: Api_ProductGuideChapterConnection;
  createAccountBlockOnPublish: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  game: Maybe<Api_Game>;
  group: Maybe<Api_Group>;
  groupChannel: Maybe<Api_GroupChannel>;
  groupChannelSupporterOnly: Maybe<Scalars['Boolean']['output']>;
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  isTrendingGuide: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  lastOpenedInEditorAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextVersion: Maybe<Api_ProductGuide>;
  owned: Scalars['Boolean']['output'];
  product: Api_Product;
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: ProductGuideStateEnum;
  supporterAccess: Scalars['Boolean']['output'];
  totalReadingTimeMinutes: Scalars['Int']['output'];
  trailerVideo: Maybe<Api_MuxAsset>;
  unlisted: Scalars['Boolean']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  version: Scalars['Int']['output'];
  videoOnly: Scalars['Boolean']['output'];
};

export type Api_ProductGuideAccountsRecentlyPurchasedArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductGuideAuthorsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductGuideChangelogArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductGuideChaptersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_ProductGuideAuthor = WithTimestamps & {
  __typename?: 'API_ProductGuideAuthor';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  /** The percentage of royalties the account will receive for the guide */
  percentage: Scalars['Float']['output'];
  product: Api_Product;
  productGuide: Api_ProductGuide;
  role: ProductGuideAuthorRoleEnum;
  state: ProductGuideAuthorStateEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_ProductGuideAuthor. */
export type Api_ProductGuideAuthorConnection = {
  __typename?: 'API_ProductGuideAuthorConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductGuideAuthorEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductGuideAuthor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductGuideAuthorEdge = {
  __typename?: 'API_ProductGuideAuthorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductGuideAuthor>;
};

export type Api_ProductGuideChangelog = WithTimestamps & {
  __typename?: 'API_ProductGuideChangelog';
  content: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  guide: Api_ProductGuide;
  id: Scalars['UUID']['output'];
  minor: Scalars['Boolean']['output'];
  post: Maybe<Api_Post>;
  product: Api_Product;
  thumbnail: Maybe<Api_Image>;
  title: Scalars['String']['output'];
  updateable: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  version: Scalars['Int']['output'];
};

/** The connection type for API_ProductGuideChangelog. */
export type Api_ProductGuideChangelogConnection = {
  __typename?: 'API_ProductGuideChangelogConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductGuideChangelogEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductGuideChangelog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductGuideChangelogEdge = {
  __typename?: 'API_ProductGuideChangelogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductGuideChangelog>;
};

export type Api_ProductGuideChapter = WithTimestamps & {
  __typename?: 'API_ProductGuideChapter';
  accountAttachments: Maybe<Array<Api_AccountAttachment>>;
  accountsOnChapter: Api_AccountConnection;
  completed: Maybe<Scalars['Boolean']['output']>;
  content: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  guide: Api_ProductGuide;
  id: Scalars['UUID']['output'];
  identifier: Scalars['String']['output'];
  muxAssets: Maybe<Array<Api_MuxAsset>>;
  position: Scalars['Int']['output'];
  post: Maybe<Api_Post>;
  readingTimeMinutes: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoRecordIds: Maybe<Array<Scalars['UUID']['output']>>;
};

export type Api_ProductGuideChapterAccountsOnChapterArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for API_ProductGuideChapter. */
export type Api_ProductGuideChapterConnection = {
  __typename?: 'API_ProductGuideChapterConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductGuideChapterEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductGuideChapter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductGuideChapterEdge = {
  __typename?: 'API_ProductGuideChapterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductGuideChapter>;
};

/** The connection type for API_ProductGuide. */
export type Api_ProductGuideConnection = {
  __typename?: 'API_ProductGuideConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductGuideEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductGuide>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductGuideEdge = {
  __typename?: 'API_ProductGuideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductGuide>;
};

export type Api_ProductPolicy = WithProductPolicy & {
  __typename?: 'API_ProductPolicy';
  account: Api_Account;
  /** The percent amount charged to cancel or reschedule */
  amount: Scalars['Float']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  policyType: CancelationPolicyPolicyEnum;
  timeFrame: Scalars['Int']['output'];
  timeUnit: CancelationPolicyTimeUnitEnum;
};

export type Api_ProductPricingOption = WithTimestamps & {
  __typename?: 'API_ProductPricingOption';
  /** The frequency at which the product is billed */
  billingFrequency: Maybe<BillingFrequencyEnum>;
  /** The interval at which the product is billed */
  billingInterval: Maybe<Scalars['Int']['output']>;
  /** The type of billing for the product */
  billingType: Maybe<BillingEnum>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The currency of the product */
  currency: Maybe<Scalars['String']['output']>;
  /** The ID of the product pricing option */
  id: Scalars['UUID']['output'];
  /** The price of the product */
  price: Maybe<Scalars['Float']['output']>;
  product: Maybe<Api_Product>;
  /** Whether the pricing option is only available to supporters */
  supporterOnly: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_ProductVisibility = WithTimestamps & {
  __typename?: 'API_ProductVisibility';
  /** The account that owns the product */
  account: Maybe<Api_Account>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the product is featured in the group */
  featured: Scalars['Boolean']['output'];
  /** The group this product is visible in */
  group: Maybe<Api_Group>;
  id: Scalars['UUID']['output'];
  /** The position of the product in the overview */
  overviewPosition: Maybe<Scalars['Int']['output']>;
  /** The position of the product in the group */
  position: Maybe<Scalars['Int']['output']>;
  /** The product this visibility is for */
  product: Maybe<Api_Product>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_ProductVisibility. */
export type Api_ProductVisibilityConnection = {
  __typename?: 'API_ProductVisibilityConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_ProductVisibilityEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_ProductVisibility>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_ProductVisibilityEdge = {
  __typename?: 'API_ProductVisibilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_ProductVisibility>;
};

/** A purchase on Metafy */
export type Api_Purchase = {
  __typename?: 'API_Purchase';
  order: Maybe<Api_Order>;
  /** The response from the payment gateway */
  paymentGatewayResponse: Maybe<Api_PaymentGatewayResponse>;
};

/** A reschedule request including an optional payment */
export type Api_PurchaseReschedule = {
  __typename?: 'API_PurchaseReschedule';
  purchase: Maybe<Api_Purchase>;
  purchasedProductCoachingSession: Api_PurchasedProductCoachingSession;
};

export type Api_PurchasedProduct = WithTimestamps & {
  __typename?: 'API_PurchasedProduct';
  addons: Maybe<Array<Api_PurchasedProductAddon>>;
  /** The frequency of billing (once, day, week, month, year) */
  billingFrequency: Maybe<Scalars['String']['output']>;
  /** The interval of billing (day, week, month, year) */
  billingInterval: Maybe<Scalars['String']['output']>;
  /** The type of billing (one_time, recurring) */
  billingType: Maybe<Scalars['String']['output']>;
  buyer: Maybe<Api_Account>;
  coaching: Maybe<Api_PurchasedProductCoaching>;
  cover: Maybe<Api_Image>;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The currency of the product (USD, EUR, etc.) */
  currency: Maybe<Scalars['String']['output']>;
  /** The description of the product */
  description: Maybe<Scalars['String']['output']>;
  /** Whether the product is enabled for purchase */
  enabled: Scalars['Boolean']['output'];
  /** The event for the product */
  event: Maybe<Api_PurchasedProductEvent>;
  /** Any gift cards purchased as part of this order */
  giftCards: Api_GiftCardConnection;
  /** Whether the product is global or offered by an account */
  global: Scalars['Boolean']['output'];
  group: Maybe<Api_Group>;
  /** The guide for the product */
  guide: Maybe<Api_PurchasedProductGuide>;
  hasLeftTestimonial: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the product */
  id: Maybe<Scalars['UUID']['output']>;
  /** Whether the current account is the buyer */
  isBuyer: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current account is the seller */
  isSeller: Maybe<Scalars['Boolean']['output']>;
  lastPurchasedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name of the product */
  name: Scalars['String']['output'];
  nonRefundableReason: Maybe<Array<Scalars['String']['output']>>;
  orderItem: Maybe<Api_OrderItem>;
  orderItems: Maybe<Api_OrderItemConnection>;
  orders: Maybe<Api_OrderConnection>;
  parentProduct: Maybe<Api_Product>;
  policies: Maybe<Api_PurchasedProductPolicyConnection>;
  /** The position of the product in the account's product list */
  position: Maybe<Scalars['Int']['output']>;
  post: Maybe<Api_Post>;
  /** The price of the product */
  price: Maybe<Scalars['Float']['output']>;
  pricingOption: Maybe<Api_ProductPricingOption>;
  productId: Maybe<Scalars['UUID']['output']>;
  productSlug: Maybe<Scalars['String']['output']>;
  productType: Maybe<ProductEnum>;
  /** The parent purchased product if this is a purchase or adjustment to an existing purchase */
  purchasedProduct: Maybe<Api_PurchasedProduct>;
  refundable: Maybe<Scalars['Boolean']['output']>;
  refundableAmount: Maybe<Api_Money>;
  seller: Maybe<Api_Account>;
  /** The stock keeping unit of the product */
  sku: Maybe<Scalars['String']['output']>;
  state: Maybe<PurchasedProductStateEnum>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_PurchasedProductGiftCardsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_PurchasedProductOrderItemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_PurchasedProductOrdersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_PurchasedProductPoliciesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_PurchasedProductAddon = WithProductAddon &
  WithTimestamps & {
    __typename?: 'API_PurchasedProductAddon';
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    description: Maybe<Scalars['String']['output']>;
    discounts: Api_Money;
    id: Scalars['UUID']['output'];
    name: Scalars['String']['output'];
    price: Maybe<Scalars['Float']['output']>;
    product: Api_PurchasedProduct;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type Api_PurchasedProductCoaching = WithProductCoaching &
  WithTimestamps & {
    __typename?: 'API_PurchasedProductCoaching';
    /** The attendee for this coaching program */
    attendee: Maybe<Api_Account>;
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    durationSeconds: Scalars['Int']['output'];
    game: Maybe<Api_Game>;
    /** The host for this coaching program */
    host: Api_Account;
    /** Is the current account the host or the attendee? */
    hostOrAttendee: CoachingRoleEnum;
    id: Scalars['UUID']['output'];
    /** The intake questions for this coaching program */
    intakeQuestions: Array<Api_PurchasedProductCoachingIntakeQuestion>;
    /** Is the current account the attendee? */
    isAttendee: Scalars['Boolean']['output'];
    /** Is the current account the host? */
    isHost: Scalars['Boolean']['output'];
    /** The product for this coaching program */
    product: Api_PurchasedProduct;
    scheduler: SchedulerEnum;
    /** The sessions for this coaching */
    sessionConnection: Api_PurchasedProductCoachingSessionConnection;
    sessionCount: Scalars['Int']['output'];
    /**
     * The sessions for this coaching
     * @deprecated Use session_connection instead
     */
    sessions: Array<Api_PurchasedProductCoachingSession>;
    /** The state of the coaching program */
    state: CoachingStateEnum;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type Api_PurchasedProductCoachingSessionConnectionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductCoachingSessionSortOption>>>;
  states?: InputMaybe<Array<CoachingSessionStateEnum>>;
};

export type Api_PurchasedProductCoachingSessionsArgs = {
  states?: InputMaybe<Array<CoachingSessionStateEnum>>;
};

/** The connection type for API_PurchasedProductCoaching. */
export type Api_PurchasedProductCoachingConnection = {
  __typename?: 'API_PurchasedProductCoachingConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductCoachingEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProductCoaching>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductCoachingEdge = {
  __typename?: 'API_PurchasedProductCoachingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProductCoaching>;
};

export type Api_PurchasedProductCoachingIntakeQuestion = WithCoachingQuestion &
  WithTimestamps & {
    __typename?: 'API_PurchasedProductCoachingIntakeQuestion';
    answer: Maybe<Scalars['String']['output']>;
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    id: Scalars['UUID']['output'];
    question: Scalars['String']['output'];
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

export type Api_PurchasedProductCoachingSession = WithProductCoachingSession &
  WithTimestamps & {
    __typename?: 'API_PurchasedProductCoachingSession';
    /** Whether the user can cancel or reschedule the session without a fee */
    canCancelWithoutFee: Scalars['Boolean']['output'];
    /** The amount to be charged for cancelation */
    cancelationAmount: Maybe<Api_Money>;
    /** The date and time the cancelation will be sent */
    cancelationDeadline: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** The coaching product this session is associated with */
    coaching: Api_PurchasedProductCoaching;
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    /** The description of the session */
    description: Maybe<Scalars['String']['output']>;
    /** The date and time accepentation will expire */
    expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** The ID of the session */
    id: Scalars['UUID']['output'];
    /** The name of the session */
    name: Scalars['String']['output'];
    /**
     * The original scheduled date and time
     * @deprecated Use previous_scheduled_at instead
     */
    originalScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** The position of the session */
    position: Scalars['Int']['output'];
    /** The previous scheduled date and time */
    previousScheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** The reason for the session being non-cancelable */
    reasonForCancelationFee: Maybe<PurchasedProductSessionPolicyReasonEnum>;
    /** The message the user sent when requesting a reschedule */
    rescheduleMessage: Maybe<Scalars['String']['output']>;
    /** The date and time the session is scheduled for */
    scheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** The amount of the session */
    sessionValue: Api_Money;
    /** The state of the session */
    state: CoachingSessionStateEnum;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
  };

/** The connection type for API_PurchasedProductCoachingSession. */
export type Api_PurchasedProductCoachingSessionConnection = {
  __typename?: 'API_PurchasedProductCoachingSessionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductCoachingSessionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProductCoachingSession>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductCoachingSessionEdge = {
  __typename?: 'API_PurchasedProductCoachingSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProductCoachingSession>;
};

/** The connection type for API_PurchasedProduct. */
export type Api_PurchasedProductConnection = {
  __typename?: 'API_PurchasedProductConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductEdge = {
  __typename?: 'API_PurchasedProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProduct>;
};

export type Api_PurchasedProductEvent = WithTimestamps & {
  __typename?: 'API_PurchasedProductEvent';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Api_ProductEvent;
  id: Scalars['UUID']['output'];
  muxAsset: Maybe<Api_MuxAsset>;
  product: Api_PurchasedProduct;
  recordings: Array<Api_MuxAsset>;
  role: EventAttendeeRoleEnum;
  token: Scalars['String']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_PurchasedProductEvent. */
export type Api_PurchasedProductEventConnection = {
  __typename?: 'API_PurchasedProductEventConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductEventEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProductEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductEventEdge = {
  __typename?: 'API_PurchasedProductEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProductEvent>;
};

export type Api_PurchasedProductGuide = WithTimestamps & {
  __typename?: 'API_PurchasedProductGuide';
  changesSinceLastRead: Scalars['Boolean']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  guide: Api_ProductGuide;
  id: Scalars['UUID']['output'];
  product: Api_PurchasedProduct;
  readingTimeMinutesRemaining: Scalars['Int']['output'];
  state: PurchasedProductGuideStateEnum;
  supporterAccess: Scalars['Boolean']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_PurchasedProductGuide. */
export type Api_PurchasedProductGuideConnection = {
  __typename?: 'API_PurchasedProductGuideConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductGuideEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProductGuide>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductGuideEdge = {
  __typename?: 'API_PurchasedProductGuideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProductGuide>;
};

export type Api_PurchasedProductPolicy = WithProductPolicy & {
  __typename?: 'API_PurchasedProductPolicy';
  /** The percent amount charged to cancel or reschedule */
  amount: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  policyType: CancelationPolicyPolicyEnum;
  timeFrame: Scalars['Int']['output'];
  timeUnit: CancelationPolicyTimeUnitEnum;
};

/** The connection type for API_PurchasedProductPolicy. */
export type Api_PurchasedProductPolicyConnection = {
  __typename?: 'API_PurchasedProductPolicyConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductPolicyEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProductPolicy>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductPolicyEdge = {
  __typename?: 'API_PurchasedProductPolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProductPolicy>;
};

export type Api_PurchasedProductSubscription = WithTimestamps & {
  __typename?: 'API_PurchasedProductSubscription';
  account: Api_Account;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentPeriodEndsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentPeriodStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentTermEndsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentTermStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['UUID']['output'];
  order: Api_Order;
  product: Api_PurchasedProduct;
  state: SubscriptionStateEnum;
  trialEndsAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  trialStartedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_PurchasedProductSubscription. */
export type Api_PurchasedProductSubscriptionConnection = {
  __typename?: 'API_PurchasedProductSubscriptionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_PurchasedProductSubscriptionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_PurchasedProductSubscription>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_PurchasedProductSubscriptionEdge = {
  __typename?: 'API_PurchasedProductSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_PurchasedProductSubscription>;
};

export type Api_PurchasedProductTip = {
  __typename?: 'API_PurchasedProductTip';
  id: Scalars['UUID']['output'];
  sender: Api_Account;
};

export type Api_Query = Query & {
  __typename?: 'API_Query';
  /** Returns a Metafy account */
  account: Maybe<Api_Account>;
  /** Returns an account attachment */
  accountAttachment: Maybe<Api_AccountAttachment>;
  /** Returns a list of metrics for the current account */
  accountMetrics: Maybe<Api_AccountMetric>;
  /** List of current announcements on Metafy */
  announcements: Api_AnnouncementConnection;
  /** Returns a list of API keys for the account */
  apiKeys: Maybe<Array<Api_ApiKey>>;
  /** Returns the availability for a account */
  availability: Maybe<Api_Availability>;
  /** Returns a change logs */
  changeLog: Maybe<Api_ChangeLog>;
  /** Returns a list of change logs */
  changeLogs: Api_ChangeLogConnection;
  chatMessage: Maybe<Api_ChatMessage>;
  /** Returns the chat messages of a chat room that you're a member of */
  chatMessages: Maybe<Api_ChatMessageConnection>;
  /** Returns a chat room between you and another account */
  chatRoom: Maybe<Api_ChatRoom>;
  /** Returns a list of chat rooms that you're a member of */
  chatRooms: Api_ChatRoomConnection;
  /** Returns a single purchased coaching product by ID */
  coaching: Maybe<Api_PurchasedProductCoaching>;
  /** Returns a list of accounts that are currently offering coaching */
  coachingPageAccounts: Maybe<Api_AccountConnection>;
  /** Returns a single coaching session by ID */
  coachingSession: Maybe<Api_PurchasedProductCoachingSession>;
  /** Returns a list of coaching sessions for a purchased coaching product */
  coachingSessions: Api_PurchasedProductCoachingSessionConnection;
  /** Returns a list of purchased coaching products for the current account */
  coachings: Api_PurchasedProductCoachingConnection;
  contestLeaderboard: Api_ContestLeaderboardConnection;
  contestSelf: Maybe<Api_ContestLeaderboard>;
  /** Returns a list of Countries recognized by the API */
  countries: Array<Scalars['JSON']['output']>;
  /** Returns a list of coupons for the current account */
  coupons: Api_CouponConnection;
  /** Return the currently authenticated account */
  currentSession: Maybe<Api_Account>;
  /** Returns a customer relationship between two accounts */
  customer: Maybe<Api_AccountCustomer>;
  /** Returns a list of customers for the current account */
  customers: Api_AccountCustomerConnection;
  /** Returns a list of supported emotes */
  emotes: Array<Api_Emote>;
  /** Returns a list of feature flags for the current account or global */
  featureFlags: Scalars['JSON']['output'];
  /** Fetches OpenGraph data for a URL */
  fetchOpengraphData: Maybe<Api_OpenGraph>;
  /** Returns a single game by ID or slug */
  game: Maybe<Api_Game>;
  /** Returns a list of filterable attribute data for the coaching page */
  gameFilter: Api_GameFilter;
  /** Returns all games on Metafy */
  games: Api_GameConnection;
  /** Returns a gift card by its ID */
  giftCard: Maybe<Api_GiftCard>;
  /** Returns a list of gift cards for the current account */
  giftCards: Api_GiftCardConnection;
  /** Returns a group on Metafy */
  group: Maybe<Api_Group>;
  /** Returns the most applicable group based discount for the product you're purchasing */
  groupDiscountAvailable: Maybe<Api_GroupDiscount>;
  /** Returns a list of metrics for the current group */
  groupMetrics: Maybe<Api_GroupMetric>;
  /** Returns a group tier by ID or slug */
  groupTier: Maybe<Api_GroupTier>;
  /** Returns a list of discoverable groups */
  groups: Api_GroupConnection;
  hasJoinedDiscord: Scalars['Boolean']['output'];
  /** Returns a mux asset record */
  muxAsset: Maybe<Api_MuxAsset>;
  /** Returns a list of accounts that you have a coaching connection with */
  myCoaches: Api_AccountConnection;
  /** Returns a list of events purchased by the current account */
  myEvents: Api_PurchasedProductEventConnection;
  /** Returns a list of guides owned by the current account */
  myGuides: Api_PurchasedProductGuideConnection;
  /** Returns an OAuth application */
  oauthApplication: Maybe<Api_OAuthApplication>;
  /** Returns a list of OAuth applications for the account */
  oauthApplications: Maybe<Array<Api_OAuthApplication>>;
  /** Return an approximated online count of users */
  onlineCount: Scalars['Int']['output'];
  /** Returns a single order by ID */
  order: Maybe<Api_Order>;
  /** Returns a list of orders for the current account */
  orders: Api_OrderConnection;
  /** Returns a list of groups owned by users who you subscribe to on Patreon */
  patreonGroups: Api_GroupConnection;
  /** Returns a pinned post for a certain feed target */
  pinnedPost: Maybe<Api_Post>;
  /** Returns a post by its ID or Slug */
  post: Maybe<Api_Post>;
  /** Returns a list of posts for a certain feed target */
  posts: Api_PostConnection;
  /** Returns a single purchsable product By ID or slug */
  product: Maybe<Api_Product>;
  /** Returns a purchasable coaching product by ID or slug */
  productCoaching: Maybe<Api_ProductCoaching>;
  /** Returns a live event product */
  productEvent: Maybe<Api_ProductEvent>;
  /** Returns a list of purchasable event products */
  productEvents: Api_ProductEventConnection;
  /** Returns a purchasable guide product by ID or slug */
  productGuide: Maybe<Api_ProductGuide>;
  /** Returns a guide chapter by ID */
  productGuideChapter: Maybe<Api_ProductGuideChapter>;
  /** Returns a list of purchasable guide products */
  productGuides: Api_ProductGuideConnection;
  /** Returns a list of purchasable global products */
  products: Api_ProductConnection;
  /** Return a list of posts you have purchased */
  purchasedPosts: Api_PostConnection;
  /** Returns a single purchased product by ID */
  purchasedProduct: Maybe<Api_PurchasedProduct>;
  /** Returns a list of purchased products for the current account */
  purchasedProducts: Api_PurchasedProductConnection;
  /** Return a list of groups best recommended for you to join */
  recommendedGroups: Array<Api_Group>;
  /** Returns a list of sales for the current account */
  sales: Api_SaleConnection;
  /** Returns a list of accounts that are currently offering coaching */
  sessionAccounts: Api_AccountConnection;
  /** Returns a list of subscriptions for the current account */
  subscriptions: Api_PurchasedProductSubscriptionConnection;
  /** Returns a tag by its ID or Slug */
  tag: Maybe<Api_UnifiedTag>;
  /** Returns a single TestimonialRequest by ID */
  testimonialRequest: Maybe<Api_TestimonialRequest>;
  /** Returns a list of Timezones supported by the API */
  timezones: Array<Scalars['JSON']['output']>;
};

export type Api_QueryAccountArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  referralIdentifier: InputMaybe<Scalars['String']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryAccountAttachmentArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryAccountMetricsArgs = {
  days: InputMaybe<Scalars['Int']['input']>;
  month: InputMaybe<Scalars['Int']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryAnnouncementsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryAvailabilityArgs = {
  accountId: Scalars['UUID']['input'];
  daysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  durationSeconds: Scalars['Int']['input'];
  forDate: InputMaybe<Scalars['ISO8601Date']['input']>;
  monthsInAdvance?: InputMaybe<Scalars['Int']['input']>;
  skipOpenSlotCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Api_QueryChangeLogArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
  identifier: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryChangeLogsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryChatMessageArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryChatMessagesArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  roomId: InputMaybe<Scalars['UUID']['input']>;
  sort: InputMaybe<Array<InputMaybe<ChatMessageSortOption>>>;
  type: InputMaybe<ChatMessageEnum>;
};

export type Api_QueryChatRoomArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  roomId: InputMaybe<Scalars['UUID']['input']>;
};

export type Api_QueryChatRoomsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryCoachingArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryCoachingPageAccountsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  languages: InputMaybe<Array<Scalars['String']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
  priceRange: InputMaybe<PriceRangeInput>;
  priceValue: InputMaybe<Scalars['String']['input']>;
  queryType?: InputMaybe<CoachingPageAccountsQueryEnum>;
};

export type Api_QueryCoachingSessionArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryCoachingSessionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  as: InputMaybe<CoachingRoleEnum>;
  before: InputMaybe<Scalars['String']['input']>;
  coachingId: InputMaybe<Scalars['UUID']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductCoachingSessionSortOption>>>;
  states?: InputMaybe<Array<CoachingSessionStateEnum>>;
};

export type Api_QueryCoachingsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  as: InputMaybe<CoachingRoleEnum>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductCoachingSortOption>>>;
  states?: InputMaybe<Array<CoachingStateEnum>>;
};

export type Api_QueryContestLeaderboardArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryContestSelfArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryCouponsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<CouponSortOption>>>;
};

export type Api_QueryCustomerArgs = {
  customerId: Scalars['UUID']['input'];
};

export type Api_QueryCustomersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  nameFilter: InputMaybe<Scalars['SanitizedString']['input']>;
  productId: InputMaybe<Scalars['UUID']['input']>;
  sort: InputMaybe<Array<InputMaybe<AccountCustomerSortOption>>>;
};

export type Api_QueryFetchOpengraphDataArgs = {
  url: Scalars['String']['input'];
};

export type Api_QueryGameArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryGamesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GameSortOption>>>;
};

export type Api_QueryGiftCardArgs = {
  code: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['UUID']['input']>;
};

export type Api_QueryGiftCardsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  as?: InputMaybe<GiftCardRoleEnum>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GiftCardSortOption>>>;
  states?: InputMaybe<Array<GiftCardStateEnum>>;
};

export type Api_QueryGroupArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryGroupDiscountAvailableArgs = {
  accountId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
};

export type Api_QueryGroupMetricsArgs = {
  days: InputMaybe<Scalars['Int']['input']>;
  groupId: InputMaybe<Scalars['UUID']['input']>;
  month: InputMaybe<Scalars['Int']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryGroupTierArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  followedGames: InputMaybe<Scalars['Boolean']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  gameSlug: InputMaybe<Scalars['String']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<GroupSortOption>>>;
  visibility: InputMaybe<GroupVisibilityDiscoverableEnum>;
};

export type Api_QueryHasJoinedDiscordArgs = {
  discordGuildId: InputMaybe<Scalars['UUID']['input']>;
  groupId: InputMaybe<Scalars['UUID']['input']>;
  metafy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Api_QueryMuxAssetArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryMyCoachesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryMyEventsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  includeOwnEvents?: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductEventSortOption>>>;
  states?: InputMaybe<Array<ProductEventStateEnum>>;
};

export type Api_QueryMyGuidesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  includeOwnGuides?: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductGuideSortOption>>>;
  states?: InputMaybe<Array<PurchasedProductGuideStateEnum>>;
};

export type Api_QueryOauthApplicationArgs = {
  clientId: Scalars['String']['input'];
};

export type Api_QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryOrdersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<OrderSortOption>>>;
  states?: InputMaybe<Array<OrderStateEnum>>;
};

export type Api_QueryPatreonGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryPinnedPostArgs = {
  feedId: InputMaybe<Scalars['UUID']['input']>;
  feedType: FeedEnum;
};

export type Api_QueryPostArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryPostsArgs = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  following: InputMaybe<Scalars['Boolean']['input']>;
  groupChannelId: InputMaybe<Scalars['UUID']['input']>;
  groupId: InputMaybe<Scalars['UUID']['input']>;
  includeGuideChapters?: InputMaybe<Scalars['Boolean']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  repliesOnly: InputMaybe<Scalars['Boolean']['input']>;
  scheduledOnly: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<FeedSortByEnum>;
  sortWindow?: InputMaybe<FeedSortWindowEnum>;
};

export type Api_QueryProductArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryProductCoachingArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryProductEventArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryProductEventsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  completed: InputMaybe<ProductEventCompletedEnum>;
  first: InputMaybe<Scalars['Int']['input']>;
  languages: InputMaybe<Array<Scalars['String']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductEventSortOption>>>;
};

export type Api_QueryProductGuideArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  mode?: InputMaybe<ProductGuideModeEnum>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryProductGuideChapterArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  mode?: InputMaybe<ProductGuideModeEnum>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryProductGuidesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  chapterCount: InputMaybe<Scalars['Int']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  languages: InputMaybe<Array<Scalars['String']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
  priceValue: InputMaybe<PriceValueEnum>;
  queryType?: InputMaybe<CoachingPageAccountsQueryEnum>;
  skipFollowedCheck?: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<Array<InputMaybe<ProductGuideSortOption>>>;
};

export type Api_QueryProductsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  productType: InputMaybe<ProductEnum>;
  sort: InputMaybe<Array<InputMaybe<ProductSortOption>>>;
};

export type Api_QueryPurchasedPostsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QueryPurchasedProductArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_QueryPurchasedProductsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  as: InputMaybe<PurchasedProductRoleEnum>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductSortOption>>>;
  states?: InputMaybe<Array<PurchasedProductStateEnum>>;
};

export type Api_QueryRecommendedGroupsArgs = {
  gameSlug: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QuerySalesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_QuerySessionAccountsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<AccountSortOption>>>;
};

export type Api_QuerySubscriptionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Array<InputMaybe<PurchasedProductSubscriptionSortOption>>>;
};

export type Api_QueryTagArgs = {
  id: InputMaybe<Scalars['UUID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};

export type Api_QueryTestimonialRequestArgs = {
  id: Scalars['UUID']['input'];
};

export type Api_RecentPostReaction = {
  __typename?: 'API_RecentPostReaction';
  names: Array<Scalars['String']['output']>;
  reactionType: ReactionEnum;
};

export type Api_RecoveryCodes = {
  __typename?: 'API_RecoveryCodes';
  /** The account associated with these recovery codes */
  account: Api_Account;
  /** A list of recovery codes for your account */
  codes: Array<Scalars['String']['output']>;
};

export type Api_ReferralClick = {
  __typename?: 'API_ReferralClick';
  /** The account that clicked the referral */
  account: Maybe<Api_Account>;
  /** The ID of the referral click */
  id: Scalars['UUID']['output'];
  /** The account that referred the click */
  referrer: Maybe<Api_Account>;
};

export type Api_ReferralTrackedPurchasePayout = WithTimestamps & {
  __typename?: 'API_ReferralTrackedPurchasePayout';
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  state: ReferralTrackedPurchasePayoutEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Api_Sale = WithCouponBase &
  WithTimestamps & {
    __typename?: 'API_Sale';
    /** List of accounts this coupon can be redeemed against */
    accounts: Array<Api_CouponAccount>;
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    /** The type of discount */
    discountType: CouponDiscountEnum;
    /** The value of the discount */
    discountValue: Scalars['Float']['output'];
    /** The duration of the coupon for group_supporter subscriptions */
    duration: Maybe<CouponDurationEnum>;
    /** Whether the coupon is enabled */
    enabled: Scalars['Boolean']['output'];
    /** The expiry date of the coupon */
    expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
    /** List of games this coupon can be redeemed against */
    games: Array<Api_CouponGame>;
    /** Whether the coupon is global */
    global: Scalars['Boolean']['output'];
    /** The ID of the coupon */
    id: Scalars['UUID']['output'];
    /** The limits of the coupon */
    limits: Api_CouponLimitConnection;
    /** The maximum value of the discount */
    maxDiscountValue: Maybe<Scalars['Float']['output']>;
    /** The maximum number of redemptions */
    maxRedemptions: Maybe<Scalars['Int']['output']>;
    /**
     * The maximum number of redemptions per account
     * @deprecated Use limits.max_redemptions_per_account instead
     */
    maxRedemptionsPerAccount: Maybe<Scalars['Int']['output']>;
    /** The name of the coupon */
    name: Maybe<Scalars['SanitizedString']['output']>;
    /** List of products this coupon can be redeemed against */
    products: Array<Api_CouponProduct>;
    /** The number of times the coupon has been redeemed */
    redeemedCount: Scalars['Int']['output'];
    /** Whether the coupon or sale is stackable with other coupons or sales */
    stackable: Scalars['Boolean']['output'];
    /** List of product types this coupon can be redeemed against */
    supportedProductTypes: Array<ProductEnum>;
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
    /** The date the coupon becomes valid */
    validFrom: Maybe<Scalars['ISO8601DateTime']['output']>;
  };

export type Api_SaleLimitsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for API_Sale. */
export type Api_SaleConnection = {
  __typename?: 'API_SaleConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_SaleEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Sale>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_SaleEdge = {
  __typename?: 'API_SaleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Sale>;
};

export type Api_ShortLink = {
  __typename?: 'API_ShortLink';
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Api_Subscription = {
  __typename?: 'API_Subscription';
  currentTermEndsAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Api_Testimonial = WithTimestamps & {
  __typename?: 'API_Testimonial';
  coachReviewed: Scalars['Boolean']['output'];
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: Api_Account;
  dismissedModal: Scalars['Boolean']['output'];
  featuredPosition: Maybe<Scalars['Int']['output']>;
  feedback: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  impression: Maybe<TestimonialImpressionEnum>;
  product: Maybe<Api_Product>;
  seller: Api_Account;
  sentiment: Maybe<TestimonialSentimentEnum>;
  type: TestimonialEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_Testimonial. */
export type Api_TestimonialConnection = {
  __typename?: 'API_TestimonialConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_TestimonialEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_Testimonial>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_TestimonialEdge = {
  __typename?: 'API_TestimonialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_Testimonial>;
};

export type Api_TestimonialRequest = {
  __typename?: 'API_TestimonialRequest';
  customer: Api_Account;
  id: Scalars['UUID']['output'];
  product: Api_Product;
  seller: Api_Account;
};

/** The connection type for API_TestimonialRequest. */
export type Api_TestimonialRequestConnection = {
  __typename?: 'API_TestimonialRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_TestimonialRequestEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_TestimonialRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_TestimonialRequestEdge = {
  __typename?: 'API_TestimonialRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_TestimonialRequest>;
};

export type Api_Twitch = WithDiscounts &
  WithTimestamps & {
    __typename?: 'API_Twitch';
    broadcaster: Scalars['Boolean']['output'];
    /** The timestamp of when the object was created */
    createdAt: Scalars['ISO8601DateTime']['output'];
    eventDiscountType: CouponDiscountEnum;
    eventDiscountValue: Scalars['Int']['output'];
    groupTierDiscountType: CouponDiscountEnum;
    groupTierDiscountValue: Scalars['Int']['output'];
    guideDiscountType: CouponDiscountEnum;
    guideDiscountValue: Scalars['Int']['output'];
    id: Scalars['UUID']['output'];
    sessionDiscountType: CouponDiscountEnum;
    sessionDiscountValue: Scalars['Int']['output'];
    /** The timestamp of when the object was last updated */
    updatedAt: Scalars['ISO8601DateTime']['output'];
    username: Scalars['String']['output'];
  };

export type Api_UnifiedTag = {
  __typename?: 'API_UnifiedTag';
  coachingCount: Scalars['Int']['output'];
  /** Games associated with this tag */
  games: Api_GameConnection;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  postCount: Scalars['Int']['output'];
  /** Posts associated with this tag */
  posts: Api_PostConnection;
  /** Products associated with this tag */
  products: Api_ProductConnection;
  slug: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type Api_UnifiedTagGamesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_UnifiedTagPostsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  gameIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type Api_UnifiedTagProductsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  gameIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  last: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for API_UnifiedTag. */
export type Api_UnifiedTagConnection = {
  __typename?: 'API_UnifiedTagConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_UnifiedTagEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_UnifiedTag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_UnifiedTagEdge = {
  __typename?: 'API_UnifiedTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_UnifiedTag>;
};

export type Api_WalletPayoutRequest = {
  __typename?: 'API_WalletPayoutRequest';
  id: Scalars['UUID']['output'];
  state: WalletPayoutRequestStateEnum;
  walletTransaction: Api_WalletTransaction;
};

export type Api_WalletTransaction = WithTimestamps & {
  __typename?: 'API_WalletTransaction';
  amount: Api_Money;
  balanceChange: Api_Money;
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['UUID']['output'];
  record: Maybe<WalletTransactionRecordUnion>;
  recordType: Maybe<Scalars['String']['output']>;
  state: WalletTransactionStateEnum;
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for API_WalletTransaction. */
export type Api_WalletTransactionConnection = {
  __typename?: 'API_WalletTransactionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Api_WalletTransactionEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Api_WalletTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of nodes. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Api_WalletTransactionEdge = {
  __typename?: 'API_WalletTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Api_WalletTransaction>;
};

export type AccountAchievementCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountAchievementCreateInput = {
  achievement: InputMaybe<Scalars['SanitizedString']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  placement: InputMaybe<Scalars['Int']['input']>;
  tournamentTitle: InputMaybe<Scalars['SanitizedString']['input']>;
  type: InputMaybe<Scalars['SanitizedString']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AccountAchievementCreate. */
export type AccountAchievementCreatePayload = {
  __typename?: 'AccountAchievementCreatePayload';
  errors: Maybe<Array<AccountAchievementCreateErrorsUnion>>;
  result: Maybe<Api_CoachAchievement>;
};

export type AccountAchievementDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountAchievementDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountAchievementDelete. */
export type AccountAchievementDeletePayload = {
  __typename?: 'AccountAchievementDeletePayload';
  errors: Maybe<Array<AccountAchievementDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountAchievementUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountAchievementUpdateInput = {
  achievement: InputMaybe<Scalars['SanitizedString']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  placement: InputMaybe<Scalars['Int']['input']>;
  position: InputMaybe<Scalars['Int']['input']>;
  tournamentTitle: InputMaybe<Scalars['SanitizedString']['input']>;
  type: InputMaybe<Scalars['SanitizedString']['input']>;
  year: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AccountAchievementUpdate. */
export type AccountAchievementUpdatePayload = {
  __typename?: 'AccountAchievementUpdatePayload';
  errors: Maybe<Array<AccountAchievementUpdateErrorsUnion>>;
  result: Maybe<Api_CoachAchievement>;
};

export type AccountAttachmentCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountAttachmentCreateInput = {
  attachment: UploadAssetInput;
};

/** Autogenerated return type of AccountAttachmentCreate. */
export type AccountAttachmentCreatePayload = {
  __typename?: 'AccountAttachmentCreatePayload';
  errors: Maybe<Array<AccountAttachmentCreateErrorsUnion>>;
  result: Maybe<Api_AccountAttachment>;
};

export type AccountBlockLayoutBlockPreviewErrorsUnion = NotAuthenticatedError | ValidationError;

export type AccountBlockLayoutBlockPreviewInput = {
  block: BlockLayoutBlockBlockInput;
};

/** Autogenerated return type of AccountBlockLayoutBlockPreview. */
export type AccountBlockLayoutBlockPreviewPayload = {
  __typename?: 'AccountBlockLayoutBlockPreviewPayload';
  errors: Maybe<Array<AccountBlockLayoutBlockPreviewErrorsUnion>>;
  result: Maybe<Api_BlockLayoutBlock>;
};

export type AccountBlockLayoutUpdateErrorsUnion = NotAuthenticatedError | ValidationError;

export type AccountBlockLayoutUpdateInput = {
  blocks: InputMaybe<Array<BlockLayoutBlockBlockInput>>;
};

/** Autogenerated return type of AccountBlockLayoutUpdate. */
export type AccountBlockLayoutUpdatePayload = {
  __typename?: 'AccountBlockLayoutUpdatePayload';
  errors: Maybe<Array<AccountBlockLayoutUpdateErrorsUnion>>;
  result: Maybe<Api_BlockLayout>;
};

export type AccountBookingNoticeInput = {
  unit: Scalars['SanitizedString']['input'];
  value: Scalars['Int']['input'];
};

export type AccountCancelationPolicyPolicyInput = {
  amount: InputMaybe<Scalars['Float']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  timeFrame: InputMaybe<Scalars['Int']['input']>;
  timeUnit: InputMaybe<CancelationPolicyTimeUnitEnum>;
};

export type AccountCancelationPolicyUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountCancelationPolicyUpdateInput = {
  policy: AccountCancelationPolicyPolicyInput;
};

/** Autogenerated return type of AccountCancelationPolicyUpdate. */
export type AccountCancelationPolicyUpdatePayload = {
  __typename?: 'AccountCancelationPolicyUpdatePayload';
  errors: Maybe<Array<AccountCancelationPolicyUpdateErrorsUnion>>;
  result: Maybe<Api_ProductPolicy>;
};

export type AccountCommunitiesEditErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountCommunitiesEditInput = {
  id: Scalars['UUID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of AccountCommunitiesEdit. */
export type AccountCommunitiesEditPayload = {
  __typename?: 'AccountCommunitiesEditPayload';
  errors: Maybe<Array<AccountCommunitiesEditErrorsUnion>>;
  result: Maybe<Api_AccountCommunity>;
};

export const enum AccountCommunityEnum {
  Game = 'GAME',
  Group = 'GROUP'
}

export type AccountCommunityRecordUnion = Api_Follow | Api_GroupMember;

export const enum AccountCommunitySortEnum {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION'
}

export type AccountCommunitySortOption = {
  direction: SortDirection;
  on: AccountCommunitySortEnum;
};

export type AccountConfirmEmailErrorsUnion = NotAuthenticatedError | ValidationError;

export type AccountConfirmEmailInput = {
  key: Scalars['String']['input'];
};

/** Autogenerated return type of AccountConfirmEmail. */
export type AccountConfirmEmailPayload = {
  __typename?: 'AccountConfirmEmailPayload';
  errors: Maybe<Array<AccountConfirmEmailErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountCreateErrorsUnion = AuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountCreateInput = {
  credentials: InputMaybe<AccountCredentialsCreateInput>;
  provider: InputMaybe<AccountProviderCreateInput>;
};

/** Autogenerated return type of AccountCreate. */
export type AccountCreatePayload = {
  __typename?: 'AccountCreatePayload';
  errors: Maybe<Array<AccountCreateErrorsUnion>>;
  result: Maybe<Api_AuthenticationToken>;
};

export type AccountCredentialsCreateInput = {
  email: Scalars['SanitizedString']['input'];
  locale: Scalars['SanitizedString']['input'];
  name: Scalars['SanitizedString']['input'];
  password: Scalars['String']['input'];
  signupGameId: InputMaybe<Scalars['UUID']['input']>;
  timezone: Scalars['SanitizedString']['input'];
};

export type AccountCredentialsLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AccountCustomerInputInput = {
  note: InputMaybe<Scalars['SanitizedString']['input']>;
};

export const enum AccountCustomerSortEnum {
  CreatedAt = 'CREATED_AT',
  FirstPurchaseAt = 'FIRST_PURCHASE_AT',
  LastPurchaseAt = 'LAST_PURCHASE_AT',
  PurchaseCount = 'PURCHASE_COUNT',
  TotalRevenue = 'TOTAL_REVENUE'
}

export type AccountCustomerSortOption = {
  direction: SortDirection;
  on: AccountCustomerSortEnum;
};

export type AccountCustomerUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountCustomerUpdateInput = {
  accountCustomer: AccountCustomerInputInput;
  /** The ID of the account customer to update */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountCustomerUpdate. */
export type AccountCustomerUpdatePayload = {
  __typename?: 'AccountCustomerUpdatePayload';
  errors: Maybe<Array<AccountCustomerUpdateErrorsUnion>>;
  result: Maybe<Api_AccountCustomer>;
};

export type AccountDailyLimitMinutesInput = {
  friday: InputMaybe<Scalars['Int']['input']>;
  monday: InputMaybe<Scalars['Int']['input']>;
  saturday: InputMaybe<Scalars['Int']['input']>;
  sunday: InputMaybe<Scalars['Int']['input']>;
  thursday: InputMaybe<Scalars['Int']['input']>;
  tuesday: InputMaybe<Scalars['Int']['input']>;
  wednesday: InputMaybe<Scalars['Int']['input']>;
};

export type AccountEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountEditInput = {
  account: AccountUpdateInput;
};

/** Autogenerated return type of AccountEdit. */
export type AccountEditPayload = {
  __typename?: 'AccountEditPayload';
  errors: Maybe<Array<AccountEditErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountFaqCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountFaqCreateInput = {
  answer: Scalars['SanitizedString']['input'];
  position: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['SanitizedString']['input'];
};

/** Autogenerated return type of AccountFaqCreate. */
export type AccountFaqCreatePayload = {
  __typename?: 'AccountFaqCreatePayload';
  errors: Maybe<Array<AccountFaqCreateErrorsUnion>>;
  result: Maybe<Api_AccountFaq>;
};

export type AccountFaqDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type AccountFaqDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountFaqDelete. */
export type AccountFaqDeletePayload = {
  __typename?: 'AccountFaqDeletePayload';
  errors: Maybe<Array<AccountFaqDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountFaqUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type AccountFaqUpdateInput = {
  answer: InputMaybe<Scalars['SanitizedString']['input']>;
  id: Scalars['UUID']['input'];
  position: InputMaybe<Scalars['Int']['input']>;
  question: InputMaybe<Scalars['SanitizedString']['input']>;
};

/** Autogenerated return type of AccountFaqUpdate. */
export type AccountFaqUpdatePayload = {
  __typename?: 'AccountFaqUpdatePayload';
  errors: Maybe<Array<AccountFaqUpdateErrorsUnion>>;
  result: Maybe<Api_AccountFaq>;
};

export type AccountFeeCoverInput = {
  platformFee: InputMaybe<Scalars['Boolean']['input']>;
  processingFee: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountFollowCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountFollowCreateInput = {
  /** The ID of the account you wish to follow */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountFollowCreate. */
export type AccountFollowCreatePayload = {
  __typename?: 'AccountFollowCreatePayload';
  errors: Maybe<Array<AccountFollowCreateErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountFollowDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountFollowDeleteInput = {
  /** The ID of the account you wish to unfollow */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountFollowDelete. */
export type AccountFollowDeletePayload = {
  __typename?: 'AccountFollowDeletePayload';
  errors: Maybe<Array<AccountFollowDeleteErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountLoginErrorsUnion = AuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountLoginInput = {
  credentials: InputMaybe<AccountCredentialsLoginInput>;
  otp: InputMaybe<Scalars['String']['input']>;
  otpRecordId: InputMaybe<Scalars['UUID']['input']>;
  otpRecoveryCode: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<AccountProviderLoginInput>;
};

/** Autogenerated return type of AccountLogin. */
export type AccountLoginPayload = {
  __typename?: 'AccountLoginPayload';
  errors: Maybe<Array<AccountLoginErrorsUnion>>;
  result: Maybe<Api_AuthenticationToken>;
};

export type AccountLogoutErrorsUnion = NotAuthenticatedError;

/** Autogenerated return type of AccountLogout. */
export type AccountLogoutPayload = {
  __typename?: 'AccountLogoutPayload';
  errors: Maybe<Array<AccountLogoutErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountMuteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type AccountMuteInput = {
  /** The ID of the account you wish to mute */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountMute. */
export type AccountMutePayload = {
  __typename?: 'AccountMutePayload';
  errors: Maybe<Array<AccountMuteErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountNotificationDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountNotificationDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountNotificationDelete. */
export type AccountNotificationDeletePayload = {
  __typename?: 'AccountNotificationDeletePayload';
  errors: Maybe<Array<AccountNotificationDeleteErrorsUnion>>;
  result: Maybe<Api_Notification>;
};

export type AccountNotificationMarkAllReadErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

/** Autogenerated return type of AccountNotificationMarkAllRead. */
export type AccountNotificationMarkAllReadPayload = {
  __typename?: 'AccountNotificationMarkAllReadPayload';
  errors: Maybe<Array<AccountNotificationMarkAllReadErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountNotificationMarkAllSeenErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

/** Autogenerated return type of AccountNotificationMarkAllSeen. */
export type AccountNotificationMarkAllSeenPayload = {
  __typename?: 'AccountNotificationMarkAllSeenPayload';
  errors: Maybe<Array<AccountNotificationMarkAllSeenErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountNotificationMarkReadErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountNotificationMarkReadInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountNotificationMarkRead. */
export type AccountNotificationMarkReadPayload = {
  __typename?: 'AccountNotificationMarkReadPayload';
  errors: Maybe<Array<AccountNotificationMarkReadErrorsUnion>>;
  result: Maybe<Api_Notification>;
};

export type AccountNotificationSettingsEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountNotificationSettingsEditInput = {
  settings: AccountNotificationSettingsInput;
};

/** Autogenerated return type of AccountNotificationSettingsEdit. */
export type AccountNotificationSettingsEditPayload = {
  __typename?: 'AccountNotificationSettingsEditPayload';
  errors: Maybe<Array<AccountNotificationSettingsEditErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountNotificationSettingsInput = {
  discord: InputMaybe<Scalars['Boolean']['input']>;
  email: InputMaybe<Scalars['Boolean']['input']>;
  webPush: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountNotificationWebPushRegisterErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | ValidationError;

export type AccountNotificationWebPushRegisterInput = {
  authKey: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  p256dhKey: Scalars['String']['input'];
};

/** Autogenerated return type of AccountNotificationWebPushRegister. */
export type AccountNotificationWebPushRegisterPayload = {
  __typename?: 'AccountNotificationWebPushRegisterPayload';
  errors: Maybe<Array<AccountNotificationWebPushRegisterErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountOAuthConnectErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountOAuthConnectInput = {
  /** Access token provided by the third-party */
  accessToken: InputMaybe<Scalars['String']['input']>;
  /** Code provided by the third-party */
  code: Scalars['String']['input'];
  provider: ExternalAuthProviderEnum;
  /** Redirect URL used when authenticating */
  redirect: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountOAuthConnect. */
export type AccountOAuthConnectPayload = {
  __typename?: 'AccountOAuthConnectPayload';
  errors: Maybe<Array<AccountOAuthConnectErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountOAuthDisconnectErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type AccountOAuthDisconnectInput = {
  /** You might have multiple of the same connection, this ID specifies which you wish to disconnect */
  id: InputMaybe<Scalars['UUID']['input']>;
  provider: ExternalAuthProviderEnum;
};

/** Autogenerated return type of AccountOAuthDisconnect. */
export type AccountOAuthDisconnectPayload = {
  __typename?: 'AccountOAuthDisconnectPayload';
  errors: Maybe<Array<AccountOAuthDisconnectErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountOtpCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountOtpCreateInput = {
  code: Scalars['String']['input'];
  key: Scalars['String']['input'];
  raw: Scalars['String']['input'];
};

/** Autogenerated return type of AccountOtpCreate. */
export type AccountOtpCreatePayload = {
  __typename?: 'AccountOtpCreatePayload';
  errors: Maybe<Array<AccountOtpCreateErrorsUnion>>;
  result: Maybe<Api_RecoveryCodes>;
};

export type AccountOtpDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountOtpDeleteInput = {
  otp: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountOtpDelete. */
export type AccountOtpDeletePayload = {
  __typename?: 'AccountOtpDeletePayload';
  errors: Maybe<Array<AccountOtpDeleteErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountOtpSetupErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

/** Autogenerated return type of AccountOtpSetup. */
export type AccountOtpSetupPayload = {
  __typename?: 'AccountOtpSetupPayload';
  errors: Maybe<Array<AccountOtpSetupErrorsUnion>>;
  result: Maybe<Api_OtpSetupCode>;
};

export type AccountOtpVerifyErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type AccountOtpVerifyInput = {
  otp: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountOtpVerify. */
export type AccountOtpVerifyPayload = {
  __typename?: 'AccountOtpVerifyPayload';
  errors: Maybe<Array<AccountOtpVerifyErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountOverviewBillboardInput = {
  buttonText: InputMaybe<Scalars['SanitizedString']['input']>;
  buttonUrl: InputMaybe<Scalars['SanitizedString']['input']>;
  ctaText: InputMaybe<Scalars['SanitizedString']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountOverviewCarouselCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountOverviewCarouselCreateInput = {
  /** The URL to link to when the carousel item is clicked */
  linkUrl: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The position to insert the carousel item at */
  position: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the record to add to the carousel */
  recordId: Scalars['UUID']['input'];
  /** The type of record to add to the carousel */
  recordType: AccountOverviewMediaEnum;
};

/** Autogenerated return type of AccountOverviewCarouselCreate. */
export type AccountOverviewCarouselCreatePayload = {
  __typename?: 'AccountOverviewCarouselCreatePayload';
  errors: Maybe<Array<AccountOverviewCarouselCreateErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountOverviewCarouselDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountOverviewCarouselDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of AccountOverviewCarouselDelete. */
export type AccountOverviewCarouselDeletePayload = {
  __typename?: 'AccountOverviewCarouselDeletePayload';
  errors: Maybe<Array<AccountOverviewCarouselDeleteErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountOverviewCarouselRecordUnion = Api_AccountAttachment | Api_MuxAsset;

export type AccountOverviewCarouselUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountOverviewCarouselUpdateInput = {
  id: Scalars['UUID']['input'];
  linkUrl: InputMaybe<Scalars['SanitizedString']['input']>;
  position: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AccountOverviewCarouselUpdate. */
export type AccountOverviewCarouselUpdatePayload = {
  __typename?: 'AccountOverviewCarouselUpdatePayload';
  errors: Maybe<Array<AccountOverviewCarouselUpdateErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export const enum AccountOverviewMediaEnum {
  Accountattachment = 'ACCOUNTATTACHMENT',
  Muxasset = 'MUXASSET'
}

export type AccountOverviewSectionInput = {
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  position: InputMaybe<Scalars['Int']['input']>;
};

export type AccountOverviewSectionsInput = {
  aboutMe: InputMaybe<AccountOverviewSectionInput>;
  billboard: InputMaybe<AccountOverviewBillboardInput>;
  community: InputMaybe<AccountOverviewSectionInput>;
  discordServerAccess: InputMaybe<AccountOverviewSectionInput>;
  faq: InputMaybe<AccountOverviewSectionInput>;
  productCoaching: InputMaybe<AccountOverviewSectionInput>;
  productEvent: InputMaybe<AccountOverviewSectionInput>;
  productGuide: InputMaybe<AccountOverviewSectionInput>;
  supporterTiers: InputMaybe<AccountOverviewSectionInput>;
  testimonials: InputMaybe<AccountOverviewSectionInput>;
};

export type AccountOverviewUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountOverviewUpdateInput = {
  overview: AccountOverviewUpdateOverviewInput;
};

export type AccountOverviewUpdateOverviewInput = {
  sections: AccountOverviewSectionsInput;
};

/** Autogenerated return type of AccountOverviewUpdate. */
export type AccountOverviewUpdatePayload = {
  __typename?: 'AccountOverviewUpdatePayload';
  errors: Maybe<Array<AccountOverviewUpdateErrorsUnion>>;
  result: Api_Account;
};

export type AccountPasswordEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountPasswordEditInput = {
  /** Your new password */
  newPassword: Scalars['String']['input'];
  /** Your existing password */
  password: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountPasswordEdit. */
export type AccountPasswordEditPayload = {
  __typename?: 'AccountPasswordEditPayload';
  errors: Maybe<Array<AccountPasswordEditErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountProviderCreateInput = {
  /** Code provided by the third-party */
  code: Scalars['String']['input'];
  locale: Scalars['SanitizedString']['input'];
  name: Scalars['SanitizedString']['input'];
  provider: ExternalAuthProviderEnum;
  /** Redirect URL used when authenticating */
  redirect: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['SanitizedString']['input'];
};

export type AccountProviderLoginInput = {
  /** Code provided by the third-party */
  code: Scalars['String']['input'];
  provider: ExternalAuthProviderEnum;
  /** Redirect URL used when authenticating */
  redirect: InputMaybe<Scalars['String']['input']>;
};

export type AccountRecoveryCodesErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type AccountRecoveryCodesInput = {
  otp: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountRecoveryCodes. */
export type AccountRecoveryCodesPayload = {
  __typename?: 'AccountRecoveryCodesPayload';
  errors: Maybe<Array<AccountRecoveryCodesErrorsUnion>>;
  result: Maybe<Api_RecoveryCodes>;
};

export type AccountRefreshTokenErrorsUnion = NotAuthorizedError | ValidationError;

export type AccountRefreshTokenInput = {
  /** You should not pass an Authorization header when refreshing the token */
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

/** Autogenerated return type of AccountRefreshToken. */
export type AccountRefreshTokenPayload = {
  __typename?: 'AccountRefreshTokenPayload';
  errors: Maybe<Array<AccountRefreshTokenErrorsUnion>>;
  result: Maybe<Api_AuthenticationToken>;
};

export type AccountResetPasswordErrorsUnion = AuthenticatedError | ValidationError;

export type AccountResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of AccountResetPassword. */
export type AccountResetPasswordPayload = {
  __typename?: 'AccountResetPasswordPayload';
  errors: Maybe<Array<AccountResetPasswordErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountResetPasswordRequestErrorsUnion = AuthenticatedError | ValidationError;

export type AccountResetPasswordRequestInput = {
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AccountResetPasswordRequest. */
export type AccountResetPasswordRequestPayload = {
  __typename?: 'AccountResetPasswordRequestPayload';
  errors: Maybe<Array<AccountResetPasswordRequestErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountSessionRemoveErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type AccountSessionRemoveInput = {
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AccountSessionRemove. */
export type AccountSessionRemovePayload = {
  __typename?: 'AccountSessionRemovePayload';
  errors: Maybe<Array<AccountSessionRemoveErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type AccountSocialAccountsInput = {
  discord: InputMaybe<Scalars['SanitizedString']['input']>;
  discordServer: InputMaybe<Scalars['SanitizedString']['input']>;
  externalSite: InputMaybe<Scalars['SanitizedString']['input']>;
  facebook: InputMaybe<Scalars['SanitizedString']['input']>;
  instagram: InputMaybe<Scalars['SanitizedString']['input']>;
  tiktok: InputMaybe<Scalars['SanitizedString']['input']>;
  twitch: InputMaybe<Scalars['SanitizedString']['input']>;
  twitter: InputMaybe<Scalars['SanitizedString']['input']>;
  youtube: InputMaybe<Scalars['SanitizedString']['input']>;
};

export const enum AccountSortEnum {
  Price = 'PRICE',
  Top = 'TOP'
}

export type AccountSortOption = {
  direction: SortDirection;
  on: AccountSortEnum;
};

export type AccountUpdateInput = {
  afkEndDate: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  availability: InputMaybe<Scalars['JSON']['input']>;
  avatar: InputMaybe<UploadAssetInput>;
  avatarIndex: InputMaybe<Scalars['Int']['input']>;
  bio: InputMaybe<Scalars['SanitizedString']['input']>;
  bookingNotice: InputMaybe<AccountBookingNoticeInput>;
  country: InputMaybe<Scalars['SanitizedString']['input']>;
  cover: InputMaybe<UploadAssetInput>;
  dailyLimitMinutes: InputMaybe<AccountDailyLimitMinutesInput>;
  email: InputMaybe<Scalars['SanitizedString']['input']>;
  faqCover: InputMaybe<UploadAssetInput>;
  feeCover: InputMaybe<AccountFeeCoverInput>;
  isAfk: InputMaybe<Scalars['Boolean']['input']>;
  languages: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  optimizedScheduling: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['SanitizedString']['input']>;
  socialAccounts: InputMaybe<AccountSocialAccountsInput>;
  timezone: InputMaybe<Scalars['SanitizedString']['input']>;
  useCreditForMetafyPro: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountVerifyEmailErrorsUnion = ValidationError;

export type AccountVerifyEmailInput = {
  token: Scalars['String']['input'];
};

/** Autogenerated return type of AccountVerifyEmail. */
export type AccountVerifyEmailPayload = {
  __typename?: 'AccountVerifyEmailPayload';
  errors: Maybe<Array<AccountVerifyEmailErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type AccountVerifyEmailResendErrorsUnion = NotAuthenticatedError;

/** Autogenerated return type of AccountVerifyEmailResend. */
export type AccountVerifyEmailResendPayload = {
  __typename?: 'AccountVerifyEmailResendPayload';
  errors: Maybe<Array<AccountVerifyEmailResendErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ApiKeyCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type ApiKeyCreateInput = {
  /** A description for the api key */
  description: Scalars['SanitizedString']['input'];
  /** The scopes for the api key */
  scopes: InputMaybe<Array<ScopeEnum>>;
};

/** Autogenerated return type of ApiKeyCreate. */
export type ApiKeyCreatePayload = {
  __typename?: 'ApiKeyCreatePayload';
  errors: Maybe<Array<ApiKeyCreateErrorsUnion>>;
  result: Maybe<Api_ApiKey>;
};

export type ApiKeyDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ApiKeyDeleteInput = {
  /** The ID of the API key to delete */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ApiKeyDelete. */
export type ApiKeyDeletePayload = {
  __typename?: 'ApiKeyDeletePayload';
  errors: Maybe<Array<ApiKeyDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ApiKeyUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ApiKeyUpdateInput = {
  /** Whether the API key is disabled */
  disabled: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the API key */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ApiKeyUpdate. */
export type ApiKeyUpdatePayload = {
  __typename?: 'ApiKeyUpdatePayload';
  errors: Maybe<Array<ApiKeyUpdateErrorsUnion>>;
  result: Maybe<Api_ApiKey>;
};

/** The mutation requires an unauthenticated user, you should log out of your existing session before calling this mutation. */
export type AuthenticatedError = Error & {
  __typename?: 'AuthenticatedError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

export type BillingCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ThreeDSecureError | ValidationError;

export type BillingCreateInput = {
  /** The billing address */
  address: InputMaybe<RecurlyAddressInput>;
  /** The payment gateway references */
  paymentGatewayReferences: InputMaybe<Array<RecurlyPaymentGatewayReferenceInput>>;
  /** The secure token returned by the 3-D Secure flow */
  secureTokenId: InputMaybe<Scalars['ID']['input']>;
  /** The token returned by Recurly.js */
  tokenId: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of BillingCreate. */
export type BillingCreatePayload = {
  __typename?: 'BillingCreatePayload';
  errors: Maybe<Array<BillingCreateErrorsUnion>>;
  result: Maybe<Api_PaymentMethod>;
};

export type BillingDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

/** Autogenerated return type of BillingDelete. */
export type BillingDeletePayload = {
  __typename?: 'BillingDeletePayload';
  errors: Maybe<Array<BillingDeleteErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export const enum BillingEnum {
  /** One-time billing */
  OneTime = 'ONE_TIME',
  /** Recurring billing */
  Recurring = 'RECURRING'
}

export const enum BillingFrequencyEnum {
  /** Day */
  Day = 'DAY',
  /** Month */
  Month = 'MONTH',
  /** Once */
  Once = 'ONCE',
  /** Week */
  Week = 'WEEK',
  /** Year */
  Year = 'YEAR'
}

export const enum BlockLayoutBlockActionEnum {
  /** Add a block */
  Add = 'ADD',
  /** Preview a block */
  Preview = 'PREVIEW',
  /** Remove a block */
  Remove = 'REMOVE',
  /** Update a block */
  Update = 'UPDATE'
}

export type BlockLayoutBlockBlockInput = {
  action: BlockLayoutBlockActionEnum;
  blockType: BlockLayoutBlockEnum;
  /** The desktop layout of the block */
  desktop: InputMaybe<BlockLayoutBlockGridInput>;
  id: InputMaybe<Scalars['UUID']['input']>;
  /** The mobile layout of the block */
  mobile: InputMaybe<BlockLayoutBlockGridInput>;
  properties: InputMaybe<BlockLayoutBlockDataInput>;
};

export const enum BlockLayoutBlockCopyTextFormatEnum {
  /** Discord Username */
  DiscordUsername = 'DISCORD_USERNAME'
}

export type BlockLayoutBlockCopyTextInput = {
  format: BlockLayoutBlockCopyTextFormatEnum;
  text: Scalars['SanitizedString']['input'];
};

export type BlockLayoutBlockDataInput = {
  copyText: InputMaybe<BlockLayoutBlockCopyTextInput>;
  gif: InputMaybe<BlockLayoutBlockGifInput>;
  groupSupporter: InputMaybe<BlockLayoutBlockGroupSupporterInput>;
  image: InputMaybe<BlockLayoutBlockImageInput>;
  link: InputMaybe<BlockLayoutBlockLinkInput>;
  post: InputMaybe<BlockLayoutBlockPostInput>;
  quote: InputMaybe<BlockLayoutBlockQuoteInput>;
  recordId: InputMaybe<Scalars['UUID']['input']>;
  video: InputMaybe<BlockLayoutBlockVideoInput>;
};

export const enum BlockLayoutBlockEnum {
  /** An achievement block */
  Achievement = 'ACHIEVEMENT',
  /** A copy text block */
  CopyText = 'COPY_TEXT',
  /** A faq block */
  Faq = 'FAQ',
  /** A gif block */
  Gif = 'GIF',
  /** A group block */
  Group = 'GROUP',
  /** A group avatar block */
  GroupAvatar = 'GROUP_AVATAR',
  /** A group description block */
  GroupDescription = 'GROUP_DESCRIPTION',
  /** A group supporter block */
  GroupSupporter = 'GROUP_SUPPORTER',
  /** A group tier block */
  GroupTier = 'GROUP_TIER',
  /** An image block */
  Image = 'IMAGE',
  /** A link block */
  Link = 'LINK',
  /** A post block */
  Post = 'POST',
  /** A product coaching block */
  ProductCoaching = 'PRODUCT_COACHING',
  /** A guide block */
  ProductGuide = 'PRODUCT_GUIDE',
  /** A quote block */
  Quote = 'QUOTE',
  /** A video block */
  Video = 'VIDEO',
  /** A single testimonial block */
  VideoTestimonial = 'VIDEO_TESTIMONIAL',
  /** A written testimonial block */
  WrittenTestimonial = 'WRITTEN_TESTIMONIAL'
}

export type BlockLayoutBlockGifImageInput = {
  dims: Array<Scalars['Int']['input']>;
  duration: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  preview: Scalars['SanitizedString']['input'];
  size: Scalars['Int']['input'];
  url: Scalars['SanitizedString']['input'];
};

export type BlockLayoutBlockGifInput = {
  image: BlockLayoutBlockGifImageInput;
  provider: BlockLayoutBlockImageProviderEnum;
};

export type BlockLayoutBlockGridInput = {
  h: InputMaybe<Scalars['Int']['input']>;
  /** Whether the block is shown */
  show: InputMaybe<Scalars['Boolean']['input']>;
  w: InputMaybe<Scalars['Int']['input']>;
  x: InputMaybe<Scalars['Int']['input']>;
  y: InputMaybe<Scalars['Int']['input']>;
};

export type BlockLayoutBlockGroupSupporterInput = {
  description: Scalars['SanitizedString']['input'];
  title: Scalars['SanitizedString']['input'];
};

export type BlockLayoutBlockImageInput = {
  altText: InputMaybe<Scalars['SanitizedString']['input']>;
  url: Scalars['SanitizedString']['input'];
};

export const enum BlockLayoutBlockImageProviderEnum {
  /** Tenor */
  Tenor = 'tenor'
}

export type BlockLayoutBlockLinkInput = {
  customTitle: InputMaybe<Scalars['SanitizedString']['input']>;
  url: Scalars['SanitizedString']['input'];
};

export const enum BlockLayoutBlockLinkSourceEnum {
  /** Discord */
  Discord = 'discord',
  /** Discord Server */
  DiscordServer = 'discord_server',
  /** External Website */
  ExternalWebsite = 'external_website',
  /** Facebook */
  Facebook = 'facebook',
  /** Instagram */
  Instagram = 'instagram',
  /** TikTok */
  Tiktok = 'tiktok',
  /** Twitch */
  Twitch = 'twitch',
  /** Twitter */
  Twitter = 'twitter',
  /** X */
  X = 'x',
  /** YouTube */
  Youtube = 'youtube'
}

export type BlockLayoutBlockPostInput = {
  color: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type BlockLayoutBlockPreviewErrorsUnion = NotAuthenticatedError | NotFoundError | ValidationError;

export type BlockLayoutBlockPreviewInput = {
  block: BlockLayoutBlockBlockInput;
  layoutId: Scalars['UUID']['input'];
};

/** Autogenerated return type of BlockLayoutBlockPreview. */
export type BlockLayoutBlockPreviewPayload = {
  __typename?: 'BlockLayoutBlockPreviewPayload';
  errors: Maybe<Array<BlockLayoutBlockPreviewErrorsUnion>>;
  result: Maybe<Api_BlockLayoutBlock>;
};

export type BlockLayoutBlockQuoteBackgroundInput = {
  align: Scalars['SanitizedString']['input'];
  color: InputMaybe<Scalars['SanitizedString']['input']>;
  justify: Scalars['SanitizedString']['input'];
  size: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type BlockLayoutBlockQuoteInput = {
  background: InputMaybe<BlockLayoutBlockQuoteBackgroundInput>;
  quote: Scalars['SanitizedString']['input'];
};

export type BlockLayoutBlockRecordUnion =
  | Api_AccountAttachment
  | Api_CoachAchievement
  | Api_Group
  | Api_GroupTier
  | Api_MuxAsset
  | Api_Post
  | Api_Product
  | Api_ProductCoaching
  | Api_Testimonial;

export type BlockLayoutBlockVideoInput = {
  url: Scalars['SanitizedString']['input'];
};

export const enum BlockLayoutBlockVideoSourceEnum {
  /** Mux */
  Mux = 'MUX',
  /** Vimeo */
  Vimeo = 'VIMEO',
  /** YouTube */
  Youtube = 'YOUTUBE'
}

export type BlockLayoutUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type BlockLayoutUpdateInput = {
  blocks: InputMaybe<Array<BlockLayoutBlockBlockInput>>;
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of BlockLayoutUpdate. */
export type BlockLayoutUpdatePayload = {
  __typename?: 'BlockLayoutUpdatePayload';
  errors: Maybe<Array<BlockLayoutUpdateErrorsUnion>>;
  result: Maybe<Api_BlockLayout>;
};

export const enum CancelationPolicyPolicyEnum {
  /** Cancelation */
  Cancelation = 'CANCELATION',
  /** Reschedule */
  Reschedule = 'RESCHEDULE'
}

export const enum CancelationPolicyTimeUnitEnum {
  /** Days */
  Day = 'DAY',
  /** Hours */
  Hour = 'HOUR',
  /** Weeks */
  Week = 'WEEK'
}

export type ChangeLogSeenErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ChangeLogSeenInput = {
  id: InputMaybe<Scalars['UUID']['input']>;
  identifier: InputMaybe<Scalars['SanitizedString']['input']>;
};

/** Autogenerated return type of ChangeLogSeen. */
export type ChangeLogSeenPayload = {
  __typename?: 'ChangeLogSeenPayload';
  errors: Maybe<Array<ChangeLogSeenErrorsUnion>>;
  result: Maybe<Api_ChangeLog>;
};

export type ChatMarkReadErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ChatMarkReadInput = {
  chatRoomId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatMarkRead. */
export type ChatMarkReadPayload = {
  __typename?: 'ChatMarkReadPayload';
  errors: Maybe<Array<ChatMarkReadErrorsUnion>>;
  result: Maybe<Api_ChatMember>;
};

export type ChatMessageDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ChatMessageDeleteInput = {
  chatMessageId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatMessageDelete. */
export type ChatMessageDeletePayload = {
  __typename?: 'ChatMessageDeletePayload';
  errors: Maybe<Array<ChatMessageDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export const enum ChatMessageEnum {
  /** Plain text message */
  Plain = 'PLAIN',
  /** Question asked */
  Question = 'QUESTION'
}

export type ChatMessageLikeErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ChatMessageLikeInput = {
  chatMessageId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatMessageLike. */
export type ChatMessageLikePayload = {
  __typename?: 'ChatMessageLikePayload';
  errors: Maybe<Array<ChatMessageLikeErrorsUnion>>;
  result: Maybe<Api_ChatMessage>;
};

export type ChatMessageMarkAnsweredErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ChatMessageMarkAnsweredInput = {
  chatMessageId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatMessageMarkAnswered. */
export type ChatMessageMarkAnsweredPayload = {
  __typename?: 'ChatMessageMarkAnsweredPayload';
  errors: Maybe<Array<ChatMessageMarkAnsweredErrorsUnion>>;
  result: Maybe<Api_ChatMessage>;
};

export type ChatMessageSendErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ChatMessageSendInput = {
  accountId: InputMaybe<Scalars['UUID']['input']>;
  chatRoomId: InputMaybe<Scalars['UUID']['input']>;
  content: Scalars['SanitizedString']['input'];
  messageType: InputMaybe<ChatMessageEnum>;
  orderId: InputMaybe<Scalars['UUID']['input']>;
  parentId: InputMaybe<Scalars['UUID']['input']>;
};

/** Autogenerated return type of ChatMessageSend. */
export type ChatMessageSendPayload = {
  __typename?: 'ChatMessageSendPayload';
  errors: Maybe<Array<ChatMessageSendErrorsUnion>>;
  result: Maybe<Api_ChatMessage>;
};

export const enum ChatMessageSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type ChatMessageSortOption = {
  direction: SortDirection;
  on: ChatMessageSortEnum;
};

export type ChatMessageUnlikeErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ChatMessageUnlikeInput = {
  chatMessageLikeId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatMessageUnlike. */
export type ChatMessageUnlikePayload = {
  __typename?: 'ChatMessageUnlikePayload';
  errors: Maybe<Array<ChatMessageUnlikeErrorsUnion>>;
  result: Maybe<Api_ChatMessage>;
};

export type ChatReactionCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ChatReactionCreateInput = {
  chatMessageId: Scalars['UUID']['input'];
  emoteId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatReactionCreate. */
export type ChatReactionCreatePayload = {
  __typename?: 'ChatReactionCreatePayload';
  errors: Maybe<Array<ChatReactionCreateErrorsUnion>>;
  result: Maybe<Api_ChatMessage>;
};

export type ChatReactionDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ChatReactionDeleteInput = {
  /** The ID of the reaction to remove */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ChatReactionDelete. */
export type ChatReactionDeletePayload = {
  __typename?: 'ChatReactionDeletePayload';
  errors: Maybe<Array<ChatReactionDeleteErrorsUnion>>;
  result: Maybe<Api_ChatMessage>;
};

export const enum ChatRoomEnum {
  /** Direct message between two users */
  Dm = 'DM',
  /** Event chatroom */
  Event = 'EVENT'
}

export type CoachingIntakeQuestionAnswerErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type CoachingIntakeQuestionAnswerInput = {
  /** The answer to the intake question */
  answer: Scalars['SanitizedString']['input'];
  /** The ID of the intake question to answer */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of CoachingIntakeQuestionAnswer. */
export type CoachingIntakeQuestionAnswerPayload = {
  __typename?: 'CoachingIntakeQuestionAnswerPayload';
  errors: Maybe<Array<CoachingIntakeQuestionAnswerErrorsUnion>>;
  result: Maybe<Api_PurchasedProductCoachingIntakeQuestion>;
};

export const enum CoachingPageAccountsQueryEnum {
  /** Community accounts */
  Community = 'COMMUNITY',
  /** New accounts */
  New = 'NEW',
  /** Top accounts */
  Top = 'TOP',
  /** Trending accounts */
  Trending = 'TRENDING'
}

export const enum CoachingRoleEnum {
  /** The user is an attendee of the coaching session */
  Attendee = 'ATTENDEE',
  /** The user is the host of the coaching session */
  Host = 'HOST'
}

export type CoachingSessionAcceptErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type CoachingSessionAcceptInput = {
  /** The ID of the coaching product session to accept */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of CoachingSessionAccept. */
export type CoachingSessionAcceptPayload = {
  __typename?: 'CoachingSessionAcceptPayload';
  errors: Maybe<Array<CoachingSessionAcceptErrorsUnion>>;
  result: Maybe<Api_PurchasedProductCoachingSession>;
};

export type CoachingSessionAcceptRescheduleErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type CoachingSessionAcceptRescheduleInput = {
  /** The ID of the coaching product session to accept */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of CoachingSessionAcceptReschedule. */
export type CoachingSessionAcceptReschedulePayload = {
  __typename?: 'CoachingSessionAcceptReschedulePayload';
  errors: Maybe<Array<CoachingSessionAcceptRescheduleErrorsUnion>>;
  result: Maybe<Api_PurchasedProductCoachingSession>;
};

export type CoachingSessionCancelErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type CoachingSessionCancelInput = {
  /** A message to send when cancelling the session */
  cancelationMessage: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The reason for cancelling the session */
  cancelationReason: InputMaybe<Scalars['String']['input']>;
  /** The ID of the coaching product session to schedule */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of CoachingSessionCancel. */
export type CoachingSessionCancelPayload = {
  __typename?: 'CoachingSessionCancelPayload';
  errors: Maybe<Array<CoachingSessionCancelErrorsUnion>>;
  result: Maybe<Api_PurchasedProductCoachingSession>;
};

export type CoachingSessionRequestRescheduleErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type CoachingSessionRequestRescheduleInput = {
  /** The ID of the coaching product session to schedule */
  id: Scalars['UUID']['input'];
  /** A message to send to the attendee when requesting to reschedule the session */
  message: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The date and time to schedule the session */
  scheduledAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of CoachingSessionRequestReschedule. */
export type CoachingSessionRequestReschedulePayload = {
  __typename?: 'CoachingSessionRequestReschedulePayload';
  errors: Maybe<Array<CoachingSessionRequestRescheduleErrorsUnion>>;
  result: Maybe<Api_PurchasedProductCoachingSession>;
};

export type CoachingSessionScheduleErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type CoachingSessionScheduleInput = {
  /** The ID of the coaching product session to schedule */
  id: Scalars['UUID']['input'];
  /** The date and time to schedule the session */
  scheduledAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CoachingSessionSchedule. */
export type CoachingSessionSchedulePayload = {
  __typename?: 'CoachingSessionSchedulePayload';
  errors: Maybe<Array<CoachingSessionScheduleErrorsUnion>>;
  result: Maybe<Api_PurchasedProductCoachingSession>;
};

export const enum CoachingSessionStateEnum {
  /** The coaching product has been canceled */
  Cancelled = 'CANCELLED',
  /** The coaching product has been completed */
  Completed = 'COMPLETED',
  /** The coaching product is confirmed */
  Confirmed = 'CONFIRMED',
  /** The coaching product has been fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The coaching product has been partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The coaching product has been scheduled and is pending acceptaqnce */
  Pending = 'PENDING',
  /** The coaching product has been rescheduled and is pending reacceptance */
  Rescheduled = 'RESCHEDULED',
  /** The coaching has been requested to be recheduled */
  Rescheduling = 'RESCHEDULING',
  /** The coaching product is unscheduled */
  Unscheduled = 'UNSCHEDULED',
  /** The coaching product has been voided */
  Void = 'VOID'
}

export const enum CoachingStateEnum {
  /** The coaching product has been canceled */
  Canceled = 'CANCELED',
  /** The coaching product has been completed */
  Completed = 'COMPLETED',
  /** The coaching product has been fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The coaching product is in progress */
  InProgress = 'IN_PROGRESS',
  /** The coaching product has been partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The coaching product has been voided */
  Void = 'VOID'
}

export type ConnectionDiscountInput = {
  eventDiscountType: InputMaybe<CouponDiscountEnum>;
  eventDiscountValue: InputMaybe<Scalars['Int']['input']>;
  groupTierDiscountType: InputMaybe<CouponDiscountEnum>;
  groupTierDiscountValue: InputMaybe<Scalars['Int']['input']>;
  guideDiscountType: InputMaybe<CouponDiscountEnum>;
  guideDiscountValue: InputMaybe<Scalars['Int']['input']>;
  sessionDiscountType: InputMaybe<CouponDiscountEnum>;
  sessionDiscountValue: InputMaybe<Scalars['Int']['input']>;
};

export type CouponCreateErrorsUnion = NotAuthenticatedError | NotFoundError | ValidationError;

export type CouponCreateInput = {
  coupon: CouponCreateNewInput;
};

export type CouponCreateNewInput = {
  code: InputMaybe<Scalars['SanitizedString']['input']>;
  discountType: CouponDiscountEnum;
  discountValue: Scalars['Float']['input'];
  /** The duration the coupon is valid for */
  duration: InputMaybe<CouponDurationEnum>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  limits: InputMaybe<Array<CouponLimitsInputInput>>;
  maxDiscountValue: InputMaybe<Scalars['Float']['input']>;
  maxRedemptions: InputMaybe<Scalars['Int']['input']>;
  maxRedemptionsPerAccount: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  products: InputMaybe<Array<CouponProductProductInput>>;
  supportedProductTypes: InputMaybe<Array<CouponSupportedProductEnum>>;
  /** The duration the coupon is valid for in months */
  temporalAmount: InputMaybe<Scalars['Int']['input']>;
  validFrom: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of CouponCreate. */
export type CouponCreatePayload = {
  __typename?: 'CouponCreatePayload';
  errors: Maybe<Array<CouponCreateErrorsUnion>>;
  result: Maybe<Api_Coupon>;
};

export type CouponDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type CouponDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of CouponDelete. */
export type CouponDeletePayload = {
  __typename?: 'CouponDeletePayload';
  errors: Maybe<Array<CouponDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export const enum CouponDiscountEnum {
  /** A fixed discount amount */
  Fixed = 'FIXED',
  /** A free trial discount amount */
  FreeTrial = 'FREE_TRIAL',
  /** A percentage discount amount */
  Percentage = 'PERCENTAGE'
}

export const enum CouponDurationEnum {
  /** The coupon is valid forever */
  Forever = 'FOREVER',
  /** The coupon is valid for a single use */
  SingleUse = 'SINGLE_USE',
  /** The coupon is valid for a temporal amount of time */
  Temporal = 'TEMPORAL'
}

export type CouponLimitsInputInput = {
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  maxRedemptions: InputMaybe<Scalars['Int']['input']>;
  maxRedemptionsPerAccount: InputMaybe<Scalars['Int']['input']>;
  productType: InputMaybe<ProductEnum>;
};

export type CouponProductProductInput = {
  id: Scalars['UUID']['input'];
  productType: CouponSupportedProductEnum;
};

export type CouponProductRecordUnion = Api_GroupTier | Api_Product;

export const enum CouponSortEnum {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  ExpiresAt = 'EXPIRES_AT',
  MaxRedemptions = 'MAX_REDEMPTIONS',
  Name = 'NAME',
  RedeemedCount = 'REDEEMED_COUNT',
  ValidFrom = 'VALID_FROM'
}

export type CouponSortOption = {
  direction: SortDirection;
  on: CouponSortEnum;
};

export const enum CouponSupportedProductEnum {
  /** A collection of one or more coaching sessions */
  Coaching = 'COACHING',
  /** A live event */
  Event = 'EVENT',
  /** A group supporter subscription */
  GroupSupporter = 'GROUP_SUPPORTER',
  /** A guide for a product */
  Guide = 'GUIDE',
  /** A one-time setup fee for a subscription */
  SetupFee = 'SETUP_FEE'
}

export type CouponUpdateErrorsUnion = NotAuthenticatedError | NotFoundError | ValidationError;

export type CouponUpdateExistingInput = {
  code: InputMaybe<Scalars['SanitizedString']['input']>;
  discountType: CouponDiscountEnum;
  discountValue: Scalars['Float']['input'];
  /** The duration the coupon is valid for */
  duration: InputMaybe<CouponDurationEnum>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  limits: InputMaybe<Array<CouponLimitsInputInput>>;
  maxDiscountValue: InputMaybe<Scalars['Float']['input']>;
  maxRedemptions: InputMaybe<Scalars['Int']['input']>;
  maxRedemptionsPerAccount: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  products: InputMaybe<Array<CouponProductProductInput>>;
  supportedProductTypes: InputMaybe<Array<CouponSupportedProductEnum>>;
  /** The duration the coupon is valid for in months */
  temporalAmount: InputMaybe<Scalars['Int']['input']>;
  validFrom: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type CouponUpdateInput = {
  coupon: CouponUpdateExistingInput;
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of CouponUpdate. */
export type CouponUpdatePayload = {
  __typename?: 'CouponUpdatePayload';
  errors: Maybe<Array<CouponUpdateErrorsUnion>>;
  result: Maybe<Api_Coupon>;
};

export const enum DiscordGuildGateEnum {
  Members = 'MEMBERS',
  Public = 'PUBLIC',
  Tier = 'TIER'
}

export type DiscordRefreshRolesErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type DiscordRefreshRolesInput = {
  discordGuildId: Scalars['UUID']['input'];
};

/** Autogenerated return type of DiscordRefreshRoles. */
export type DiscordRefreshRolesPayload = {
  __typename?: 'DiscordRefreshRolesPayload';
  errors: Maybe<Array<DiscordRefreshRolesErrorsUnion>>;
  result: Maybe<Api_DiscordGuild>;
};

export type DiscordRequestInviteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type DiscordRequestInviteInput = {
  discordGuildId: Scalars['UUID']['input'];
  groupMemberId: InputMaybe<Scalars['UUID']['input']>;
};

/** Autogenerated return type of DiscordRequestInvite. */
export type DiscordRequestInvitePayload = {
  __typename?: 'DiscordRequestInvitePayload';
  errors: Maybe<Array<DiscordRequestInviteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type DiscordSyncRolesErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type DiscordSyncRolesInput = {
  discordGuildId: InputMaybe<Scalars['UUID']['input']>;
  groupMemberId: InputMaybe<Scalars['UUID']['input']>;
  metafy: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DiscordSyncRoles. */
export type DiscordSyncRolesPayload = {
  __typename?: 'DiscordSyncRolesPayload';
  errors: Maybe<Array<DiscordSyncRolesErrorsUnion>>;
  result: Maybe<Api_GroupMember>;
};

export type DiscordUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type DiscordUpdateInput = {
  assignableRoles: InputMaybe<Array<Scalars['UUID']['input']>>;
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  discordGuildId: InputMaybe<Scalars['UUID']['input']>;
  gate: InputMaybe<DiscordGuildGateEnum>;
};

/** Autogenerated return type of DiscordUpdate. */
export type DiscordUpdatePayload = {
  __typename?: 'DiscordUpdatePayload';
  errors: Maybe<Array<DiscordUpdateErrorsUnion>>;
  result: Maybe<Api_DiscordGuild>;
};

export const enum EarningThresholdEnum {
  Earned_1K = 'EARNED_1K',
  Earned_10K = 'EARNED_10K',
  Earned_50K = 'EARNED_50K',
  EarnedNothing = 'EARNED_NOTHING'
}

/** Generic error fields used by all errors. */
export type Error = {
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

export const enum EventAttendeeRoleEnum {
  /** The host of the event */
  Host = 'HOST',
  /** Moderator of the event room */
  Moderator = 'MODERATOR',
  /** Can speak in the event */
  Speaker = 'SPEAKER',
  /** Regular viewer */
  User = 'USER'
}

export const enum ExternalAuthProviderEnum {
  /** Apple identity */
  Apple = 'APPLE',
  /** Discord identity */
  Discord = 'DISCORD',
  /** Discord guild */
  DiscordGuild = 'DISCORD_GUILD',
  /** Facebook identity */
  Facebook = 'FACEBOOK',
  /** Google identity */
  Google = 'GOOGLE',
  /** Patreon identity */
  Patreon = 'PATREON',
  /** Twitch identity */
  Twitch = 'TWITCH'
}

export type FeedAnnouncementCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type FeedAnnouncementCreateInput = {
  custom: InputMaybe<FeedAnnouncementInput>;
  postId: InputMaybe<Scalars['UUID']['input']>;
};

/** Autogenerated return type of FeedAnnouncementCreate. */
export type FeedAnnouncementCreatePayload = {
  __typename?: 'FeedAnnouncementCreatePayload';
  errors: Maybe<Array<FeedAnnouncementCreateErrorsUnion>>;
  result: Maybe<Api_Announcement>;
};

export type FeedAnnouncementDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type FeedAnnouncementDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedAnnouncementDelete. */
export type FeedAnnouncementDeletePayload = {
  __typename?: 'FeedAnnouncementDeletePayload';
  errors: Maybe<Array<FeedAnnouncementDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type FeedAnnouncementDismissErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type FeedAnnouncementDismissInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedAnnouncementDismiss. */
export type FeedAnnouncementDismissPayload = {
  __typename?: 'FeedAnnouncementDismissPayload';
  errors: Maybe<Array<FeedAnnouncementDismissErrorsUnion>>;
  result: Maybe<Api_Announcement>;
};

export type FeedAnnouncementInput = {
  coverImage: InputMaybe<UploadAssetInput>;
  description: Scalars['SanitizedString']['input'];
  href: InputMaybe<Scalars['String']['input']>;
  title: Scalars['SanitizedString']['input'];
};

export type FeedAnnouncementsHideErrorsUnion = NotAuthenticatedError | NotAuthorizedError;

/** Autogenerated return type of FeedAnnouncementsHide. */
export type FeedAnnouncementsHidePayload = {
  __typename?: 'FeedAnnouncementsHidePayload';
  errors: Maybe<Array<FeedAnnouncementsHideErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export const enum FeedEnum {
  /** Feed of games, groups, and users that you follow */
  Following = 'FOLLOWING',
  /** Feed for a certain game */
  Game = 'GAME',
  /** The global feed, all public visibile posts */
  Global = 'GLOBAL',
  /** Feed for a certain group */
  Group = 'GROUP',
  /** Feed for a certain group channel */
  GroupChannel = 'GROUP_CHANNEL'
}

export type FeedPollVoteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type FeedPollVoteInput = {
  /** The ID of the Poll Option */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedPollVote. */
export type FeedPollVotePayload = {
  __typename?: 'FeedPollVotePayload';
  errors: Maybe<Array<FeedPollVoteErrorsUnion>>;
  result: Maybe<Api_Poll>;
};

export type FeedPostCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type FeedPostCreateInput = {
  content: InputMaybe<Scalars['String']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  groupChannelId: InputMaybe<Scalars['UUID']['input']>;
  groupId: InputMaybe<Scalars['UUID']['input']>;
  isIcebreaker: InputMaybe<Scalars['Boolean']['input']>;
  parentId: InputMaybe<Scalars['UUID']['input']>;
  poll: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  price: InputMaybe<MoneyInput>;
  purchasable: InputMaybe<Scalars['Boolean']['input']>;
  scheduledAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  tags: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  title: InputMaybe<Scalars['SanitizedString']['input']>;
  uploads: InputMaybe<Array<UploadAssetInput>>;
  videos: InputMaybe<Array<UploadAssetInput>>;
};

/** Autogenerated return type of FeedPostCreate. */
export type FeedPostCreatePayload = {
  __typename?: 'FeedPostCreatePayload';
  errors: Maybe<Array<FeedPostCreateErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export type FeedPostDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type FeedPostDeleteInput = {
  /** The ID of the Post to delete */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedPostDelete. */
export type FeedPostDeletePayload = {
  __typename?: 'FeedPostDeletePayload';
  errors: Maybe<Array<FeedPostDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type FeedPostEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type FeedPostEditInput = {
  content: InputMaybe<Scalars['String']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  isLocked: InputMaybe<Scalars['Boolean']['input']>;
  poll: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  price: InputMaybe<MoneyInput>;
  purchasable: InputMaybe<Scalars['Boolean']['input']>;
  scheduledAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  tags: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  title: InputMaybe<Scalars['SanitizedString']['input']>;
  uploads: InputMaybe<Array<UploadAssetInput>>;
  /** List of upload IDs to remove */
  uploadsToRemove: InputMaybe<Array<Scalars['UUID']['input']>>;
  videos: InputMaybe<Array<UploadAssetInput>>;
};

/** Autogenerated return type of FeedPostEdit. */
export type FeedPostEditPayload = {
  __typename?: 'FeedPostEditPayload';
  errors: Maybe<Array<FeedPostEditErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export type FeedPostPinErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type FeedPostPinInput = {
  groupChannelId: InputMaybe<Scalars['UUID']['input']>;
  groupId: Scalars['UUID']['input'];
  postId: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedPostPin. */
export type FeedPostPinPayload = {
  __typename?: 'FeedPostPinPayload';
  errors: Maybe<Array<FeedPostPinErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export type FeedPostUnpinErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type FeedPostUnpinInput = {
  postId: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedPostUnpin. */
export type FeedPostUnpinPayload = {
  __typename?: 'FeedPostUnpinPayload';
  errors: Maybe<Array<FeedPostUnpinErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export type FeedReactionCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type FeedReactionCreateInput = {
  postId: Scalars['UUID']['input'];
  reaction: ReactionEnum;
};

/** Autogenerated return type of FeedReactionCreate. */
export type FeedReactionCreatePayload = {
  __typename?: 'FeedReactionCreatePayload';
  errors: Maybe<Array<FeedReactionCreateErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export type FeedReactionDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type FeedReactionDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of FeedReactionDelete. */
export type FeedReactionDeletePayload = {
  __typename?: 'FeedReactionDeletePayload';
  errors: Maybe<Array<FeedReactionDeleteErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export const enum FeedSortByEnum {
  Hot = 'HOT',
  Recent = 'RECENT',
  Top = 'TOP'
}

export const enum FeedSortWindowEnum {
  All = 'ALL',
  Month = 'MONTH',
  Today = 'TODAY',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type FeedVoteCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type FeedVoteCreateInput = {
  id: InputMaybe<Scalars['UUID']['input']>;
  voteType: InputMaybe<PostVoteEnum>;
};

/** Autogenerated return type of FeedVoteCreate. */
export type FeedVoteCreatePayload = {
  __typename?: 'FeedVoteCreatePayload';
  errors: Maybe<Array<FeedVoteCreateErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export type FeedVoteDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type FeedVoteDeleteInput = {
  id: InputMaybe<Scalars['UUID']['input']>;
};

/** Autogenerated return type of FeedVoteDelete. */
export type FeedVoteDeletePayload = {
  __typename?: 'FeedVoteDeletePayload';
  errors: Maybe<Array<FeedVoteDeleteErrorsUnion>>;
  result: Maybe<Api_Post>;
};

export const enum FollowEnum {
  Account = 'ACCOUNT',
  All = 'ALL',
  Game = 'GAME'
}

export const enum FollowSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type FollowSortOption = {
  direction: SortDirection;
  on: FollowSortEnum;
};

export const enum GameCommunityArtworkSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type GameCommunityArtworkSortOption = {
  direction: SortDirection;
  on: GameCommunityArtworkSortEnum;
};

export type GameFollowCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GameFollowCreateInput = {
  /** The ID of the game you wish to follow */
  id: Scalars['UUID']['input'];
  /** The position you wish to place the game in your list */
  position: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GameFollowCreate. */
export type GameFollowCreatePayload = {
  __typename?: 'GameFollowCreatePayload';
  errors: Maybe<Array<GameFollowCreateErrorsUnion>>;
  result: Maybe<Api_Game>;
};

export type GameFollowDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GameFollowDeleteInput = {
  /** The ID of the game you wish to unfollow */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GameFollowDelete. */
export type GameFollowDeletePayload = {
  __typename?: 'GameFollowDeletePayload';
  errors: Maybe<Array<GameFollowDeleteErrorsUnion>>;
  result: Maybe<Api_Game>;
};

export const enum GameSortEnum {
  CreatedAt = 'CREATED_AT',
  HomePage = 'HOME_PAGE',
  Popular = 'POPULAR'
}

export type GameSortOption = {
  direction: SortDirection;
  on: GameSortEnum;
};

export type GiftCardRedeemErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GiftCardRedeemInput = {
  code: Scalars['SanitizedString']['input'];
};

/** Autogenerated return type of GiftCardRedeem. */
export type GiftCardRedeemPayload = {
  __typename?: 'GiftCardRedeemPayload';
  errors: Maybe<Array<GiftCardRedeemErrorsUnion>>;
  result: Maybe<Api_GiftCard>;
};

export const enum GiftCardRoleEnum {
  Gifter = 'GIFTER',
  Recipient = 'RECIPIENT'
}

export type GiftCardSendErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GiftCardSendInput = {
  giftCard: GiftCardUpdateInput;
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GiftCardSend. */
export type GiftCardSendPayload = {
  __typename?: 'GiftCardSendPayload';
  errors: Maybe<Array<GiftCardSendErrorsUnion>>;
  result: Maybe<Api_GiftCard>;
};

export const enum GiftCardSortEnum {
  CreatedAt = 'CREATED_AT',
  State = 'STATE',
  Value = 'VALUE'
}

export type GiftCardSortOption = {
  direction: SortDirection;
  on: GiftCardSortEnum;
};

export const enum GiftCardStateEnum {
  /** sdgsdg */
  Canceled = 'CANCELED',
  /** a giftcard that has been purchased but not sent */
  Pending = 'PENDING',
  /** sdg */
  Redeemed = 'REDEEMED',
  /** a giftcard that has been sent to a recipient */
  Sent = 'SENT',
  /** sdgsdg */
  Void = 'VOID'
}

export type GiftCardUpdateInput = {
  anonymousGift: InputMaybe<Scalars['Boolean']['input']>;
  gifterName: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  recipientEmail: InputMaybe<Scalars['String']['input']>;
  recipientName: InputMaybe<Scalars['String']['input']>;
  style: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GoogleEditInput = {
  google: GoogleUpdateInput;
  googleId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GoogleEdit. */
export type GoogleEditPayload = {
  __typename?: 'GoogleEditPayload';
  errors: Maybe<Array<GoogleEditErrorsUnion>>;
  result: Maybe<Api_Google>;
};

export type GoogleUpdateInput = {
  calendarAdd: InputMaybe<Scalars['Boolean']['input']>;
  calendarConflicts: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupBanCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupBanCreateInput = {
  accountId: Scalars['UUID']['input'];
  groupId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupBanCreate. */
export type GroupBanCreatePayload = {
  __typename?: 'GroupBanCreatePayload';
  errors: Maybe<Array<GroupBanCreateErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupBanDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupBanDeleteInput = {
  /** The ID of the ban record */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupBanDelete. */
export type GroupBanDeletePayload = {
  __typename?: 'GroupBanDeletePayload';
  errors: Maybe<Array<GroupBanDeleteErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export const enum GroupBanSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type GroupBanSortOption = {
  direction: SortDirection;
  on: GroupBanSortEnum;
};

export type GroupChannelCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupChannelCreateInput = {
  channel: GroupChannelInput;
  /** The ID of the group */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupChannelCreate. */
export type GroupChannelCreatePayload = {
  __typename?: 'GroupChannelCreatePayload';
  errors: Maybe<Array<GroupChannelCreateErrorsUnion>>;
  result: Maybe<Api_GroupChannel>;
};

export type GroupChannelDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupChannelDeleteInput = {
  /** The ID of the group channel */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupChannelDelete. */
export type GroupChannelDeletePayload = {
  __typename?: 'GroupChannelDeletePayload';
  errors: Maybe<Array<GroupChannelDeleteErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupChannelEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupChannelEditInput = {
  channel: GroupChannelInput;
  /** The ID of the group channel */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupChannelEdit. */
export type GroupChannelEditPayload = {
  __typename?: 'GroupChannelEditPayload';
  errors: Maybe<Array<GroupChannelEditErrorsUnion>>;
  result: Maybe<Api_GroupChannel>;
};

export type GroupChannelInput = {
  position: Scalars['Int']['input'];
  title: Scalars['SanitizedString']['input'];
};

export type GroupEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupEditInput = {
  group: GroupUpdateInput;
  /** The ID of the group */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupEdit. */
export type GroupEditPayload = {
  __typename?: 'GroupEditPayload';
  errors: Maybe<Array<GroupEditErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export const enum GroupInviteSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type GroupInviteSortOption = {
  direction: SortDirection;
  on: GroupInviteSortEnum;
};

export type GroupJoinErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupJoinInput = {
  /** The ID of the group to join */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupJoin. */
export type GroupJoinPayload = {
  __typename?: 'GroupJoinPayload';
  errors: Maybe<Array<GroupJoinErrorsUnion>>;
  result: Maybe<Api_GroupMember>;
};

export type GroupLeaveErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type GroupLeaveInput = {
  /** The ID of the group */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupLeave. */
export type GroupLeavePayload = {
  __typename?: 'GroupLeavePayload';
  errors: Maybe<Array<GroupLeaveErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupMemberDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupMemberDeleteInput = {
  /** The ID of the member to remove */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupMemberDelete. */
export type GroupMemberDeletePayload = {
  __typename?: 'GroupMemberDeletePayload';
  errors: Maybe<Array<GroupMemberDeleteErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupMemberEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupMemberEditInput = {
  /** The ID of the group member */
  id: Scalars['UUID']['input'];
  role: GroupRoleEnum;
};

/** Autogenerated return type of GroupMemberEdit. */
export type GroupMemberEditPayload = {
  __typename?: 'GroupMemberEditPayload';
  errors: Maybe<Array<GroupMemberEditErrorsUnion>>;
  result: Maybe<Api_GroupMember>;
};

export type GroupMemberExtendSubscriptionErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupMemberExtendSubscriptionInput = {
  /** The number of days to extend the subscription */
  days: Scalars['Int']['input'];
  /** The ID of the group member */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupMemberExtendSubscription. */
export type GroupMemberExtendSubscriptionPayload = {
  __typename?: 'GroupMemberExtendSubscriptionPayload';
  errors: Maybe<Array<GroupMemberExtendSubscriptionErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export const enum GroupMemberSortEnum {
  CreatedAt = 'CREATED_AT',
  Leaderboard = 'LEADERBOARD'
}

export type GroupMemberSortOption = {
  direction: SortDirection;
  on: GroupMemberSortEnum;
};

export const enum GroupPostPermissionEnum {
  /** Everyone can post */
  Members = 'MEMBERS',
  /** Admin and Moderators can post */
  Super = 'SUPER'
}

export const enum GroupRequestSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type GroupRequestSortOption = {
  direction: SortDirection;
  on: GroupRequestSortEnum;
};

export const enum GroupRoleEnum {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Moderator = 'MODERATOR',
  Team = 'TEAM'
}

export const enum GroupSortEnum {
  CreatedAt = 'CREATED_AT',
  Members = 'MEMBERS',
  Popular = 'POPULAR',
  RecentActivity = 'RECENT_ACTIVITY',
  Top = 'TOP'
}

export type GroupSortOption = {
  direction: SortDirection;
  on: GroupSortEnum;
};

export type GroupTeamMemberAcceptErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTeamMemberAcceptInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTeamMemberAccept. */
export type GroupTeamMemberAcceptPayload = {
  __typename?: 'GroupTeamMemberAcceptPayload';
  errors: Maybe<Array<GroupTeamMemberAcceptErrorsUnion>>;
  result: Maybe<Api_GroupTeamMember>;
};

export type GroupTeamMemberAddErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTeamMemberAddInput = {
  groupId: Scalars['UUID']['input'];
  member: GroupTeamMemberBaseInput;
};

/** Autogenerated return type of GroupTeamMemberAdd. */
export type GroupTeamMemberAddPayload = {
  __typename?: 'GroupTeamMemberAddPayload';
  errors: Maybe<Array<GroupTeamMemberAddErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupTeamMemberBaseInput = {
  /** The ID of the account */
  accountId: Scalars['UUID']['input'];
  /** The percentage split of revenue you take from non-recurring revenue */
  percentageSplit: InputMaybe<Scalars['Float']['input']>;
  /** The position of the team member in the group */
  position: InputMaybe<Scalars['Int']['input']>;
};

export type GroupTeamMemberRejectErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTeamMemberRejectInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTeamMemberReject. */
export type GroupTeamMemberRejectPayload = {
  __typename?: 'GroupTeamMemberRejectPayload';
  errors: Maybe<Array<GroupTeamMemberRejectErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupTeamMemberRemoveErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTeamMemberRemoveInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTeamMemberRemove. */
export type GroupTeamMemberRemovePayload = {
  __typename?: 'GroupTeamMemberRemovePayload';
  errors: Maybe<Array<GroupTeamMemberRemoveErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export const enum GroupTeamMemberSortEnum {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  State = 'STATE'
}

export type GroupTeamMemberSortOption = {
  direction: SortDirection;
  on: GroupTeamMemberSortEnum;
};

export const enum GroupTeamMemberStateEnum {
  Accepted = 'ACCEPTED',
  Requested = 'REQUESTED'
}

export type GroupTeamMemberUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTeamMemberUpdateExistingInput = {
  /** The percentage split of revenue you take from non-recurring revenue */
  percentageSplit: InputMaybe<Scalars['Float']['input']>;
  /** The position of the team member in the group */
  position: InputMaybe<Scalars['Int']['input']>;
};

export type GroupTeamMemberUpdateInput = {
  id: Scalars['UUID']['input'];
  /** The attributes to update the team member with */
  member: InputMaybe<GroupTeamMemberUpdateExistingInput>;
};

/** Autogenerated return type of GroupTeamMemberUpdate. */
export type GroupTeamMemberUpdatePayload = {
  __typename?: 'GroupTeamMemberUpdatePayload';
  errors: Maybe<Array<GroupTeamMemberUpdateErrorsUnion>>;
  result: Maybe<Api_GroupMember>;
};

export type GroupTierBenefitCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTierBenefitCreateInput = {
  benefit: GroupTierBenefitNewInput;
  tierId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierBenefitCreate. */
export type GroupTierBenefitCreatePayload = {
  __typename?: 'GroupTierBenefitCreatePayload';
  errors: Maybe<Array<GroupTierBenefitCreateErrorsUnion>>;
  result: Maybe<Api_GroupTierBenefit>;
};

export type GroupTierBenefitDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTierBenefitDeleteInput = {
  benefitId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierBenefitDelete. */
export type GroupTierBenefitDeletePayload = {
  __typename?: 'GroupTierBenefitDeletePayload';
  errors: Maybe<Array<GroupTierBenefitDeleteErrorsUnion>>;
  result: Maybe<Api_GroupTier>;
};

export type GroupTierBenefitEditErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTierBenefitEditInput = {
  benefit: GroupTierBenefitUpdateInput;
  benefitId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierBenefitEdit. */
export type GroupTierBenefitEditPayload = {
  __typename?: 'GroupTierBenefitEditPayload';
  errors: Maybe<Array<GroupTierBenefitEditErrorsUnion>>;
  result: Maybe<Api_GroupTierBenefit>;
};

export const enum GroupTierBenefitEnum {
  Coaching = 'COACHING',
  Custom = 'CUSTOM',
  Event = 'EVENT',
  Guide = 'GUIDE',
  SupporterAccess = 'SUPPORTER_ACCESS'
}

export type GroupTierBenefitNewInput = {
  allRecords: InputMaybe<Scalars['Boolean']['input']>;
  benefitType: GroupTierBenefitEnum;
  context: InputMaybe<Scalars['SanitizedString']['input']>;
  discountPercent: InputMaybe<Scalars['Int']['input']>;
  icon: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  recordIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  title: Scalars['SanitizedString']['input'];
};

export type GroupTierBenefitUnion = Api_Product | Api_ProductCoaching;

export type GroupTierBenefitUpdateInput = {
  allRecords: InputMaybe<Scalars['Boolean']['input']>;
  context: InputMaybe<Scalars['SanitizedString']['input']>;
  discountPercent: InputMaybe<Scalars['Int']['input']>;
  icon: InputMaybe<Scalars['String']['input']>;
  position: InputMaybe<Scalars['Int']['input']>;
  recordIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  title: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type GroupTierChannelCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTierChannelCreateInput = {
  channelId: Scalars['UUID']['input'];
  tierId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierChannelCreate. */
export type GroupTierChannelCreatePayload = {
  __typename?: 'GroupTierChannelCreatePayload';
  errors: Maybe<Array<GroupTierChannelCreateErrorsUnion>>;
  result: Maybe<Api_GroupTier>;
};

export type GroupTierChannelDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type GroupTierChannelDeleteInput = {
  channelId: Scalars['UUID']['input'];
  tierId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierChannelDelete. */
export type GroupTierChannelDeletePayload = {
  __typename?: 'GroupTierChannelDeletePayload';
  errors: Maybe<Array<GroupTierChannelDeleteErrorsUnion>>;
  result: Maybe<Api_GroupTier>;
};

export type GroupTierCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupTierCreateInput = {
  benefits: InputMaybe<Array<GroupTierBenefitNewInput>>;
  channels: InputMaybe<Array<Scalars['UUID']['input']>>;
  groupId: Scalars['UUID']['input'];
  tier: GroupTierNewInput;
};

/** Autogenerated return type of GroupTierCreate. */
export type GroupTierCreatePayload = {
  __typename?: 'GroupTierCreatePayload';
  errors: Maybe<Array<GroupTierCreateErrorsUnion>>;
  result: Maybe<Api_GroupTier>;
};

export type GroupTierDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupTierDeleteInput = {
  tierId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierDelete. */
export type GroupTierDeletePayload = {
  __typename?: 'GroupTierDeletePayload';
  errors: Maybe<Array<GroupTierDeleteErrorsUnion>>;
  result: Maybe<Api_Group>;
};

export type GroupTierEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type GroupTierEditInput = {
  /** You must send all channels each edit mutation, any channels not provided will be removed */
  channels: InputMaybe<Array<Scalars['UUID']['input']>>;
  discordRoles: InputMaybe<Array<Scalars['UUID']['input']>>;
  tier: InputMaybe<GroupTierUpdateInput>;
  tierId: Scalars['UUID']['input'];
};

/** Autogenerated return type of GroupTierEdit. */
export type GroupTierEditPayload = {
  __typename?: 'GroupTierEditPayload';
  errors: Maybe<Array<GroupTierEditErrorsUnion>>;
  result: Maybe<Api_GroupTier>;
};

export type GroupTierNewInput = {
  billingFrequency: InputMaybe<BillingFrequencyEnum>;
  billingInterval: InputMaybe<Scalars['Int']['input']>;
  cover: InputMaybe<UploadAssetInput>;
  coverVideoId: InputMaybe<Scalars['UUID']['input']>;
  description: Scalars['SanitizedString']['input'];
  hasSetupFee: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['SanitizedString']['input'];
  price: InputMaybe<MoneyInput>;
  recommended: InputMaybe<Scalars['Boolean']['input']>;
  role: InputMaybe<Scalars['SanitizedString']['input']>;
  seatLimit: InputMaybe<Scalars['Int']['input']>;
  setupPrice: InputMaybe<MoneyInput>;
  unlisted: InputMaybe<Scalars['Boolean']['input']>;
  yearlyDiscountPercentage: InputMaybe<Scalars['Int']['input']>;
};

export type GroupTierUpdateInput = {
  billingFrequency: InputMaybe<BillingFrequencyEnum>;
  billingInterval: InputMaybe<Scalars['Int']['input']>;
  cover: InputMaybe<UploadAssetInput>;
  coverVideoId: InputMaybe<Scalars['UUID']['input']>;
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  discordGuilds: InputMaybe<Array<Scalars['UUID']['input']>>;
  hasSetupFee: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  price: InputMaybe<MoneyInput>;
  recommended: InputMaybe<Scalars['Boolean']['input']>;
  role: InputMaybe<Scalars['SanitizedString']['input']>;
  seatLimit: InputMaybe<Scalars['Int']['input']>;
  setupPrice: InputMaybe<MoneyInput>;
  unlisted: InputMaybe<Scalars['Boolean']['input']>;
  yearlyDiscountPercentage: InputMaybe<Scalars['Int']['input']>;
};

export type GroupUpdateInput = {
  cover: InputMaybe<UploadAssetInput>;
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  gameId: InputMaybe<Scalars['UUID']['input']>;
  logo: InputMaybe<UploadAssetInput>;
  postPermission: InputMaybe<GroupPostPermissionEnum>;
  price: InputMaybe<MoneyInput>;
  /** The percentage split of revenue given to all other team members */
  subscriptionPercentageSplit: InputMaybe<Scalars['Float']['input']>;
  title: InputMaybe<Scalars['SanitizedString']['input']>;
};

export const enum GroupVisibilityDiscoverableEnum {
  /** Members must request access to join */
  Private = 'PRIVATE',
  /** Anyone can join */
  Public = 'PUBLIC'
}

export const enum GroupVisibilityEnum {
  /** Members must request access to join */
  Private = 'PRIVATE',
  /** Anyone can join */
  Public = 'PUBLIC',
  /** Hidden from search and discovery */
  Unlisted = 'UNLISTED'
}

export type GuideChapterCompleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type GuideChapterCompleteInput = {
  chapterId: Scalars['UUID']['input'];
  completed: Scalars['Boolean']['input'];
};

/** Autogenerated return type of GuideChapterComplete. */
export type GuideChapterCompletePayload = {
  __typename?: 'GuideChapterCompletePayload';
  errors: Maybe<Array<GuideChapterCompleteErrorsUnion>>;
  result: Maybe<Api_ProductGuideChapter>;
};

export type LegacySubscriptionCancelErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type LegacySubscriptionCancelInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of LegacySubscriptionCancel. */
export type LegacySubscriptionCancelPayload = {
  __typename?: 'LegacySubscriptionCancelPayload';
  errors: Maybe<Array<LegacySubscriptionCancelErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export const enum MetafyPartnerEnum {
  /** Metafy Core member */
  Core = 'CORE',
  /** Metafy Pro member */
  Pro = 'PRO'
}

export type MoneyInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export const enum MutedAccountSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type MutedAccountSortOption = {
  direction: SortDirection;
  on: MutedAccountSortEnum;
};

export type MuxAssetCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type MuxAssetCreateInput = {
  muxAsset: MuxAssetCreateNewInput;
};

export type MuxAssetCreateNewInput = {
  customThumbnail: InputMaybe<UploadAssetInput>;
  /** The original filename of the video */
  originalFilename: InputMaybe<Scalars['SanitizedString']['input']>;
  recordType: InputMaybe<MuxRecordEnum>;
};

/** Autogenerated return type of MuxAssetCreate. */
export type MuxAssetCreatePayload = {
  __typename?: 'MuxAssetCreatePayload';
  errors: Maybe<Array<MuxAssetCreateErrorsUnion>>;
  result: Maybe<Api_MuxAsset>;
};

export const enum MuxAssetStatusEnum {
  /** This asset has been deleted */
  Deleted = 'DELETED',
  /** This asset has errored during conversion or upload */
  Errored = 'ERRORED',
  /** The upload of this asset is pending */
  Pending = 'PENDING',
  /** This asest is currently preparing */
  Preparing = 'PREPARING',
  /** This asset is ready for playback */
  Ready = 'READY',
  /** This asset is currently uploading */
  Uploading = 'UPLOADING'
}

export type MuxAssetUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type MuxAssetUpdateExistingInput = {
  customThumbnail: InputMaybe<UploadAssetInput>;
  /** The original filename of the video */
  originalFilename: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type MuxAssetUpdateInput = {
  /** The ID of the Mux asset */
  id: Scalars['UUID']['input'];
  muxAsset: MuxAssetUpdateExistingInput;
};

/** Autogenerated return type of MuxAssetUpdate. */
export type MuxAssetUpdatePayload = {
  __typename?: 'MuxAssetUpdatePayload';
  errors: Maybe<Array<MuxAssetUpdateErrorsUnion>>;
  result: Maybe<Api_MuxAsset>;
};

export type MuxAssetViewTrackErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type MuxAssetViewTrackInput = {
  completed: InputMaybe<Scalars['Boolean']['input']>;
  muxAssetId: Scalars['UUID']['input'];
  timestamp: Scalars['Float']['input'];
};

/** Autogenerated return type of MuxAssetViewTrack. */
export type MuxAssetViewTrackPayload = {
  __typename?: 'MuxAssetViewTrackPayload';
  errors: Maybe<Array<MuxAssetViewTrackErrorsUnion>>;
  result: Maybe<Api_MuxAsset>;
};

export const enum MuxPlaybackPolicyEnum {
  /** Public */
  Public = 'PUBLIC',
  /** Signed */
  Signed = 'SIGNED'
}

export const enum MuxRecordEnum {
  /** Content Video */
  ContentVideo = 'CONTENT_VIDEO',
  /** Event recording */
  EventRecording = 'EVENT_RECORDING',
  /** Group tier cover video */
  GroupTier = 'GROUP_TIER',
  /** Guide Trailer Video */
  GuideTrailerVideo = 'GUIDE_TRAILER_VIDEO',
  /** Guide Video */
  GuideVideo = 'GUIDE_VIDEO',
  /** None */
  None = 'NONE',
  /** Overview carousel */
  OverviewCarousel = 'OVERVIEW_CAROUSEL',
  /** Post Video */
  PostVideo = 'POST_VIDEO',
  /** Profile Layout Video */
  ProfileLayoutVideo = 'PROFILE_LAYOUT_VIDEO'
}

/** The mutation requires an authenticated logged-in user session, and none was provided or the session has expired. */
export type NotAuthenticatedError = Error & {
  __typename?: 'NotAuthenticatedError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

/** The mutation requires higher permissions than the current user or token has. This is a bit vague, but it generally means you're attempting to modify an object you don't own, or perform an administrator action without being an administrator. */
export type NotAuthorizedError = Error & {
  __typename?: 'NotAuthorizedError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

/** An object required for your mutation was unable to be located. Usually this means the object you're attempting to modify or delete does not exist. */
export type NotFoundError = Error & {
  __typename?: 'NotFoundError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

/** The mutation requires a verified account. This means the account must have a verified email. */
export type NotVerifiedError = Error & {
  __typename?: 'NotVerifiedError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

export type NotificationRecordUnion =
  | Api_Discord
  | Api_Follow
  | Api_GiftCard
  | Api_Group
  | Api_GroupInvite
  | Api_GroupMember
  | Api_GroupRequest
  | Api_GroupTeamMember
  | Api_Order
  | Api_Post
  | Api_PostReaction
  | Api_PostVote
  | Api_Product
  | Api_ProductEvent
  | Api_ProductGuideAuthor
  | Api_PurchasedProduct
  | Api_PurchasedProductCoaching
  | Api_PurchasedProductCoachingSession
  | Api_PurchasedProductEvent
  | Api_PurchasedProductGuide
  | Api_PurchasedProductTip
  | Api_Testimonial
  | Api_TestimonialRequest;

export type OAuthApplicationCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type OAuthApplicationCreateInput = {
  /** The name of the application */
  name: Scalars['SanitizedString']['input'];
  /** The redirect URI for the application */
  redirectUri: Scalars['SanitizedString']['input'];
  /** The scopes for the application */
  scopes: InputMaybe<Array<ScopeEnum>>;
};

/** Autogenerated return type of OAuthApplicationCreate. */
export type OAuthApplicationCreatePayload = {
  __typename?: 'OAuthApplicationCreatePayload';
  errors: Maybe<Array<OAuthApplicationCreateErrorsUnion>>;
  result: Maybe<Api_OAuthApplication>;
};

export type OAuthApplicationDeleteErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type OAuthApplicationDeleteInput = {
  /** The ID of the application to delete */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of OAuthApplicationDelete. */
export type OAuthApplicationDeletePayload = {
  __typename?: 'OAuthApplicationDeletePayload';
  errors: Maybe<Array<OAuthApplicationDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type OAuthApplicationUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type OAuthApplicationUpdateInput = {
  /** The ID of the application */
  id: Scalars['UUID']['input'];
  /** The name of the application */
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The redirect URI for the application */
  redirectUri: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The scopes for the application */
  scopes: InputMaybe<Array<ScopeEnum>>;
};

/** Autogenerated return type of OAuthApplicationUpdate. */
export type OAuthApplicationUpdatePayload = {
  __typename?: 'OAuthApplicationUpdatePayload';
  errors: Maybe<Array<OAuthApplicationUpdateErrorsUnion>>;
  result: Maybe<Api_OAuthApplication>;
};

export type OrderItemDiscountRecordUnion = Api_Coupon | Api_GroupTierBenefit | Api_Sale;

export const enum OrderItemStateEnum {
  /** The order is completed */
  Completed = 'COMPLETED',
  /** The order is fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The order is partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The order requires payment */
  PaymentRequired = 'PAYMENT_REQUIRED',
  /** The order is pending */
  Pending = 'PENDING',
  /** The order is a preview */
  Preview = 'PREVIEW',
  /** The order is settled */
  Settled = 'SETTLED',
  /** The order is void */
  Void = 'VOID'
}

export const enum OrderPaymentEnum {
  /** The payment was made using a coupon */
  Coupon = 'COUPON',
  /** The payment was made using Metafy credit */
  Credit = 'CREDIT',
  /** The payment is a gift card */
  GiftCard = 'GIFT_CARD',
  /** The payment is a promo code */
  PromoCode = 'PROMO_CODE',
  /** The payment is from Recurly */
  Recurly = 'RECURLY',
  /** The payment was made with a Twitch discount */
  Twitch = 'TWITCH'
}

export const enum OrderPaymentStateEnum {
  /** The payment is canceled */
  Canceled = 'CANCELED',
  /** The payment is fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The payment is partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The payment is pending */
  Pending = 'PENDING',
  /** The payment is settled */
  Settled = 'SETTLED',
  /** The payment is void */
  Void = 'VOID'
}

export const enum OrderPayoutEnum {
  /** The payout is from a purchased product */
  Purchase = 'PURCHASE',
  /** The payout is a refunded product purchase */
  Refund = 'REFUND'
}

export const enum OrderPayoutStateEnum {
  /** The payout is fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The payout is partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The payout is pending */
  Pending = 'PENDING',
  /** The payout is settled */
  Settled = 'SETTLED',
  /** The payout is void */
  Void = 'VOID'
}

export const enum OrderSortEnum {
  CreatedAt = 'CREATED_AT',
  State = 'STATE',
  Total = 'TOTAL'
}

export type OrderSortOption = {
  direction: SortDirection;
  on: OrderSortEnum;
};

export const enum OrderStateEnum {
  /** The order is fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The order is partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The order requires payment */
  PaymentRequired = 'PAYMENT_REQUIRED',
  /** The order is pending */
  Pending = 'PENDING',
  /** The order is a preview */
  Preview = 'PREVIEW',
  /** The order is settled */
  Settled = 'SETTLED',
  /** The order is void */
  Void = 'VOID'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PatreonTierEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type PatreonTierEditInput = {
  discounts: ConnectionDiscountInput;
  /** The ID of the Patreon Tier */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of PatreonTierEdit. */
export type PatreonTierEditPayload = {
  __typename?: 'PatreonTierEditPayload';
  errors: Maybe<Array<PatreonTierEditErrorsUnion>>;
  result: Maybe<Api_PatreonTier>;
};

export type PaypalCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type PaypalCreateInput = {
  email: Scalars['SanitizedString']['input'];
};

/** Autogenerated return type of PaypalCreate. */
export type PaypalCreatePayload = {
  __typename?: 'PaypalCreatePayload';
  errors: Maybe<Array<PaypalCreateErrorsUnion>>;
  result: Maybe<Api_Paypal>;
};

export type PaypalDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

/** Autogenerated return type of PaypalDelete. */
export type PaypalDeletePayload = {
  __typename?: 'PaypalDeletePayload';
  errors: Maybe<Array<PaypalDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export const enum PostEmbedEnum {
  MetafyArticle = 'METAFY_ARTICLE',
  MetafyGroup = 'METAFY_GROUP',
  MuxStream = 'MUX_STREAM',
  Og = 'OG',
  Reddit = 'REDDIT',
  Spotify = 'SPOTIFY',
  Tenor = 'TENOR',
  TwitchChannel = 'TWITCH_CHANNEL',
  TwitchClip = 'TWITCH_CLIP',
  TwitchVod = 'TWITCH_VOD',
  Youtube = 'YOUTUBE'
}

export const enum PostGateReasonEnum {
  Guest = 'GUEST',
  NotMember = 'NOT_MEMBER',
  NotPurchased = 'NOT_PURCHASED',
  NotPurchasedOrSubscribed = 'NOT_PURCHASED_OR_SUBSCRIBED',
  NotSubscribed = 'NOT_SUBSCRIBED'
}

export const enum PostReactionSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type PostReactionSortOption = {
  direction: SortDirection;
  on: PostReactionSortEnum;
};

export const enum PostSortEnum {
  CreatedAt = 'CREATED_AT',
  Hotness = 'HOTNESS',
  Top = 'TOP'
}

export type PostSortOption = {
  direction: SortDirection;
  on: PostSortEnum;
};

export const enum PostVoteEnum {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type PriceRangeInput = {
  max: InputMaybe<Scalars['Float']['input']>;
  min: InputMaybe<Scalars['Float']['input']>;
};

export const enum PriceValueEnum {
  /** Free */
  Free = 'FREE',
  /** $$$ */
  Max = 'MAX',
  /** $$ */
  Middle = 'MIDDLE',
  /** $ */
  Min = 'MIN'
}

export type ProductAddonCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductAddonCreateInput = {
  /** The addon to add to the product */
  addon: ProductAddonCreateNewInput;
  /** The ID of the product to add the addon to */
  productId: Scalars['UUID']['input'];
};

export type ProductAddonCreateNewInput = {
  /** A description of the addon */
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The name of the addon */
  name: Scalars['SanitizedString']['input'];
  /** The price of the addon */
  price: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of ProductAddonCreate. */
export type ProductAddonCreatePayload = {
  __typename?: 'ProductAddonCreatePayload';
  errors: Maybe<Array<ProductAddonCreateErrorsUnion>>;
  result: Maybe<Api_ProductAddon>;
};

export type ProductAddonDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductAddonDeleteInput = {
  /** The ID of the addon to delete */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductAddonDelete. */
export type ProductAddonDeletePayload = {
  __typename?: 'ProductAddonDeletePayload';
  errors: Maybe<Array<ProductAddonDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ProductAddonUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductAddonUpdateExistingInput = {
  /** A description of the addon */
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The name of the addon */
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The price of the addon */
  price: InputMaybe<Scalars['Float']['input']>;
};

export type ProductAddonUpdateInput = {
  /** The updated addon */
  addon: ProductAddonUpdateExistingInput;
  /** The ID of the addon to update */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductAddonUpdate. */
export type ProductAddonUpdatePayload = {
  __typename?: 'ProductAddonUpdatePayload';
  errors: Maybe<Array<ProductAddonUpdateErrorsUnion>>;
  result: Maybe<Api_ProductAddon>;
};

export type ProductCoachingCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotVerifiedError
  | ValidationError;

export type ProductCoachingCreateInput = {
  coaching: ProductCoachingCreateNewInput;
  product: ProductCreateNewInput;
};

export type ProductCoachingCreateNewInput = {
  /** The duration of the coaching product in seconds */
  durationSeconds: InputMaybe<Scalars['Int']['input']>;
  /** An optional game ID to associate with the coaching product */
  gameId: InputMaybe<Scalars['UUID']['input']>;
  /** The intake questions to create for the coaching product */
  intakeQuestions: InputMaybe<Array<ProductCoachingIntakeQuestionInput>>;
  /** The scheduler to use for the coaching product */
  scheduler: InputMaybe<SchedulerEnum>;
  /** The sessions to create for the coaching product */
  sessions: Array<ProductCoachingSessionInput>;
};

/** Autogenerated return type of ProductCoachingCreate. */
export type ProductCoachingCreatePayload = {
  __typename?: 'ProductCoachingCreatePayload';
  errors: Maybe<Array<ProductCoachingCreateErrorsUnion>>;
  result: Maybe<Api_ProductCoaching>;
};

export type ProductCoachingDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductCoachingDeleteInput = {
  /** The ID of the coaching product to delete */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductCoachingDelete. */
export type ProductCoachingDeletePayload = {
  __typename?: 'ProductCoachingDeletePayload';
  errors: Maybe<Array<ProductCoachingDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ProductCoachingIntakeQuestionCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductCoachingIntakeQuestionCreateInput = {
  /** The ID of the coaching product to add the intake question to */
  productCoachingId: Scalars['UUID']['input'];
  /** The intake question to add to the coaching product */
  question: ProductCoachingIntakeQuestionInput;
};

/** Autogenerated return type of ProductCoachingIntakeQuestionCreate. */
export type ProductCoachingIntakeQuestionCreatePayload = {
  __typename?: 'ProductCoachingIntakeQuestionCreatePayload';
  errors: Maybe<Array<ProductCoachingIntakeQuestionCreateErrorsUnion>>;
  result: Maybe<Api_ProductCoachingIntakeQuestion>;
};

export type ProductCoachingIntakeQuestionDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductCoachingIntakeQuestionDeleteInput = {
  /** The ID of the intake question to remove */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductCoachingIntakeQuestionDelete. */
export type ProductCoachingIntakeQuestionDeletePayload = {
  __typename?: 'ProductCoachingIntakeQuestionDeletePayload';
  errors: Maybe<Array<ProductCoachingIntakeQuestionDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ProductCoachingIntakeQuestionInput = {
  /** The position of the question in the intake form */
  position: InputMaybe<Scalars['Int']['input']>;
  /** The question to ask the user */
  question: Scalars['SanitizedString']['input'];
};

export type ProductCoachingIntakeQuestionUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductCoachingIntakeQuestionUpdateInput = {
  /** The ID of the intake question to update */
  id: Scalars['UUID']['input'];
  /** The intake question to add to the coaching product */
  question: ProductCoachingIntakeQuestionInput;
};

/** Autogenerated return type of ProductCoachingIntakeQuestionUpdate. */
export type ProductCoachingIntakeQuestionUpdatePayload = {
  __typename?: 'ProductCoachingIntakeQuestionUpdatePayload';
  errors: Maybe<Array<ProductCoachingIntakeQuestionUpdateErrorsUnion>>;
  result: Maybe<Api_ProductCoachingIntakeQuestion>;
};

export const enum ProductCoachingSessionCountFilterEnum {
  /** All */
  All = 'ALL',
  /** Multiple */
  Multiple = 'MULTIPLE',
  /** Single */
  Single = 'SINGLE'
}

export type ProductCoachingSessionCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductCoachingSessionCreateInput = {
  /** The ID of the coaching product to create a session for */
  productCoachingId: Scalars['UUID']['input'];
  /** The session to create for the coaching product */
  session: ProductCoachingSessionInput;
};

/** Autogenerated return type of ProductCoachingSessionCreate. */
export type ProductCoachingSessionCreatePayload = {
  __typename?: 'ProductCoachingSessionCreatePayload';
  errors: Maybe<Array<ProductCoachingSessionCreateErrorsUnion>>;
  result: Maybe<Api_ProductCoachingSession>;
};

export type ProductCoachingSessionDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductCoachingSessionDeleteInput = {
  /** The ID of the session to delete */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductCoachingSessionDelete. */
export type ProductCoachingSessionDeletePayload = {
  __typename?: 'ProductCoachingSessionDeletePayload';
  errors: Maybe<Array<ProductCoachingSessionDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ProductCoachingSessionInput = {
  /** A description of the session */
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The name of the session */
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The position of the session in the coaching product */
  position: InputMaybe<Scalars['Int']['input']>;
};

export const enum ProductCoachingSessionSortEnum {
  Position = 'POSITION'
}

export type ProductCoachingSessionSortOption = {
  direction: SortDirection;
  on: ProductCoachingSessionSortEnum;
};

export type ProductCoachingSessionUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductCoachingSessionUpdateInput = {
  /** The ID of the coaching product session to update */
  id: Scalars['UUID']['input'];
  /** The session to create for the coaching product */
  session: ProductCoachingSessionInput;
};

/** Autogenerated return type of ProductCoachingSessionUpdate. */
export type ProductCoachingSessionUpdatePayload = {
  __typename?: 'ProductCoachingSessionUpdatePayload';
  errors: Maybe<Array<ProductCoachingSessionUpdateErrorsUnion>>;
  result: Maybe<Api_ProductCoachingSession>;
};

export const enum ProductCoachingSortEnum {
  CommunityCoaches = 'COMMUNITY_COACHES',
  CreatedAt = 'CREATED_AT',
  NewCoaches = 'NEW_COACHES',
  Popularity = 'POPULARITY',
  Position = 'POSITION',
  Price = 'PRICE',
  TopCoaches = 'TOP_COACHES'
}

export type ProductCoachingSortOption = {
  direction: SortDirection;
  on: ProductCoachingSortEnum;
};

export type ProductCoachingUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductCoachingUpdateExistingInput = {
  /** The duration of the coaching product in seconds */
  durationSeconds: InputMaybe<Scalars['Int']['input']>;
  /** An optional game ID to associate with the coaching product */
  gameId: InputMaybe<Scalars['UUID']['input']>;
  /** Whether intake questions are enabled for the coaching product */
  intakeQuestionsEnabled: InputMaybe<Scalars['Boolean']['input']>;
  /** The position of the coaching product in the account's product list */
  position: InputMaybe<Scalars['Int']['input']>;
  /** The scheduler to use for the coaching product */
  scheduler: InputMaybe<SchedulerEnum>;
};

export type ProductCoachingUpdateInput = {
  /** The coaching product to update */
  coaching: InputMaybe<ProductCoachingUpdateExistingInput>;
  /** The ID of the coaching product to update */
  id: Scalars['UUID']['input'];
  /** The product to update */
  product: InputMaybe<ProductUpdateInput>;
};

/** Autogenerated return type of ProductCoachingUpdate. */
export type ProductCoachingUpdatePayload = {
  __typename?: 'ProductCoachingUpdatePayload';
  errors: Maybe<Array<ProductCoachingUpdateErrorsUnion>>;
  result: Maybe<Api_ProductCoaching>;
};

export type ProductCreateBlockInput = {
  /** Whether to create the block if it doesn't exist */
  create: Scalars['Boolean']['input'];
  /** The desktop layout of the block */
  desktop: InputMaybe<BlockLayoutBlockGridInput>;
  /** The mobile layout of the block */
  mobile: InputMaybe<BlockLayoutBlockGridInput>;
};

export type ProductCreateNewInput = {
  addons: InputMaybe<Array<ProductAddonCreateNewInput>>;
  cover: InputMaybe<UploadAssetInput>;
  /** The currency for the product */
  currency: InputMaybe<Scalars['String']['input']>;
  /** A description of the product */
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  /** Whether the product is enabled */
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  /** The IDs of the groups's the product is visible in */
  groupVisibilityIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The name of the product */
  name: Scalars['SanitizedString']['input'];
  /** The position of the product in the account's product list */
  position: InputMaybe<Scalars['Int']['input']>;
  /** The pricing options for the product */
  pricingOptions: Array<ProductPricingOptionInput>;
  /** The type of the product */
  productType: InputMaybe<ProductEnum>;
  /** Whether to create the block if it doesn't exist */
  profileBlock: InputMaybe<ProductCreateBlockInput>;
  /** The SKU of the product */
  sku: InputMaybe<Scalars['SanitizedString']['input']>;
  unifiedTags: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** Whether the product is unlisted from discovery */
  unlisted: InputMaybe<Scalars['Boolean']['input']>;
};

export const enum ProductEnum {
  /** A collection of one or more coaching sessions */
  Coaching = 'COACHING',
  /** A live event */
  Event = 'EVENT',
  /** A gift card for a user */
  GiftCard = 'GIFT_CARD',
  /** Group supporter subscription */
  GroupSupporter = 'GROUP_SUPPORTER',
  /** A guide for a product */
  Guide = 'GUIDE',
  /** Metafy Core Partnership */
  MetafyCore = 'METAFY_CORE',
  /** A Metafy credit */
  MetafyCredit = 'METAFY_CREDIT',
  /** A Metafy Pro subscription */
  MetafyPro = 'METAFY_PRO',
  /** A policy for a product */
  Policy = 'POLICY',
  /** A purchasable post */
  Post = 'POST',
  /** Fee associated with a product */
  SetupFee = 'SETUP_FEE',
  /** A tip for a user */
  Tip = 'TIP'
}

export type ProductEventCancelErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductEventCancelInput = {
  productId: Scalars['UUID']['input'];
  reason: InputMaybe<Scalars['SanitizedString']['input']>;
  refund: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ProductEventCancel. */
export type ProductEventCancelPayload = {
  __typename?: 'ProductEventCancelPayload';
  errors: Maybe<Array<ProductEventCancelErrorsUnion>>;
  result: Maybe<Api_ProductEvent>;
};

export const enum ProductEventCompletedEnum {
  Both = 'BOTH',
  /** Event has concluded and does not have the recording for sale */
  WithoutReplays = 'WITHOUT_REPLAYS',
  /** Event has concluded and has the recording for sale */
  WithReplays = 'WITH_REPLAYS'
}

export type ProductEventCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotVerifiedError
  | ValidationError;

export type ProductEventCreateInput = {
  event: ProductEventCreateNewInput;
  product: ProductCreateNewInput;
};

export type ProductEventCreateNewInput = {
  /** Duration of the live event */
  durationSeconds: Scalars['Int']['input'];
  /** An optional game ID to associate with the live event */
  gameId: InputMaybe<Scalars['UUID']['input']>;
  /** The group ID to associate with the live event */
  groupId: InputMaybe<Scalars['UUID']['input']>;
  /** Language of the live event */
  language: InputMaybe<Scalars['SanitizedString']['input']>;
  /** Outcomes of the live event */
  learningOutcomes: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** Whether the event recording will be sold after completion */
  offerReplayPurchase: InputMaybe<Scalars['Boolean']['input']>;
  /** Price of the replay if offered */
  replayPrice: InputMaybe<MoneyInput>;
  /** When the live event will take place */
  scheduledAt: Scalars['ISO8601DateTime']['input'];
  /** Limit of ticket sales for the live event */
  seatLimit: Scalars['Int']['input'];
};

/** Autogenerated return type of ProductEventCreate. */
export type ProductEventCreatePayload = {
  __typename?: 'ProductEventCreatePayload';
  errors: Maybe<Array<ProductEventCreateErrorsUnion>>;
  result: Maybe<Api_ProductEvent>;
};

export type ProductEventEndLiveErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductEventEndLiveInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductEventEndLive. */
export type ProductEventEndLivePayload = {
  __typename?: 'ProductEventEndLivePayload';
  errors: Maybe<Array<ProductEventEndLiveErrorsUnion>>;
  result: Maybe<Api_ProductEvent>;
};

export type ProductEventExtendErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductEventExtendInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductEventExtend. */
export type ProductEventExtendPayload = {
  __typename?: 'ProductEventExtendPayload';
  errors: Maybe<Array<ProductEventExtendErrorsUnion>>;
  result: Maybe<Api_ProductEvent>;
};

export type ProductEventGoLiveErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductEventGoLiveInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductEventGoLive. */
export type ProductEventGoLivePayload = {
  __typename?: 'ProductEventGoLivePayload';
  errors: Maybe<Array<ProductEventGoLiveErrorsUnion>>;
  result: Maybe<Api_ProductEvent>;
};

export const enum ProductEventSortEnum {
  CompletedAt = 'COMPLETED_AT',
  CreatedAt = 'CREATED_AT',
  Popular = 'POPULAR',
  Position = 'POSITION',
  Price = 'PRICE',
  ScheduledAt = 'SCHEDULED_AT'
}

export type ProductEventSortOption = {
  direction: SortDirection;
  on: ProductEventSortEnum;
};

export const enum ProductEventStateEnum {
  /** Event has been canceled */
  Canceled = 'CANCELED',
  /** Event has concluded */
  Complete = 'COMPLETE',
  /** Event is currently live */
  Live = 'LIVE',
  /** Event is scheduled for the future */
  Scheduled = 'SCHEDULED'
}

export type ProductEventUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductEventUpdateExistingInput = {
  /** Duration of the live event */
  durationSeconds: InputMaybe<Scalars['Int']['input']>;
  /** An optional game ID to associate with the live event */
  gameId: InputMaybe<Scalars['UUID']['input']>;
  /** Language of the live event */
  language: InputMaybe<Scalars['SanitizedString']['input']>;
  /** Outcomes of the live event */
  learningOutcomes: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** Whether the event recording will be sold after completion */
  offerReplayPurchase: InputMaybe<Scalars['Boolean']['input']>;
  /** Price of the replay if offered */
  replayPrice: InputMaybe<MoneyInput>;
  /** When the live event will take place */
  scheduledAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Limit of ticket sales for the live event */
  seatLimit: InputMaybe<Scalars['Int']['input']>;
};

export type ProductEventUpdateInput = {
  event: InputMaybe<ProductEventUpdateExistingInput>;
  product: InputMaybe<ProductUpdateInput>;
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductEventUpdate. */
export type ProductEventUpdatePayload = {
  __typename?: 'ProductEventUpdatePayload';
  errors: Maybe<Array<ProductEventUpdateErrorsUnion>>;
  result: Maybe<Api_ProductEvent>;
};

export type ProductEventUpdateRoleErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductEventUpdateRoleInput = {
  productId: Scalars['UUID']['input'];
  role: EventAttendeeRoleEnum;
};

/** Autogenerated return type of ProductEventUpdateRole. */
export type ProductEventUpdateRolePayload = {
  __typename?: 'ProductEventUpdateRolePayload';
  errors: Maybe<Array<ProductEventUpdateRoleErrorsUnion>>;
  result: Maybe<Api_PurchasedProductEvent>;
};

export type ProductFeatureErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ProductFeatureInput = {
  featured: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  /** The position in the overview list to place the product */
  overviewPosition: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ProductFeature. */
export type ProductFeaturePayload = {
  __typename?: 'ProductFeaturePayload';
  errors: Maybe<Array<ProductFeatureErrorsUnion>>;
  result: Maybe<Api_Product>;
};

export type ProductGiftCardInput = {
  /** The style of the gift card */
  style: InputMaybe<Scalars['Int']['input']>;
  /** The dollar value of the gift card */
  value: MoneyInput;
};

export type ProductGuideArchiveErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type ProductGuideArchiveInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideArchive. */
export type ProductGuideArchivePayload = {
  __typename?: 'ProductGuideArchivePayload';
  errors: Maybe<Array<ProductGuideArchiveErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductGuideAuthorCreateInput = {
  /** The ID of the account to add as an author */
  accountId: Scalars['UUID']['input'];
  /** The percentage of royalties the account will receive for the guide */
  percentage: InputMaybe<Scalars['Float']['input']>;
  /** The role the account will have in the guide */
  role: ProductGuideAuthorRoleEnum;
};

export type ProductGuideAuthorRequestUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideAuthorRequestUpdateInput = {
  accepted: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideAuthorRequestUpdate. */
export type ProductGuideAuthorRequestUpdatePayload = {
  __typename?: 'ProductGuideAuthorRequestUpdatePayload';
  errors: Maybe<Array<ProductGuideAuthorRequestUpdateErrorsUnion>>;
  result: Maybe<Api_ProductGuideAuthor>;
};

export const enum ProductGuideAuthorRoleEnum {
  /** The account is an original author of the guide */
  Author = 'AUTHOR',
  /** The account is a contributor to the guide */
  Contributor = 'CONTRIBUTOR',
  /** The account is an editor of the guide */
  Editor = 'EDITOR'
}

export const enum ProductGuideAuthorSortEnum {
  CreatedAt = 'CREATED_AT',
  GameTitle = 'GAME_TITLE',
  LastUpdatedAt = 'LAST_UPDATED_AT',
  OverviewPosition = 'OVERVIEW_POSITION',
  Position = 'POSITION',
  Price = 'PRICE',
  PublishedAt = 'PUBLISHED_AT',
  RequestDate = 'REQUEST_DATE'
}

export type ProductGuideAuthorSortOption = {
  direction: SortDirection;
  on: ProductGuideAuthorSortEnum;
};

export const enum ProductGuideAuthorStateEnum {
  /** The account has accepted the invitation to be an author of the guide */
  Accepted = 'ACCEPTED',
  /** The account has declined the invitation to be an author of the guide */
  Declined = 'DECLINED',
  /** The account has been invited to be an author of the guide, but has not yet accepted */
  Pending = 'PENDING'
}

export type ProductGuideChangelogCreateInput = {
  /** The content of the changelog */
  content: Scalars['SanitizedString']['input'];
  /** Whether the changelog is a minor update */
  minor: Scalars['Boolean']['input'];
  thumbnail: InputMaybe<UploadAssetInput>;
  /** The title of the changelog */
  title: Scalars['SanitizedString']['input'];
};

export type ProductGuideChangelogUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideChangelogUpdateExistingInput = {
  /** The content of the changelog */
  content: InputMaybe<Scalars['SanitizedString']['input']>;
  thumbnail: InputMaybe<UploadAssetInput>;
  /** The title of the changelog */
  title: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type ProductGuideChangelogUpdateInput = {
  /** The changelog for the guide update */
  changelog: ProductGuideChangelogUpdateExistingInput;
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideChangelogUpdate. */
export type ProductGuideChangelogUpdatePayload = {
  __typename?: 'ProductGuideChangelogUpdatePayload';
  errors: Maybe<Array<ProductGuideChangelogUpdateErrorsUnion>>;
  result: Maybe<Api_ProductGuideChangelog>;
};

export type ProductGuideChapterCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideChapterCreateInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideChapterCreate. */
export type ProductGuideChapterCreatePayload = {
  __typename?: 'ProductGuideChapterCreatePayload';
  errors: Maybe<Array<ProductGuideChapterCreateErrorsUnion>>;
  result: Maybe<Api_ProductGuideChapter>;
};

export type ProductGuideChapterRemoveErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideChapterRemoveInput = {
  id: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideChapterRemove. */
export type ProductGuideChapterRemovePayload = {
  __typename?: 'ProductGuideChapterRemovePayload';
  errors: Maybe<Array<ProductGuideChapterRemoveErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductGuideChapterUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideChapterUpdateExistingInput = {
  /** The attachment records associated with the chapter */
  attachmentRecordIds: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The content of the chapter */
  content: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The position of the chapter within the guide */
  position: InputMaybe<Scalars['Int']['input']>;
  /** The title of the chapter */
  title: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The video records associated with the chapter */
  videoRecordIds: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProductGuideChapterUpdateInput = {
  guide: ProductGuideChapterUpdateExistingInput;
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideChapterUpdate. */
export type ProductGuideChapterUpdatePayload = {
  __typename?: 'ProductGuideChapterUpdatePayload';
  errors: Maybe<Array<ProductGuideChapterUpdateErrorsUnion>>;
  result: Maybe<Api_ProductGuideChapter>;
};

export type ProductGuideCreateDraftErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type ProductGuideCreateDraftInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideCreateDraft. */
export type ProductGuideCreateDraftPayload = {
  __typename?: 'ProductGuideCreateDraftPayload';
  errors: Maybe<Array<ProductGuideCreateDraftErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductGuideCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotVerifiedError
  | ValidationError;

export type ProductGuideCreateInput = {
  guide: ProductGuideCreateNewInput;
  product: ProductCreateNewInput;
};

export type ProductGuideCreateNewInput = {
  /** The authors to add to the guide */
  authors: InputMaybe<Array<ProductGuideAuthorCreateInput>>;
  /** Whether to create an account block when the guide is published */
  createAccountBlockOnPublish: InputMaybe<Scalars['Boolean']['input']>;
  /** An optional game ID to associate with the coaching product */
  gameId: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the guide is only available to supporters of the group */
  groupChannelSupporterOnly: InputMaybe<Scalars['Boolean']['input']>;
  /** The group ID to associate with the coaching product */
  groupId: InputMaybe<Scalars['UUID']['input']>;
  /** The ID of the trailer video for the guide */
  trailerVideoId: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the guide is unlisted */
  unlisted: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ProductGuideCreate. */
export type ProductGuideCreatePayload = {
  __typename?: 'ProductGuideCreatePayload';
  errors: Maybe<Array<ProductGuideCreateErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductGuideDeleteDraftErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideDeleteDraftInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideDeleteDraft. */
export type ProductGuideDeleteDraftPayload = {
  __typename?: 'ProductGuideDeleteDraftPayload';
  errors: Maybe<Array<ProductGuideDeleteDraftErrorsUnion>>;
  result: Maybe<Api_Product>;
};

export type ProductGuideDuplicateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideDuplicateInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideDuplicate. */
export type ProductGuideDuplicatePayload = {
  __typename?: 'ProductGuideDuplicatePayload';
  errors: Maybe<Array<ProductGuideDuplicateErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export const enum ProductGuideModeEnum {
  /** The product guide is in edit mode */
  Edit = 'EDIT',
  /** The product guide is in preview mode */
  Preview = 'PREVIEW',
  /** The product guide is in view mode */
  View = 'VIEW'
}

export type ProductGuidePublishErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuidePublishInput = {
  /** The changelog for the guide update */
  changelog: InputMaybe<ProductGuideChangelogCreateInput>;
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuidePublish. */
export type ProductGuidePublishPayload = {
  __typename?: 'ProductGuidePublishPayload';
  errors: Maybe<Array<ProductGuidePublishErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export const enum ProductGuideSortEnum {
  ChapterCount = 'CHAPTER_COUNT',
  CreatedAt = 'CREATED_AT',
  Free = 'FREE',
  GameTitle = 'GAME_TITLE',
  LastUpdatedAt = 'LAST_UPDATED_AT',
  New = 'NEW',
  Position = 'POSITION',
  PublishedAt = 'PUBLISHED_AT',
  TopGuides = 'TOP_GUIDES'
}

export type ProductGuideSortOption = {
  direction: SortDirection;
  on: ProductGuideSortEnum;
};

export const enum ProductGuideStateEnum {
  /** The product guide is in archived state */
  Archived = 'ARCHIVED',
  /** The product guide is in draft state */
  Draft = 'DRAFT',
  /** The product guide is in published state */
  Published = 'PUBLISHED',
  /** The product guide is in unpublished state */
  Unpublished = 'UNPUBLISHED'
}

export type ProductGuideUnarchiveErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type ProductGuideUnarchiveInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideUnarchive. */
export type ProductGuideUnarchivePayload = {
  __typename?: 'ProductGuideUnarchivePayload';
  errors: Maybe<Array<ProductGuideUnarchiveErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductGuideUnpublishErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type ProductGuideUnpublishInput = {
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideUnpublish. */
export type ProductGuideUnpublishPayload = {
  __typename?: 'ProductGuideUnpublishPayload';
  errors: Maybe<Array<ProductGuideUnpublishErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductGuideUpdateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductGuideUpdateExistingInput = {
  /** Whether to create an account block when the guide is published */
  createAccountBlockOnPublish: InputMaybe<Scalars['Boolean']['input']>;
  /** An optional game ID to associate with the coaching product */
  gameId: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the guide is only available to supporters of the group */
  groupChannelSupporterOnly: InputMaybe<Scalars['Boolean']['input']>;
  /** The group ID to associate with the coaching product */
  groupId: InputMaybe<Scalars['UUID']['input']>;
  /** Whether to remove the group association */
  removeGroup: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the trailer video for the guide */
  trailerVideoId: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the guide is unlisted */
  unlisted: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductGuideUpdateInput = {
  guide: InputMaybe<ProductGuideUpdateExistingInput>;
  product: InputMaybe<ProductUpdateInput>;
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductGuideUpdate. */
export type ProductGuideUpdatePayload = {
  __typename?: 'ProductGuideUpdatePayload';
  errors: Maybe<Array<ProductGuideUpdateErrorsUnion>>;
  result: Maybe<Api_ProductGuide>;
};

export type ProductPricingOptionCreateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductPricingOptionCreateInput = {
  pricingOption: ProductPricingOptionInput;
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductPricingOptionCreate. */
export type ProductPricingOptionCreatePayload = {
  __typename?: 'ProductPricingOptionCreatePayload';
  errors: Maybe<Array<ProductPricingOptionCreateErrorsUnion>>;
  result: Maybe<Api_ProductPricingOption>;
};

export type ProductPricingOptionDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductPricingOptionDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductPricingOptionDelete. */
export type ProductPricingOptionDeletePayload = {
  __typename?: 'ProductPricingOptionDeletePayload';
  errors: Maybe<Array<ProductPricingOptionDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type ProductPricingOptionGroupTierBenefitInput = {
  discountPercent: Scalars['Int']['input'];
  groupTierId: Scalars['UUID']['input'];
};

export type ProductPricingOptionInput = {
  /** The frequency at which the product is billed */
  billingFrequency: InputMaybe<BillingFrequencyEnum>;
  /** The interval at which the product is billed */
  billingInterval: InputMaybe<Scalars['Int']['input']>;
  /** The type of billing for the product */
  billingType: InputMaybe<BillingEnum>;
  /** Whether the pricing option is the default */
  default: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the pricing option is enabled */
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  /** The group tier benefits for this pricing option */
  groupTierBenefits: InputMaybe<Array<ProductPricingOptionGroupTierBenefitInput>>;
  /** The price of the product */
  price: Scalars['Float']['input'];
  /** Whether the pricing option is only available to supporters */
  supporterOnly: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductPricingOptionUpdateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type ProductPricingOptionUpdateInput = {
  id: Scalars['UUID']['input'];
  pricingOption: ProductPricingOptionInput;
};

/** Autogenerated return type of ProductPricingOptionUpdate. */
export type ProductPricingOptionUpdatePayload = {
  __typename?: 'ProductPricingOptionUpdatePayload';
  errors: Maybe<Array<ProductPricingOptionUpdateErrorsUnion>>;
  result: Maybe<Api_ProductPricingOption>;
};

export type ProductPurchaseCoachingSessionInput = {
  /** Whether to cancel the session */
  cancel: InputMaybe<Scalars['Boolean']['input']>;
  /** A message to send when cancelling the session */
  cancelationMessage: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The reason for cancelling the session */
  cancelationReason: InputMaybe<Scalars['String']['input']>;
  /** The coaching session to schedule */
  id: InputMaybe<Scalars['UUID']['input']>;
  /** The date and time to schedule the session */
  scheduledAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type ProductPurchaseInput = {
  /** Addons to purchase with the product */
  addonIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If the purchase includes a coaching session reschedule or cancel, the session details */
  coachingSession: InputMaybe<ProductPurchaseCoachingSessionInput>;
  /** If the purchase includes a coaching session, the session details */
  coachingSessions: InputMaybe<Array<ProductPurchaseCoachingSessionInput>>;
  /** The group context for the purchase */
  contextGroupId: InputMaybe<Scalars['UUID']['input']>;
  /** If the purchase includes a gift card, the gift card details */
  giftCard: InputMaybe<ProductGiftCardInput>;
  /** Whether to upsell the user to a group supporter subscription */
  groupSupporterUpsell: InputMaybe<Scalars['Boolean']['input']>;
  /** The pricing option to purchase */
  pricingOptionId: InputMaybe<Scalars['UUID']['input']>;
  /** The product to purchase */
  productId: InputMaybe<Scalars['UUID']['input']>;
  /** The slug of the product to purchase */
  productSlug: InputMaybe<Scalars['String']['input']>;
  /** The type of the product to purchase */
  productType: InputMaybe<ProductEnum>;
  /** The quantity of the product to purchase */
  quantity: InputMaybe<Scalars['Int']['input']>;
  setupFee: InputMaybe<ProductPurchaseSetupFeeInput>;
  /** If the purchase includes a tip, the tip details */
  tip: InputMaybe<ProductPurchaseTipInput>;
};

export type ProductPurchaseSetupFeeInput = {
  accountId: Scalars['UUID']['input'];
  groupTierId: Scalars['UUID']['input'];
};

export type ProductPurchaseTipInput = {
  /** The account to tip */
  accountId: Scalars['UUID']['input'];
  /** Whether the tipper covers the processing fee */
  coverFee: InputMaybe<Scalars['Boolean']['input']>;
  /** A message to send with the tip */
  message: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The session this tip is associated with */
  sessionId: InputMaybe<Scalars['UUID']['input']>;
  /** The source of the tip */
  source: InputMaybe<TipSourceEnum>;
};

export const enum ProductSortEnum {
  CreatedAt = 'CREATED_AT',
  OverviewPosition = 'OVERVIEW_POSITION',
  Position = 'POSITION',
  Price = 'PRICE'
}

export type ProductSortOption = {
  direction: SortDirection;
  on: ProductSortEnum;
};

export type ProductUnifiedTagAddErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductUnifiedTagAddInput = {
  /** The ID of the product to add the unified tag to */
  productId: Scalars['UUID']['input'];
  /** The unified tag to add to the product */
  unifiedTag: Scalars['SanitizedString']['input'];
};

/** Autogenerated return type of ProductUnifiedTagAdd. */
export type ProductUnifiedTagAddPayload = {
  __typename?: 'ProductUnifiedTagAddPayload';
  errors: Maybe<Array<ProductUnifiedTagAddErrorsUnion>>;
  result: Maybe<Api_Product>;
};

export type ProductUnifiedTagRemoveErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductUnifiedTagRemoveInput = {
  /** The ID of the product to add the unified tag to */
  productId: Scalars['UUID']['input'];
  /** The ID of the unified tag to add to the product */
  unifiedTagId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductUnifiedTagRemove. */
export type ProductUnifiedTagRemovePayload = {
  __typename?: 'ProductUnifiedTagRemovePayload';
  errors: Maybe<Array<ProductUnifiedTagRemoveErrorsUnion>>;
  result: Maybe<Api_Product>;
};

export type ProductUpdateInput = {
  /** Whether addons are enabled for the product */
  addonsEnabled: InputMaybe<Scalars['Boolean']['input']>;
  /** The cover image for the product */
  cover: InputMaybe<UploadAssetInput>;
  /** The currency for the product */
  currency: InputMaybe<Scalars['String']['input']>;
  /** A description of the product */
  description: InputMaybe<Scalars['SanitizedString']['input']>;
  /** Whether the product is enabled */
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  /** The IDs of the groups's the product is visible in */
  groupVisibilityIds: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The name of the product */
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  /** The position of the product in the account's product list */
  position: InputMaybe<Scalars['Int']['input']>;
  productType: InputMaybe<ProductEnum>;
  /** Whether to remove the cover image */
  removeCover: InputMaybe<Scalars['Boolean']['input']>;
  /** The SKU of the product */
  sku: InputMaybe<Scalars['SanitizedString']['input']>;
  /** Whether the product is unlisted from discovery */
  unlisted: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductVisibilityBaseInput = {
  /** Whether the product is featured in the group overview */
  featured: InputMaybe<Scalars['Boolean']['input']>;
  /** The position in the overview list to place the product */
  overviewPosition: InputMaybe<Scalars['Int']['input']>;
  /** The position of the product in the group's product list */
  position: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVisibilityEditErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductVisibilityEditInput = {
  id: Scalars['UUID']['input'];
  visibility: ProductVisibilityBaseInput;
};

/** Autogenerated return type of ProductVisibilityEdit. */
export type ProductVisibilityEditPayload = {
  __typename?: 'ProductVisibilityEditPayload';
  errors: Maybe<Array<ProductVisibilityEditErrorsUnion>>;
  result: Maybe<Api_ProductVisibility>;
};

export type ProductVisibilityRemoveErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type ProductVisibilityRemoveInput = {
  groupId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
};

/** Autogenerated return type of ProductVisibilityRemove. */
export type ProductVisibilityRemovePayload = {
  __typename?: 'ProductVisibilityRemovePayload';
  errors: Maybe<Array<ProductVisibilityRemoveErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type PurchaseCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type PurchaseCreateInput = {
  /** The billing information for the purchase */
  billingInfo: InputMaybe<RecurlyBillingInfoInput>;
  /** Coupon codes to apply to the purchase */
  couponCodes: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** Gift card codes to apply to the purchase */
  giftCardCodes: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** The products to purchase */
  products: Array<ProductPurchaseInput>;
  /** Whether to use account credit for the purchase */
  useCredit: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of PurchaseCreate. */
export type PurchaseCreatePayload = {
  __typename?: 'PurchaseCreatePayload';
  errors: Maybe<Array<PurchaseCreateErrorsUnion>>;
  result: Maybe<Api_Purchase>;
};

export type PurchasePreviewErrorsUnion = ValidationError;

export type PurchasePreviewInput = {
  /** Coupon codes to apply to the purchase */
  couponCodes: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** Gift card codes to apply to the purchase */
  giftCardCodes: InputMaybe<Array<Scalars['SanitizedString']['input']>>;
  /** The products to purchase */
  products: Array<ProductPurchaseInput>;
  /** Whether to use account credit for the purchase */
  useCredit: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of PurchasePreview. */
export type PurchasePreviewPayload = {
  __typename?: 'PurchasePreviewPayload';
  errors: Maybe<Array<PurchasePreviewErrorsUnion>>;
  result: Maybe<Api_Purchase>;
};

export type PurchaseProductCoachingSessionReschedulePreviewErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | ValidationError;

export type PurchaseProductCoachingSessionReschedulePreviewInput = {
  id: Scalars['UUID']['input'];
  /** The date and time to schedule the session */
  scheduledAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of PurchaseProductCoachingSessionReschedulePreview. */
export type PurchaseProductCoachingSessionReschedulePreviewPayload = {
  __typename?: 'PurchaseProductCoachingSessionReschedulePreviewPayload';
  errors: Maybe<Array<PurchaseProductCoachingSessionReschedulePreviewErrorsUnion>>;
  result: Maybe<Api_PurchaseReschedule>;
};

export type PurchaseProductRefundErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type PurchaseProductRefundInput = {
  /** The amount to refund */
  amount: InputMaybe<Scalars['Float']['input']>;
  /** Whether to cancel the group supporter subscription renewal */
  cancelGroupSupporter: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to expire the group supporter subscription, removing access instantly */
  expireGroupSupporter: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the product purchase to refund */
  id: Scalars['UUID']['input'];
  /** The IDs of the sessions to cancel */
  sessionIdsToCancel: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Autogenerated return type of PurchaseProductRefund. */
export type PurchaseProductRefundPayload = {
  __typename?: 'PurchaseProductRefundPayload';
  errors: Maybe<Array<PurchaseProductRefundErrorsUnion>>;
  result: Maybe<Api_PurchasedProduct>;
};

export const enum PurchasedProductCoachingSessionSortEnum {
  CompletedAt = 'COMPLETED_AT',
  CreatedAt = 'CREATED_AT',
  ExpiresAt = 'EXPIRES_AT',
  Position = 'POSITION',
  ScheduledAt = 'SCHEDULED_AT',
  State = 'STATE',
  UpdatedAt = 'UPDATED_AT'
}

export type PurchasedProductCoachingSessionSortOption = {
  direction: SortDirection;
  on: PurchasedProductCoachingSessionSortEnum;
};

export const enum PurchasedProductCoachingSortEnum {
  CreatedAt = 'CREATED_AT',
  DurationSeconds = 'DURATION_SECONDS',
  State = 'STATE'
}

export type PurchasedProductCoachingSortOption = {
  direction: SortDirection;
  on: PurchasedProductCoachingSortEnum;
};

export const enum PurchasedProductEventSortEnum {
  CreatedAt = 'CREATED_AT',
  ScheduledAt = 'SCHEDULED_AT'
}

export type PurchasedProductEventSortOption = {
  direction: SortDirection;
  on: PurchasedProductEventSortEnum;
};

export const enum PurchasedProductGuideSortEnum {
  CreatedAt = 'CREATED_AT',
  MyGuides = 'MY_GUIDES'
}

export type PurchasedProductGuideSortOption = {
  direction: SortDirection;
  on: PurchasedProductGuideSortEnum;
};

export const enum PurchasedProductGuideStateEnum {
  /** The purchased product guide is completed */
  Completed = 'COMPLETED',
  /** The purchased product guide is in progress */
  InProgress = 'IN_PROGRESS',
  /** The purchased product guide is new */
  New = 'NEW'
}

export const enum PurchasedProductRoleEnum {
  /** The user is the buyer of the purchased product */
  Buyer = 'BUYER',
  /** The user is the seller of the purchased product */
  Seller = 'SELLER'
}

export const enum PurchasedProductSessionPolicyReasonEnum {
  /** The purchased product is past the deadline */
  DeadLine = 'DEAD_LINE',
  /** The purchased product is in an invalid state */
  InvalidState = 'INVALID_STATE'
}

export const enum PurchasedProductSortEnum {
  CreatedAt = 'CREATED_AT',
  LastPurchasedAt = 'LAST_PURCHASED_AT',
  Price = 'PRICE',
  State = 'STATE'
}

export type PurchasedProductSortOption = {
  direction: SortDirection;
  on: PurchasedProductSortEnum;
};

export const enum PurchasedProductStateEnum {
  /** The purchased product is active */
  Active = 'ACTIVE',
  /** The purchased product is completed */
  Completed = 'COMPLETED',
  /** The payment is fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The payment is partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The purchased product is pending */
  Pending = 'PENDING',
  /** The payment is void */
  Void = 'VOID'
}

export const enum PurchasedProductSubscriptionSortEnum {
  CreatedAt = 'CREATED_AT',
  Position = 'POSITION',
  Price = 'PRICE'
}

export type PurchasedProductSubscriptionSortOption = {
  direction: SortDirection;
  on: PurchasedProductSubscriptionSortEnum;
};

export type Query = {
  contestLeaderboard: Api_ContestLeaderboardConnection;
  contestSelf: Maybe<Api_ContestLeaderboard>;
};

export type QueryContestLeaderboardArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryContestSelfArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
};

export const enum ReactionEnum {
  Celebrate = 'CELEBRATE',
  Funny = 'FUNNY',
  Huh = 'HUH',
  Like = 'LIKE',
  Smart = 'SMART',
  ThisIsFine = 'THIS_IS_FINE',
  Unamused = 'UNAMUSED',
  Wow = 'WOW'
}

export type RecurlyAddressInput = {
  /** The country for the address */
  country: InputMaybe<Scalars['String']['input']>;
  /** The postal code for the address */
  postalCode: InputMaybe<Scalars['String']['input']>;
};

export type RecurlyBillingInfoInput = {
  /** The billing address for the purchase */
  address: InputMaybe<RecurlyAddressInput>;
  /** The payment gateway references to use for the transaction */
  paymentGatewayReferences: InputMaybe<Array<RecurlyPaymentGatewayReferenceInput>>;
  /** The 3DS secure token to use for the transaction */
  secureToken: InputMaybe<Scalars['String']['input']>;
  /** The token generated by the Recurly.js library */
  token: InputMaybe<Scalars['String']['input']>;
};

export type RecurlyPaymentGatewayReferenceInput = {
  /** The type of payment gateway reference */
  referenceType: Scalars['String']['input'];
  /** The token generated by Stripe.js */
  token: Scalars['String']['input'];
};

export type ReferralClickTrackErrorsUnion = NotFoundError | ValidationError;

export type ReferralClickTrackInput = {
  /** The identifier of the link that was clicked */
  identifier: InputMaybe<Scalars['String']['input']>;
  /** A session ID to track the click if the user is anonymous */
  sessionId: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReferralClickTrack. */
export type ReferralClickTrackPayload = {
  __typename?: 'ReferralClickTrackPayload';
  errors: Maybe<Array<ReferralClickTrackErrorsUnion>>;
  result: Maybe<Api_ReferralClick>;
};

export const enum ReferralStateEnum {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Trial = 'TRIAL'
}

export const enum ReferralTrackedPurchasePayoutEnum {
  /** The payout is pending */
  Pending = 'PENDING',
  /** The payout has been refunded */
  Refunded = 'REFUNDED',
  /** The payout has been paid */
  Settled = 'SETTLED'
}

export const enum ReferralTrackedPurchaseSortEnum {
  AllTimeRevenue = 'ALL_TIME_REVENUE',
  CreatedAt = 'CREATED_AT',
  MonthlyRevenue = 'MONTHLY_REVENUE',
  SignUpDate = 'SIGN_UP_DATE'
}

export type ReferralTrackedPurchaseSortOption = {
  direction: SortDirection;
  on: ReferralTrackedPurchaseSortEnum;
};

export type ReportErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReportInput = {
  feedback: InputMaybe<Scalars['SanitizedString']['input']>;
  reason: Scalars['String']['input'];
  recordId: Scalars['UUID']['input'];
  recordType: Scalars['SanitizedString']['input'];
};

/** Autogenerated return type of Report. */
export type ReportPayload = {
  __typename?: 'ReportPayload';
  errors: Maybe<Array<ReportErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export type SaleCreateErrorsUnion = NotAuthenticatedError | NotFoundError | ValidationError;

export type SaleCreateInput = {
  sale: SaleCreateNewInput;
};

export type SaleCreateNewInput = {
  discountType: CouponDiscountEnum;
  discountValue: Scalars['Float']['input'];
  /** The duration the coupon is valid for */
  duration: InputMaybe<CouponDurationEnum>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  limits: InputMaybe<Array<CouponLimitsInputInput>>;
  maxDiscountValue: InputMaybe<Scalars['Float']['input']>;
  maxRedemptions: InputMaybe<Scalars['Int']['input']>;
  maxRedemptionsPerAccount: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['SanitizedString']['input'];
  products: InputMaybe<Array<CouponProductProductInput>>;
  supportedProductTypes: InputMaybe<Array<CouponSupportedProductEnum>>;
  /** The duration the coupon is valid for in months */
  temporalAmount: InputMaybe<Scalars['Int']['input']>;
  validFrom: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of SaleCreate. */
export type SaleCreatePayload = {
  __typename?: 'SaleCreatePayload';
  errors: Maybe<Array<SaleCreateErrorsUnion>>;
  result: Maybe<Api_Sale>;
};

export type SaleDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type SaleDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of SaleDelete. */
export type SaleDeletePayload = {
  __typename?: 'SaleDeletePayload';
  errors: Maybe<Array<SaleDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export const enum SaleSortEnum {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  ExpiresAt = 'EXPIRES_AT',
  MaxRedemptions = 'MAX_REDEMPTIONS',
  Name = 'NAME',
  RedeemedCount = 'REDEEMED_COUNT',
  ValidFrom = 'VALID_FROM'
}

export type SaleSortOption = {
  direction: SortDirection;
  on: SaleSortEnum;
};

export type SaleUpdateErrorsUnion = NotAuthenticatedError | NotFoundError | ValidationError;

export type SaleUpdateExistingInput = {
  discountType: CouponDiscountEnum;
  discountValue: Scalars['Float']['input'];
  /** The duration the coupon is valid for */
  duration: InputMaybe<CouponDurationEnum>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  limits: InputMaybe<Array<CouponLimitsInputInput>>;
  maxDiscountValue: InputMaybe<Scalars['Float']['input']>;
  maxRedemptions: InputMaybe<Scalars['Int']['input']>;
  maxRedemptionsPerAccount: InputMaybe<Scalars['Int']['input']>;
  name: InputMaybe<Scalars['SanitizedString']['input']>;
  products: InputMaybe<Array<CouponProductProductInput>>;
  supportedProductTypes: InputMaybe<Array<CouponSupportedProductEnum>>;
  /** The duration the coupon is valid for in months */
  temporalAmount: InputMaybe<Scalars['Int']['input']>;
  validFrom: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type SaleUpdateInput = {
  id: Scalars['UUID']['input'];
  sale: SaleUpdateExistingInput;
};

/** Autogenerated return type of SaleUpdate. */
export type SaleUpdatePayload = {
  __typename?: 'SaleUpdatePayload';
  errors: Maybe<Array<SaleUpdateErrorsUnion>>;
  result: Maybe<Api_Sale>;
};

export const enum SchedulerEnum {
  /** Manual scheduling */
  Manual = 'MANUAL',
  /** Metafy's scheduler */
  Metafy = 'METAFY'
}

export const enum ScopeEnum {
  /** Access to view the community of the authenticated user */
  Community = 'community',
  /** Access to view the products of the authenticated user */
  Products = 'products',
  /** Access to the account information of the authenticated user */
  Profile = 'profile',
  /** Access to view the purchases of the authenticated user */
  Purchases = 'purchases'
}

export const enum SentimentEnum {
  /** Negative sentiment */
  Negative = 'NEGATIVE',
  /** Neutral sentiment */
  Neutral = 'NEUTRAL',
  /** Positive sentiment */
  Positive = 'POSITIVE'
}

export type ShortLinkCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type ShortLinkCreateInput = {
  key: Scalars['SanitizedString']['input'];
  url: Scalars['SanitizedString']['input'];
};

/** Autogenerated return type of ShortLinkCreate. */
export type ShortLinkCreatePayload = {
  __typename?: 'ShortLinkCreatePayload';
  errors: Maybe<Array<ShortLinkCreateErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export type ShortLinkDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type ShortLinkDeleteInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of ShortLinkDelete. */
export type ShortLinkDeletePayload = {
  __typename?: 'ShortLinkDeletePayload';
  errors: Maybe<Array<ShortLinkDeleteErrorsUnion>>;
  result: Maybe<Api_Account>;
};

export const enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SubscriptionCancelErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type SubscriptionCancelInput = {
  feedback: InputMaybe<Scalars['SanitizedString']['input']>;
  id: Scalars['UUID']['input'];
  reason: InputMaybe<Scalars['SanitizedString']['input']>;
};

/** Autogenerated return type of SubscriptionCancel. */
export type SubscriptionCancelPayload = {
  __typename?: 'SubscriptionCancelPayload';
  errors: Maybe<Array<SubscriptionCancelErrorsUnion>>;
  result: Maybe<Api_PurchasedProductSubscription>;
};

export type SubscriptionCancelationFeedbackErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type SubscriptionCancelationFeedbackInput = {
  feedback: InputMaybe<Scalars['SanitizedString']['input']>;
  id: Scalars['UUID']['input'];
  reason: InputMaybe<Scalars['SanitizedString']['input']>;
};

/** Autogenerated return type of SubscriptionCancelationFeedback. */
export type SubscriptionCancelationFeedbackPayload = {
  __typename?: 'SubscriptionCancelationFeedbackPayload';
  errors: Maybe<Array<SubscriptionCancelationFeedbackErrorsUnion>>;
  result: Maybe<Api_PurchasedProductSubscription>;
};

export type SubscriptionDowngradeCancelErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type SubscriptionDowngradeCancelInput = {
  /** The ID of current subscription */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of SubscriptionDowngradeCancel. */
export type SubscriptionDowngradeCancelPayload = {
  __typename?: 'SubscriptionDowngradeCancelPayload';
  errors: Maybe<Array<SubscriptionDowngradeCancelErrorsUnion>>;
  result: Maybe<Api_PurchasedProductSubscription>;
};

export type SubscriptionDowngradeTierErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type SubscriptionDowngradeTierInput = {
  /** The ID of the new tier */
  groupTierId: Scalars['UUID']['input'];
  /** The ID of current subscription */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of SubscriptionDowngradeTier. */
export type SubscriptionDowngradeTierPayload = {
  __typename?: 'SubscriptionDowngradeTierPayload';
  errors: Maybe<Array<SubscriptionDowngradeTierErrorsUnion>>;
  result: Maybe<Api_PurchasedProductSubscription>;
};

export type SubscriptionReactivateErrorsUnion =
  | NotAuthenticatedError
  | NotAuthorizedError
  | NotFoundError
  | ValidationError;

export type SubscriptionReactivateInput = {
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of SubscriptionReactivate. */
export type SubscriptionReactivatePayload = {
  __typename?: 'SubscriptionReactivatePayload';
  errors: Maybe<Array<SubscriptionReactivateErrorsUnion>>;
  result: Maybe<Api_PurchasedProductSubscription>;
};

export const enum SubscriptionStateEnum {
  /** The subscription is active */
  Active = 'ACTIVE',
  /** The subscription has been canceled */
  Canceled = 'CANCELED',
  /** The subscription has expired */
  Expired = 'EXPIRED',
  /** The subscription is in grace period */
  GracePeriod = 'GRACE_PERIOD',
  /** The subscription is in trial */
  Trial = 'TRIAL'
}

export type TestimonialCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type TestimonialCreateInput = {
  productId: Scalars['UUID']['input'];
  testimonial: TestimonialNewInput;
};

/** Autogenerated return type of TestimonialCreate. */
export type TestimonialCreatePayload = {
  __typename?: 'TestimonialCreatePayload';
  errors: Maybe<Array<TestimonialCreateErrorsUnion>>;
  result: Maybe<Api_Testimonial>;
};

export type TestimonialEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type TestimonialEditInput = {
  /** The ID of the Testimonial you wish to edit */
  id: Scalars['UUID']['input'];
  testimonial: TestimonialUpdateInput;
};

/** Autogenerated return type of TestimonialEdit. */
export type TestimonialEditPayload = {
  __typename?: 'TestimonialEditPayload';
  errors: Maybe<Array<TestimonialEditErrorsUnion>>;
  result: Maybe<Api_Testimonial>;
};

export const enum TestimonialEnum {
  /** Video testimonial */
  Video = 'VIDEO',
  /** Written testimonial */
  Written = 'WRITTEN'
}

export const enum TestimonialImpressionEnum {
  DidntLearn = 'DIDNT_LEARN',
  DidntLikeIt = 'DIDNT_LIKE_IT',
  DidntShow = 'DIDNT_SHOW',
  Entertaining = 'ENTERTAINING',
  GoalOrientated = 'GOAL_ORIENTATED',
  GreatListener = 'GREAT_LISTENER',
  HighlyPrepared = 'HIGHLY_PREPARED',
  Personal = 'PERSONAL',
  SomethingElse = 'SOMETHING_ELSE',
  TrueMotivator = 'TRUE_MOTIVATOR',
  Visionary = 'VISIONARY',
  WasLate = 'WAS_LATE',
  WasRude = 'WAS_RUDE'
}

export type TestimonialNewInput = {
  feedback: Scalars['SanitizedString']['input'];
  impression: InputMaybe<TestimonialImpressionEnum>;
  sentiment: TestimonialSentimentEnum;
};

export type TestimonialRequestDeleteErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export type TestimonialRequestDeleteInput = {
  /** The ID of the Testimonial Request that you want to remove */
  id: Scalars['UUID']['input'];
};

/** Autogenerated return type of TestimonialRequestDelete. */
export type TestimonialRequestDeletePayload = {
  __typename?: 'TestimonialRequestDeletePayload';
  errors: Maybe<Array<TestimonialRequestDeleteErrorsUnion>>;
  result: Maybe<Scalars['String']['output']>;
};

export const enum TestimonialSentimentEnum {
  Bad = 'BAD',
  Decent = 'DECENT',
  Fantastic = 'FANTASTIC'
}

export const enum TestimonialSortEnum {
  CreatedAt = 'CREATED_AT',
  FeaturedPosition = 'FEATURED_POSITION'
}

export type TestimonialSortOption = {
  direction: SortDirection;
  on: TestimonialSortEnum;
};

export type TestimonialUpdateInput = {
  coachReviewed: InputMaybe<Scalars['Boolean']['input']>;
  dismissedModal: InputMaybe<Scalars['Boolean']['input']>;
  featuredPosition: InputMaybe<Scalars['Int']['input']>;
};

/** Payment method requires 3-D Secure authorization */
export type ThreeDSecureError = Error & {
  __typename?: 'ThreeDSecureError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
  /** Token required to initiate the 3-D Secure flow */
  token: Scalars['String']['output'];
};

export const enum TipSourceEnum {
  /** Articles */
  Articles = 'ARTICLES',
  /** Chat message */
  ChatMessage = 'CHAT_MESSAGE',
  /** Checkout */
  Checkout = 'CHECKOUT',
  /** Coach profile */
  CoachProfile = 'COACH_PROFILE',
  /** Dashboard */
  Dashboard = 'DASHBOARD',
  /** Event */
  Event = 'EVENT',
  /** Group page */
  GroupPage = 'GROUP_PAGE',
  /** Replay review editor */
  ReplayReviewEditor = 'REPLAY_REVIEW_EDITOR',
  /** Replay review summary modal */
  ReplayReviewSummaryModal = 'REPLAY_REVIEW_SUMMARY_MODAL',
  /** Session details */
  SessionDetails = 'SESSION_DETAILS',
  /** Session summaries page */
  SessionSummariesPage = 'SESSION_SUMMARIES_PAGE',
  /** Session summaries page card */
  SessionSummariesPageCard = 'SESSION_SUMMARIES_PAGE_CARD',
  /** Session summary received modal */
  SessionSummaryReceivedModal = 'SESSION_SUMMARY_RECEIVED_MODAL',
  /** Unknown source */
  Unknown = 'UNKNOWN'
}

export const enum TouchpointEnum {
  /** Event */
  Event = 'EVENT',
  /** Group */
  Group = 'GROUP',
  /** Guide */
  Guide = 'GUIDE',
  /** Purchased post */
  Post = 'POST',
  /** Session */
  Session = 'SESSION',
  /** Unknown touchpoint */
  Unknown = 'UNKNOWN'
}

export type TwitchEditErrorsUnion = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ValidationError;

export type TwitchEditInput = {
  discounts: ConnectionDiscountInput;
};

/** Autogenerated return type of TwitchEdit. */
export type TwitchEditPayload = {
  __typename?: 'TwitchEditPayload';
  errors: Maybe<Array<TwitchEditErrorsUnion>>;
  result: Maybe<Api_Twitch>;
};

export const enum UnifiedTagRecordSortEnum {
  CreatedAt = 'CREATED_AT'
}

export type UnifiedTagRecordSortOption = {
  direction: SortDirection;
  on: UnifiedTagRecordSortEnum;
};

export type UploadAssetInput = {
  /** Used when uploading an image */
  id: InputMaybe<Scalars['String']['input']>;
  /** Used when uploading an image */
  metadata: InputMaybe<UploadMetadataInput>;
  /** Used when uploading a video */
  muxAssetId: InputMaybe<Scalars['UUID']['input']>;
  /** Used when uploading an image */
  storage: InputMaybe<UploadBucketEnum>;
};

export const enum UploadBucketEnum {
  /** Cache bucket */
  Cache = 'CACHE',
  /** Store bucket */
  Store = 'STORE'
}

export type UploadMetadataInput = {
  creation_id: InputMaybe<Scalars['UUID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  mime_type: InputMaybe<Scalars['String']['input']>;
  size: InputMaybe<Scalars['Int']['input']>;
};

/** The mutation failed validation. This is usually because the input provided was invalid in some way, such as a missing required field or an invalid value for a field. There may be multiple of this error, one for each failed validation. */
export type ValidationError = Error & {
  __typename?: 'ValidationError';
  /** The attribute that relates to the error */
  attribute: Maybe<Scalars['String']['output']>;
  /** The error code. */
  code: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Any metadata of the error */
  metadata: Maybe<Scalars['JSON']['output']>;
};

export type WalletPayoutRequestCreateErrorsUnion = NotAuthenticatedError | NotAuthorizedError | ValidationError;

export type WalletPayoutRequestCreateInput = {
  /** The amount to request a payout for */
  amount: Scalars['Float']['input'];
};

/** Autogenerated return type of WalletPayoutRequestCreate. */
export type WalletPayoutRequestCreatePayload = {
  __typename?: 'WalletPayoutRequestCreatePayload';
  errors: Maybe<Array<WalletPayoutRequestCreateErrorsUnion>>;
  result: Maybe<Api_WalletPayoutRequest>;
};

export const enum WalletPayoutRequestStateEnum {
  /** The payout request is pending */
  Pending = 'PENDING',
  /** The payout request is rejected */
  Rejected = 'REJECTED',
  /** The payout request is settled */
  Settled = 'SETTLED',
  /** The payout request is void */
  Void = 'VOID'
}

export type WalletTransactionRecordUnion =
  | Api_GiftCard
  | Api_Order
  | Api_OrderPayout
  | Api_ProductGuideAuthor
  | Api_ReferralTrackedPurchasePayout
  | Api_Subscription
  | Api_WalletPayoutRequest
  | Api_WalletTransaction;

export const enum WalletTransactionSortEnum {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT'
}

export type WalletTransactionSortOption = {
  direction: SortDirection;
  on: WalletTransactionSortEnum;
};

export const enum WalletTransactionStateEnum {
  /** The balance log is fully refunded */
  FullyRefunded = 'FULLY_REFUNDED',
  /** The balance log is partially refunded */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** The balance log is pending */
  Pending = 'PENDING',
  /** The balance log is settled */
  Settled = 'SETTLED',
  /** The balance log is void */
  Void = 'VOID'
}

export type WithCoachingQuestion = {
  id: Scalars['UUID']['output'];
  question: Scalars['String']['output'];
};

export type WithCouponBase = {
  /** List of accounts this coupon can be redeemed against */
  accounts: Array<Api_CouponAccount>;
  /** The type of discount */
  discountType: CouponDiscountEnum;
  /** The value of the discount */
  discountValue: Scalars['Float']['output'];
  /** The duration of the coupon for group_supporter subscriptions */
  duration: Maybe<CouponDurationEnum>;
  /** Whether the coupon is enabled */
  enabled: Scalars['Boolean']['output'];
  /** The expiry date of the coupon */
  expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** List of games this coupon can be redeemed against */
  games: Array<Api_CouponGame>;
  /** Whether the coupon is global */
  global: Scalars['Boolean']['output'];
  /** The ID of the coupon */
  id: Scalars['UUID']['output'];
  /** The limits of the coupon */
  limits: Api_CouponLimitConnection;
  /** The maximum value of the discount */
  maxDiscountValue: Maybe<Scalars['Float']['output']>;
  /** The maximum number of redemptions */
  maxRedemptions: Maybe<Scalars['Int']['output']>;
  /**
   * The maximum number of redemptions per account
   * @deprecated Use limits.max_redemptions_per_account instead
   */
  maxRedemptionsPerAccount: Maybe<Scalars['Int']['output']>;
  /** The name of the coupon */
  name: Maybe<Scalars['SanitizedString']['output']>;
  /** List of products this coupon can be redeemed against */
  products: Array<Api_CouponProduct>;
  /** The number of times the coupon has been redeemed */
  redeemedCount: Scalars['Int']['output'];
  /** Whether the coupon or sale is stackable with other coupons or sales */
  stackable: Scalars['Boolean']['output'];
  /** List of product types this coupon can be redeemed against */
  supportedProductTypes: Array<ProductEnum>;
  /** The date the coupon becomes valid */
  validFrom: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type WithCouponBaseLimitsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
};

export type WithDiscounts = {
  eventDiscountType: CouponDiscountEnum;
  eventDiscountValue: Scalars['Int']['output'];
  groupTierDiscountType: CouponDiscountEnum;
  groupTierDiscountValue: Scalars['Int']['output'];
  guideDiscountType: CouponDiscountEnum;
  guideDiscountValue: Scalars['Int']['output'];
  sessionDiscountType: CouponDiscountEnum;
  sessionDiscountValue: Scalars['Int']['output'];
};

export type WithProduct = {
  cover: Maybe<Api_Image>;
  /** The currency of the product (USD, EUR, etc.) */
  currency: Maybe<Scalars['String']['output']>;
  /** The description of the product */
  description: Maybe<Scalars['String']['output']>;
  /** Whether the product is enabled for purchase */
  enabled: Scalars['Boolean']['output'];
  /** Whether the product is global or offered by an account */
  global: Scalars['Boolean']['output'];
  /** The ID of the product */
  id: Scalars['UUID']['output'];
  /** The name of the product */
  name: Scalars['String']['output'];
  /** The position of the product in the account's product list */
  position: Maybe<Scalars['Int']['output']>;
  /** The type of the product */
  productType: ProductEnum;
  /** The stock keeping unit of the product */
  sku: Maybe<Scalars['String']['output']>;
};

export type WithProductAddon = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  price: Maybe<Scalars['Float']['output']>;
};

/** An coaching product on Metafy */
export type WithProductCoaching = {
  durationSeconds: Scalars['Int']['output'];
  game: Maybe<Api_Game>;
  id: Scalars['UUID']['output'];
  scheduler: SchedulerEnum;
  sessionCount: Scalars['Int']['output'];
};

/** An session for a coaching product on Metafy */
export type WithProductCoachingSession = {
  /** The description of the session */
  description: Maybe<Scalars['String']['output']>;
  /** The ID of the session */
  id: Scalars['UUID']['output'];
  /** The name of the session */
  name: Scalars['String']['output'];
  /** The position of the session */
  position: Scalars['Int']['output'];
};

export type WithProductPolicy = {
  /** The percent amount charged to cancel or reschedule */
  amount: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  policyType: CancelationPolicyPolicyEnum;
  timeFrame: Scalars['Int']['output'];
  timeUnit: CancelationPolicyTimeUnitEnum;
};

export type WithTimestamps = {
  /** The timestamp of when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The timestamp of when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};
